<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <HeaderPadrao class="mb-2" icon="fa fa-shopping-cart" titulo="VENDAS DE PRODUTOS">
        <template #subtitulo>
          
          <i class="fa fa-tag mr-1 text-info"></i>
          Pedido: <strong class="text-white">{{ venda.N_VENDA || 'Novo Pedido' }}</strong>
          <span class="mx-2">•</span>
          <i class="fa fa-user mr-1 text-info"></i>
          Cliente: <strong class="text-white">{{ cliente.CODIGO }} - {{ cliente.NOME }}</strong>
          
        </template>

        <template #acoes>
          <b-button v-b-modal="'modal-impostos'" variant="link" class="btn-glass btn-glass-info">
            <i class="fa fa-money mr-1"></i> Impostos
          </b-button>

          <b-button v-if="habilitarBotaoFinalizar" variant="link" class="btn-glass btn-glass-success" @click="finalizarVenda()">
            <i class="fa fa-check mr-1"></i> FINALIZAR <small>F11</small>
          </b-button>

          <b-button v-if="habilitaBotaoGravar" variant="link" class="btn-glass btn-glass-primary" @click="gravarPedidoEVoltar()">
            <i class="fa fa-save mr-1"></i> GRAVAR <small>F10</small>
          </b-button>

          <b-button v-if="habilitarBotaoReabrir" variant="link" class="btn-glass btn-glass-warning" @click="abrirModalReabrir()">
            <i class="fa fa-unlock-alt mr-1"></i> LIBERAR DÉBITOS
          </b-button>

          <b-button
            v-if="mostrarBotaoBoletoVenda"
            variant="link"
            class="btn-glass btn-glass-info"
            :disabled="!habilitarBotaoBoletoVenda"
            @click="abrirBoletoDaVenda()"
          >
            <i class="fa mr-1" :class="iconeBotaoBoletoVenda"></i> {{ textoBotaoBoletoVenda }}
          </b-button>

          <b-button
            v-if="mostrarBotaoNotaFiscalVenda"
            variant="link"
            class="btn-glass btn-glass-primary"
            :disabled="!habilitarBotaoNotaFiscalVenda"
            @click="abrirNotaFiscalDaVenda()"
          >
            <i class="fa mr-1" :class="iconeBotaoNotaFiscalVenda"></i> {{ textoBotaoNotaFiscalVenda }}
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm" @click.stop.prevent="voltar()">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </HeaderPadrao>
 


      <!-- Main Summary Bar -->
      <b-row class="mb-4 px-1">
        <b-col md="2">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-info" style="border-top-width: 3px !important;">
            <small class="modal-label-premium d-block text-muted">ICMS Total</small>
            <h4 class="mb-0 font-weight-bold text-dark">{{totalICMS.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h4>
          </div>
        </b-col>
        <b-col md="2">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-primary" style="border-top-width: 3px !important;">
            <small class="modal-label-premium d-block text-muted">Desconto</small>
            <h5 class="mb-0 font-weight-bold text-danger">{{totalDesconto.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h5>
          </div>
        </b-col>
        <b-col md="2">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-warning" style="border-top-width: 3px !important;">
            <small class="modal-label-premium d-block text-muted">Total Volumes</small>
            <h4 class="mb-0 font-weight-bold text-dark">{{totalPecas}}</h4>
          </div>
        </b-col>
        <b-col md="2">
          <div class="stat-item bg-white p-3 rounded shadow-sm text-center transition-hover h-100 border-top border-secondary" style="border-top-width: 3px !important;">
            <small class="modal-label-premium d-block text-muted">Quantidade</small>
            <h4 class="mb-0 font-weight-bold text-dark">{{totalQuant.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})}}</h4>
          </div>
        </b-col>
        <b-col md="4">
          <div class="stat-item bg-primary p-3 rounded shadow-sm text-center transition-hover h-100 text-white shadow-lg border-0" style="background: linear-gradient(135deg, #20a8d8 0%, #1985ac 100%) !important;">
            <small class="modal-label-premium d-block text-white opacity-75">VALOR TOTAL DO PEDIDO</small>
            <h3 class="mb-0 font-weight-bold letter-spacing-1">{{totalVenda.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h3>
          </div>
        </b-col>
      </b-row>
        <b-row class="p-0 align-items-stretch ml-2 mr-2">
          <b-col sm="7" class="p-0 d-flex pr-2">
            <b-card class="flex-fill h-100 border-0 shadow-sm" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
              <template #header>
                <div class="d-flex align-items-center justify-content-between w-100">
                  <div class="d-flex align-items-center">
                    <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                      <i class="fa fa-user-circle"></i>
                    </div>
                    <div>
                      <h6 class="mb-0 font-weight-bold">Dados da Identificação</h6>
                      <small class="text-muted">Informações básicas do pedido e cliente</small>
                    </div>
                  </div>
                  <div style="min-width: 120px">
                    <b-badge :variant="colorirSituacao(venda.SITUACAO)" pill class="d-block py-2 font-weight-bold">
                        {{traduzirSituacao(venda)}}
                    </b-badge>
                  </div>
                </div>
              </template>

              <b-row class="mb-3">
                <b-col sm="3">
                  <label class="modal-label-premium">Nº do Pedido</label>
                  <b-form-input 
                    type="text" 
                    id="edID" 
                    class="rounded-pill shadow-xs"
                    :disabled="controles.fechada || parametros.OP_PEDIDO_NUMERO_AUTOMATICO !== '0'" 
                    :placeholder="parametros.OP_PEDIDO_NUMERO_AUTOMATICO === '0' ? 'Número' : 'Automático'" 
                    v-model="venda.N_VENDA"
                  />
                </b-col>
                <b-col sm="5">
                  <label class="modal-label-premium">Tipo de Movimentação</label>
                  <b-input-group>
                    <b-form-input 
                      id="edTIPO_MOVIMENTACAO_ID" 
                      class="rounded-pill-left shadow-xs bg-light text-dark"
                      :disabled="true"
                      :state="valTIPO_MOVIMENTACAO_ID"
                      :value="tipoMovimentacaoSelecionadoTexto"/>
                    <b-input-group-append>
                      <b-button 
                        :disabled="controles.fechada"
                        variant="soft-primary"
                        class="rounded-pill-right shadow-xs px-3"
                        @click="abrirModalTipoMovimentacao()"
                      >
                        <i class="fa fa-list"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
                <b-col sm="4">
                  <label class="modal-label-premium">Data da Venda</label>
                  <cec-input-data
                    v-model="venda.DT_SAIDA"
                    :disabled="controles.fechada || !permiteAlterarDataVenda"
                    class="shadow-xs"
                    input-class="rounded-pill"
                    :state="!!venda.DT_SAIDA"
                  />
                </b-col>
              </b-row>
              
              <b-row class="mb-3">
                <b-col sm="6">
                    <cliente-pesquisa 
                        @retornaId="venda.COD_CLI = $event"
                        :idInicial="venda.COD_CLI"
                        :classe-required="true"
                        :desabilitarInput="controles.fechada"
                        idModal="modalCliente"
                        :labelVermelho="controles.clienteBloqueado"
                        :label="controles.situacaoCliente"
                        :exibirBloqueado="controles.clienteBloqueado"
                        id="edCOD_CLI"
                        ref="edCOD_CLI"
                        place="Informe o Cliente"
                        labelBotao=""
                        :arredondado="true"
                    />
                </b-col>
              
                <b-col sm="2">
                   <label class="modal-label-premium">Limite de Crédito</label>
                   <vue-autonumeric  
                        v-model="limiteCredito" 
                        :disabled="true"
                        :options="{ digitGroupSeparator: '.', decimalCharacter: ',', roundingMethod: 'U', minimumValue: '-10000000000000' }"
                        class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold"
                   />
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium ">Débitos em Aberto</label>
                  <b-form-input 
                    type="text" 
                    :disabled="true" 
                    v-model="cliente.NOTAS_EM_ABERTO"
                    class="rounded-pill shadow-xs bg-light text-right text-danger font-weight-bold"
                  />
                </b-col>
                <b-col sm="2">
                  <label class="modal-label-premium">Config. ICMS</label>
                  <b-form-input 
                    type="text" 
                    :disabled="true" 
                    v-model="textoImposto"
                    class="rounded-pill shadow-xs bg-light font-weight-bold"
                  />
                </b-col>
              </b-row>

              <b-row class="mb-3">
                <b-col sm="6">
                  <label class="modal-label-premium">Vendedor Responsável</label>
                  <vendedor-dropdown
                    v-model="venda.COD_VENDEDOR"
                    :disabled="controles.fechada"
                    :placeholder="'Pesquise o vendedor...'"
                    :state="!!venda.COD_VENDEDOR"
                    input-class="rounded-pill shadow-xs"
                    
                  />
                </b-col>
                <b-col sm="3">
                   <label class="modal-label-premium">Tipo Contato</label>
                    <cec-select-search
                      v-model="venda.PAG2"
                      :options="tipoContatoOptions"
                      placeholder="Escolha..."
                      :state="!!venda.PAG2"
                      input-class="rounded-pill shadow-xs"/>
                </b-col>
                <b-col sm="3">
                  <label class="modal-label-premium">Nº Entrega</label>
                  <b-form-input  
                    type="text" 
                    id="nentrega" 
                    reg="nentrega"
                    v-model="venda.NENTREGA"
                    :disabled="controles.fechada"
                    placeholder="Ref. Entrega"
                    class="rounded-pill shadow-xs"/>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <label class="modal-label-premium">Conferente</label>
                  <funcionario-dropdown
                    v-model="venda.COD_CONFERENTE"
                    :disabled="controles.fechada"
                    :state="valCOD_CONFERENTE"
                    :placeholder="'Selecione o conferente...'"
                    input-class="rounded-pill shadow-xs"
                  />
                </b-col>
                <b-col sm="6">
                  <label class="modal-label-premium">Motorista</label>
                  <funcionario-dropdown
                    v-model="venda.COD_MOTORISTA"
                    :disabled="controles.fechada"
                    :state="valCOD_MOTORISTA"
                    :placeholder="'Selecione o motorista...'"
                    input-class="rounded-pill shadow-xs"
                  />
                </b-col>
              </b-row>
            </b-card>
          </b-col>

          <b-col sm="5" class="p-0 d-flex pl-2">
            <b-card class="flex-fill h-100 border-0 shadow-sm" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
                <template #header>
                    <div class="d-flex align-items-center">
                    <div class="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                        <i class="fa fa-credit-card"></i>
                    </div>
                    <div>
                        <h6 class="mb-0 font-weight-bold">Pagamento e Entrega</h6>
                        <small class="text-muted">Condições comerciais e prazos</small>
                    </div>
                    </div>
                </template>

                <b-row class="mb-3">
                  <b-col sm="7">
                     <label class="modal-label-premium">Forma de Pagamento Principal</label>
                     <b-form-select 
                        :disabled="controles.fechada" 
                        v-model="venda.OP_FORMA_PAGTO"
                        :state="valOP_FORMA_PAGTO"  
                        :options="tipoPagamento"
                        class="rounded-pill shadow-xs"
                     />
                  </b-col>
                  <b-col sm="5">
                     <label class="modal-label-premium">Data Entrega</label>
                     <cec-input-data
                        v-model="venda.DT_PREVISAO_ENTREGA"
                        :disabled="controles.fechada"
                        :state="valDT_PREVISAO_ENTREGA"
                        class="shadow-xs"
                        input-class="rounded-pill"
                     />
                  </b-col>
                </b-row>
                
                <b-collapse :visible="venda.OP_FORMA_PAGTO === 'P'">
                    <b-row class="mb-3">
                      <b-col sm="6">
                         <label class="modal-label-premium">Primeira Parcela em</label>
                         <cec-input-data
                            v-model="venda.DT_INICIAR_PAGAMENTO"
                            :disabled="controles.fechada"
                            :state="valDT_INICIAR_PAGAMENTO"
                            class="shadow-xs"
                            input-class="rounded-pill"
                         />
                      </b-col>
                      <b-col sm="3">
                         <label class="modal-label-premium">Dias</label>
                         <b-form-input  
                            v-model="diasIniciarPagamento" 
                            type="number"
                            :disabled="controles.fechada"  
                            :state="valDiasIniciarPagamento"
                            class="rounded-pill shadow-xs text-center"
                         />
                      </b-col>
                      <b-col sm="3">
                         <label class="modal-label-premium">Vezes</label>
                         <b-form-select 
                            v-model="venda.NR_PARCELAS"
                            :disabled="controles.fechada" 
                            :state="valNR_PARCELAS"
                            :options="parcelasVezes"
                            class="rounded-pill shadow-xs"
                         />
                      </b-col>
                    </b-row>

                    <b-row class="mb-3">
                      <b-col md="12">
                          <b-overlay :show="controles.botaoGerarDocumento.busy" rounded="pill" opacity="0.6">
                            <label class="modal-label-premium">Intervalo entre Parcelas (Dias)</label>
                            <b-input-group>
                                <b-form-select 
                                    :disabled="controles.fechada" 
                                    v-model="venda.PAG1"
                                    :state="valPAG1"
                                    :options="dias"
                                    class="rounded-pill-left shadow-xs"
                                />
                                <b-input-group-append>
                                    <b-button :disabled="controles.fechada" variant="info" class="rounded-pill-right shadow-xs px-3 font-weight-bold" @click="gerarParcelamento()">
                                        <i class="fa fa-refresh mr-1"></i> PARCELAR
                                    </b-button>
                                </b-input-group-append>                                    
                            </b-input-group>
                          </b-overlay>
                      </b-col>
                    </b-row>

                    <b-row class="mb-3" v-if="tabelaParcelamento.items.length > 0">
                        <b-col sm="12">
                            <div class="table-responsive rounded shadow-xs" style="max-height: 180px;">
                                <b-table 
                                    striped 
                                    hover 
                                    :items="tabelaParcelamento.items" 
                                    :fields="tabelaParcelamento.fields"
                                    show-empty
                                    empty-text="Sem parcelamento"
                                    small
                                    class="mb-0 table-finance"
                                />
                            </div>
                        </b-col>
                    </b-row>
                </b-collapse>

                <b-row>
                  <b-col sm="12">
                     <label class="modal-label-premium">Observações Gerais do Pedido</label>
                     <b-form-textarea
                        id="edOBSERVACOES"
                        v-model="venda.OBSERVACOES"
                        placeholder="Ex: Entrega após as 14h, cliente solicitou conferência cuidadosa..."
                        :disabled="controles.fechada"
                        rows="3"
                        class="rounded-pill-20 shadow-xs px-4 py-3"
                     />
                  </b-col>
                </b-row>
            </b-card>
          </b-col>
        </b-row>
       
        
          <!-- row produtos -->
          <b-row class="mb-3 mt-4 align-items-center px-3">
            <b-col>
              <h5 class="mb-0 font-weight-bold text-dark"><i class="fa fa-list-ul mr-2 text-primary"></i>Itens do Pedido</h5>
            </b-col>
            <b-col class="text-right">
              <b-button v-if="((!controles.fechada) && (!controles.clienteBloqueado) && (opPedido == null))"
                        variant="success" 
                        ref="btAdicionarItem"
                        pill
                        class="px-4 font-weight-bold shadow-sm"
                        @click="abrirModalItemNovo()" > 
                    <i class="fa fa-plus-circle mr-1"></i> ADICIONAR PRODUTO <small class="ml-1 opacity-75">(INSERT)</small>
              </b-button>
            </b-col>
          </b-row>

          <b-row class="px-3">
            <b-col sm="12">
              <div class="bg-white rounded shadow-sm overflow-hidden border">
                  <b-table 
                    hover 
                    show-empty
                    empty-text="Nenhum produto lançado neste pedido"
                    :dark="isDark"
                    small
                    select-mode="single"
                    @row-dblclicked="abrirModalItemEditar"
                    :items="tabelaItens.items" 
                    :fields="tabelaItens.fields"
                    class="mb-0 table-finance"
                    responsive
                  >
                    <template #cell(actions)="item">
                      <div class="text-center">
                        <b-button v-if="!controles.fechada"
                                  type="button"  
                                  @click.stop="abrirModaldeleteItem(item.item)" 
                                  size="sm" variant="soft-danger" pill 
                                  class="btn-action-pill">
                          <i class="fa fa-trash-o"></i>
                        </b-button>
                      </div>
                    </template>

                    <template #cell(VL_TOTAL)="data">
                      <span class="font-weight-bold text-primary">{{ data.value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                    </template>
                </b-table>
              </div>
            </b-col>
          </b-row>
          
      

      <!--/.row-->
    
    </div>
    
     <!--  -----------------------------------------------------------------------------------
                                          MODAL RECEBIMENTOS 
            ----------------------------------------------------------------------------------- -->
    <div>
     
        <b-modal ref="modal-impostos" 
            id="modal-impostos" 
            size="lg" 
            hide-header
            hide-footer
            body-class="p-0 overflow-hidden"
            content-class="border-0 shadow-lg"
            dialog-class="modal-xl-custom"
        >
            <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
                <div class="header-icon-wrapper-modal mr-3 bg-white-100">
                    <i class="fa fa-university text-info"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold text-white">Detalhamento de Impostos</h5>
                    <small class="text-white opacity-75">Resumo tributário estadual e federal do pedido</small>
                </div>
                <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-impostos')">
                    <i class="fa fa-times fa-lg"></i>
                </b-button>
            </div>

            <div class="p-4 bg-white">
                <div class="modal-section-title mb-3">
                    <i class="fa fa-map-marker mr-2 text-primary"></i> Tributos e Impostos Estaduais
                </div>
                <b-row class="mb-4">
                  <b-col sm="3">
                    <label class="modal-label-premium">BC. ICMS</label>
                    <vue-autonumeric v-model="venda.VL_BASE_CALC_ICMS" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold" />
                  </b-col>
                  <b-col sm="3">
                    <label class="modal-label-premium">Total ICMS</label>
                    <vue-autonumeric v-model="venda.VL_TOTAL_ICMS" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold text-info" />
                  </b-col>
                  <b-col sm="3">
                    <label class="modal-label-premium">BC. ICMS ST</label>
                    <vue-autonumeric v-model="venda.VL_BASE_CALC_ST_ICMS" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold" />
                  </b-col>
                  <b-col sm="3">
                    <label class="modal-label-premium">Total ICMS ST</label>
                    <vue-autonumeric v-model="venda.VL_TOTAL_ST_ICMS" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold text-info" />
                  </b-col>
                </b-row>

                <div class="modal-section-title mb-3">
                    <i class="fa fa-balance-scale mr-2 text-primary"></i> Tributos e Impostos Federais
                </div>
                <b-row class="mb-4">
                  <b-col sm="4">
                    <label class="modal-label-premium">Total IPI</label>
                    <vue-autonumeric v-model="venda.VL_TOTAL_IPI" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold" />
                  </b-col>
                  <b-col sm="4">
                    <label class="modal-label-premium">Total PIS</label>
                    <vue-autonumeric v-model="venda.VL_TOTAL_PIS" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold text-primary" />
                  </b-col>
                  <b-col sm="4">
                    <label class="modal-label-premium">Total COFINS</label>
                    <vue-autonumeric v-model="venda.VL_TOTAL_COFINS" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold text-primary" />
                  </b-col>
                </b-row>

                <div class="modal-section-title mb-3">
                    <i class="fa fa-gavel mr-2 text-primary"></i> Reforma Tributária (IBS / CBS)
                </div>
                <b-row class="mb-4">
                  <b-col sm="4">
                    <label class="modal-label-premium">BC. IBS / CBS</label>
                    <vue-autonumeric v-model="venda.VBCIBSCBSTOT" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold" />
                  </b-col>
                  <b-col sm="4">
                    <label class="modal-label-premium">Total IBS</label>
                    <vue-autonumeric v-model="venda.VIBSTOT" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold text-success" />
                  </b-col>
                  <b-col sm="4">
                    <label class="modal-label-premium">Total CBS</label>
                    <vue-autonumeric v-model="venda.VCBS_TOT" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right font-weight-bold text-success" />
                  </b-col>
                </b-row>

                <div class="modal-section-title mb-3">
                    <i class="fa fa-plus-circle mr-2 text-primary"></i> Outros Valores e Adicionais
                </div>
                <b-row>
                  <b-col sm="3">
                    <label class="modal-label-premium">Total Desconto</label>
                    <vue-autonumeric v-model="venda.VL_TOTAL_DESCONTO" :disabled="controles.fechada" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs text-right font-weight-bold text-danger" />
                  </b-col>
                  <b-col sm="3">
                    <label class="modal-label-premium">Total Seguro</label>
                    <vue-autonumeric v-model="venda.VL_TOTAL_SEGURO" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs text-right" />
                  </b-col>
                  <b-col sm="3">
                    <label class="modal-label-premium">Total Frete</label>
                    <vue-autonumeric v-model="venda.VL_TOTAL_FRETE" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs text-right" />
                  </b-col>
                  <b-col sm="3">
                    <label class="modal-label-premium">Outras Despesas</label>
                    <vue-autonumeric v-model="venda.VL_TOTAL_OUTRAS_DESP" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right" />
                  </b-col>
                </b-row>
            </div>

            <div class="modal-footer-premium p-3 bg-light border-top text-right">
                <b-button variant="soft-danger" pill class="px-5 font-weight-bold" @click="$bvModal.hide('modal-impostos')">
                    FECHAR
                </b-button>
            </div>
        </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL ITENS 
            ----------------------------------------------------------------------------------- -->
    <div>
        <b-modal ref="modalItem" 
            id="modalItem" 
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            body-class="p-0 overflow-hidden"
            size="xl"
            hide-footer
            hide-header
            content-class="border-0 shadow-lg"
            dialog-class="modal-xl-custom"
            @shown="focusModalItem()"
        >
            <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
                <div class="header-icon-wrapper-modal mr-3 bg-white-100">
                    <i class="fa fa-cube text-warning"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold text-white">{{ controles.itemAlteracao ? 'Editar Item do Pedido' : 'Adicionar Novo Item' }}</h5>
                    <small class="text-white opacity-75">Informe os detalhes do produto e quantidades</small>
                </div>
                <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modalItem')">
                    <i class="fa fa-times fa-lg"></i>
                </b-button>
            </div>
            
            <div class="p-4 bg-white">
              <!-- SEÇÃO 1: Identificação e Quantificação (Largura Total) -->
              <div class="modal-section-title mb-3">
                <i class="fa fa-info-circle mr-2 text-primary"></i> Identificação e Quantificação
              </div>
              
              <b-row class="mb-3">
                <b-col md="12">
                  <produto-pesquisa 
                    @retornaId="item.COD_PRO = $event"
                    @retornaNome="item.TX_NOME_PRODUTO = $event"
                    :idInicial="item.COD_PRO"
                    :desabilitarInput="controles.itemAlteracao"
                    :classe-required="!valCOD_PRO"
                    id="edCOD_PRO"
                    ref="edCOD_PRO"
                    label="Produto"
                    place="Busque pelo código ou nome do produto..."
                    labelBotao=""
                  />
                </b-col>
              </b-row>

              <b-row class="mb-3">
                <b-col md="3" sm="6">
                    <label class="modal-label-premium">Quantidade</label>
                    <vue-autonumeric v-model="item.QUANT" :disabled="pesagem.manual && !pesagem.liberadoParaEdicao" ref="edQuant" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 6 }" :class="['form-control rounded-pill shadow-xs text-right', { 'is-invalid' : !valQUANT }]" />
                </b-col>
                <b-col md="3" sm="6">
                    <label class="modal-label-premium">Volumes</label>
                    <vue-autonumeric v-model="item.PECAS" :disabled="pesagem.manual" ref="edPecas" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 0 }" :class="['form-control rounded-pill shadow-xs text-right', { 'is-invalid' : !valPECAS }]" />
                </b-col>
                <b-col md="3" sm="6" v-if="!precoTabelado">
                    <label class="modal-label-premium">Preço Unit.</label>
                    <vue-autonumeric ref="edPreco" v-model="item.VL_UNT" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 6 }" :class="['form-control rounded-pill shadow-xs font-weight-bold text-primary text-right', { 'is-invalid' : !valVL_UNT }]" />
                </b-col>
                <b-col md="3" sm="6" v-if="precoTabelado">
                    <label class="modal-label-premium">Tabela</label>
                    <b-form-select v-model="tabelaPreco.selected" :options="tabelaPreco.options" ref="comboTABELA_PRECO" class="rounded-pill shadow-xs" />
                </b-col>
                <b-col md="3" sm="6">
                    <label class="modal-label-premium">Valor Bruto</label>
                    <vue-autonumeric :value="totalBruto" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 2 }" class="form-control rounded-pill shadow-xs bg-light font-weight-bold text-right" />
                </b-col>
              </b-row>

              <!-- SEÇÃO 2: Pesagem Manual (Largura Total para mostrar as 10 colunas) -->
              <div class="bg-light p-3 rounded border mb-4 shadow-sm">
                  <div class="d-flex align-items-center mb-2">
                    <label class="modal-label-premium mb-0 mr-3">Lançamento por Peso (Pesagem Manual)</label>
                    <b-badge variant="soft-info" pill>10 COLUNAS • 300 LANÇAMENTOS</b-badge>
                  </div>
                  <b-input-group @keyup.enter="lancarPeso()" class="mb-3">
                    <vue-autonumeric v-model="pesagem.peso" id="edPeso" ref="edPeso" placeholder="Informe o peso e tecle ENTER" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill-left shadow-xs px-4 text-right" />
                    <b-input-group-append>
                      <b-button variant="primary" class="px-3" @click.stop.prevent="lancarPeso()"><i class="fa fa-plus mr-1"></i> LANÇAR</b-button>
                      <b-button variant="warning" class="px-3" @click.stop.prevent="excluirPeso()">DESFAZER</b-button>
                      <b-button v-if="pesagem.manual && !pesagem.liberadoParaEdicao" variant="info" class="px-3" @click.stop.prevent="solicitarLiberacaoEdicaoPeso()"><i class="fa fa-unlock mr-1"></i> LIBERAR EDIÇÃO</b-button>
                      <b-button variant="danger" :class="pesagem.manual && !pesagem.liberadoParaEdicao ? 'px-3' : 'rounded-pill-right px-3'" @click.stop.prevent="excluirPesagem()">LIMPAR TUDO</b-button>
                    </b-input-group-append>
                  </b-input-group>

                  <div class="bg-white rounded border shadow-xs overflow-hidden">
                    <b-table 
                      id="tblPesagem" 
                      ref="tblPesagem" 
                      sticky-header="150px" 
                      small 
                      hover 
                      striped 
                      :items="pesagem.items" 
                      :fields="pesagem.fields" 
                      class="mb-0 table-finance font-xs"
                    >
                        <template #head(id)="scope">Linha</template>
                        <template v-for="col in ['COL1','COL2','COL3','COL4','COL5','COL6', 'COL7', 'COL8', 'COL9', 'COL10']" #[`cell(${col})`]="data">
                            <div v-if="data.value !== null" class="d-flex justify-content-between align-items-center px-1 border-right" style="min-width: 70px;">
                                <span class="font-weight-bold">{{ data.value }}</span>
                                <b-button size="sm" variant="link" class="text-danger p-0" @click="limparCelulaPesagem(data.item.ID, col)">
                                    <i class="fa fa-times-circle"></i>
                                </b-button>
                            </div>
                        </template>
                    </b-table>
                  </div>
              </div>

              <!-- SEÇÃO 3: Base do Layout (Estoque + Impostos + Total) -->
              <div class="pt-4 border-top">
                <b-row>
                  <!-- Coluna Estoque -->
                  <b-col md="3" class="border-right">
                     <div class="modal-section-title mb-3 font-sm"><i class="fa fa-home mr-2 text-info"></i> Origem e Estoque</div>
                     <div class="mb-2">
                        <label class="modal-label-premium">Centro de Estoque</label>
                        <b-form-select v-model="item.COD_CENTRO" :options="estoqueProduto.options" class="rounded-pill shadow-xs border-info font-sm" />
                     </div>
                     <b-row>
                        <b-col sm="6">
                            <label class="modal-label-premium">Disponível</label>
                            <vue-autonumeric v-model="estoqueProduto.QUANT" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right font-sm" />
                        </b-col>
                        <b-col sm="6">
                            <label class="modal-label-premium">Volumes</label>
                            <vue-autonumeric v-model="estoqueProduto.PECAS" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right font-sm" />
                        </b-col>
                     </b-row>
                  </b-col>

                  <!-- Coluna Impostos Tradicionais -->
                  <b-col md="4" class="border-right">
                     <div class="modal-section-title mb-3 font-sm"><i class="fa fa-calculator mr-2 text-primary"></i> Tributos Federais/Estaduais</div>
                     <b-row class="mb-2">
                        <b-col sm="6">
                            <label class="modal-label-premium">ICMS / ST</label>
                            <b-input-group size="sm" class="rounded-pill overflow-hidden border shadow-xs">
                              <vue-autonumeric v-model="item.VL_ICMS" :disabled="true" class="form-control bg-soft-info border-0 text-right font-weight-bold" />
                              <vue-autonumeric v-model="item.VL_ICMS_ST" :disabled="true" class="form-control bg-soft-info border-0 border-left text-right font-weight-bold" />
                            </b-input-group>
                        </b-col>
                        <b-col sm="6">
                            <label class="modal-label-premium">PIS / ST</label>
                            <b-input-group size="sm" class="rounded-pill overflow-hidden border shadow-xs">
                              <vue-autonumeric v-model="item.VL_PIS" :disabled="true" class="form-control bg-soft-primary border-0 text-right font-weight-bold" />
                              <vue-autonumeric v-model="item.VL_PISST" :disabled="true" class="form-control bg-soft-primary border-0 border-left text-right font-weight-bold" />
                            </b-input-group>
                        </b-col>
                     </b-row>
                     <b-row>
                        <b-col sm="6">
                            <label class="modal-label-premium">COFINS / ST</label>
                            <b-input-group size="sm" class="rounded-pill overflow-hidden border shadow-xs">
                              <vue-autonumeric v-model="item.VL_COFINS" :disabled="true" class="form-control bg-soft-primary border-0 text-right font-weight-bold" />
                              <vue-autonumeric v-model="item.VL_COFINSST" :disabled="true" class="form-control bg-soft-primary border-0 border-left text-right font-weight-bold" />
                            </b-input-group>
                        </b-col>
                     </b-row>
                  </b-col>

                  <!-- Coluna Reforma Tributária -->
                  <b-col md="3" class="border-right">
                     <div class="modal-section-title mb-3 font-sm"><i class="fa fa-gavel mr-2 text-success"></i> Reforma (IBS/CBS)</div>
                     <b-row class="mb-2">
                        <b-col sm="6">
                            <label class="modal-label-premium">CST / ClassTrib</label>
                            <b-input-group size="sm" class="rounded-pill overflow-hidden border shadow-xs">
                                <b-form-input v-model="item.CST_IBSCBS" :disabled="true" class="form-control border-0 text-center font-weight-bold bg-light" />
                                <b-form-input v-model="item.CCLASSTRIB_IBSCBS" :disabled="true" class="form-control border-0 border-left text-center font-weight-bold bg-light" />
                            </b-input-group>
                        </b-col>
                        <b-col sm="6">
                            <label class="modal-label-premium text-success">IBS / CBS</label>
                            <b-input-group size="sm" class="rounded-pill overflow-hidden border shadow-xs">
                                <vue-autonumeric v-model="item.VIBSUF" :disabled="true" class="form-control bg-soft-success border-0 text-right font-weight-bold text-success" />
                                <vue-autonumeric v-model="item.VCBS" :disabled="true" class="form-control bg-soft-success border-0 border-left text-right font-weight-bold text-success" />
                            </b-input-group>
                        </b-col>
                     </b-row>
                  </b-col>

                  <!-- Coluna Total -->
                  <b-col md="2" class="d-flex align-items-center justify-content-center">
                    <div class="text-center w-100">
                      <small class="text-uppercase font-weight-bold text-muted" style="letter-spacing: 1px; font-size: 10px">Total Líquido</small>
                      <h3 class="mb-0 font-weight-bold text-success mt-1">{{totalBruto.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h3>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
            
            <div class="modal-footer-premium p-3 bg-light border-top">
                <b-row class="w-100 m-0">
                    <b-col class="p-0">
                         <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modalItem')">
                            CANCELAR
                        </b-button>
                    </b-col>
                    <b-col class="p-0 text-right">
                         <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click="controles.itemAlteracao ? editItem() : postItem()">
                            <i class="fa fa-save mr-1"></i> {{ controles.itemAlteracao ? 'SALVAR ALTERAÇÕES' : 'CONFIRMAR E ADICIONAR' }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL ITEM COM LOTE
            ----------------------------------------------------------------------------------- -->
    <div>
        <b-modal ref="modalItemLote"
            id="modalItemLote"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            body-class="p-0 overflow-hidden"
            size="xl"
            hide-footer
            hide-header
            content-class="border-0 shadow-lg"
            dialog-class="modal-xl-custom"
            @shown="focusModalItemLote()"
        >
            <b-overlay :show="modalLotes.carregando" rounded="sm">
              <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #2c3e50 0%, #000000 100%) !important;">
                  <div class="header-icon-wrapper-modal mr-3 bg-white-100">
                      <i class="fa fa-tags text-warning"></i>
                  </div>
                  <div>
                      <h5 class="mb-0 font-weight-bold text-white">{{ controles.itemAlteracao ? 'Editar Item com Lotes' : 'Adicionar Item com Lotes' }}</h5>
                      <small class="text-white opacity-75">Mapeie os lotes de estoque para este item do pedido</small>
                  </div>
                  <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modalItemLote')">
                      <i class="fa fa-times fa-lg"></i>
                  </b-button>
              </div>

              <div class="p-4 bg-white">
                <!-- SEÇÃO 1: Produto e Quantidade Total -->
                <div class="modal-section-title mb-3">
                  <i class="fa fa-info-circle mr-2 text-primary"></i> Identificação e Quantificação
                </div>

                <b-row class="mb-3">
                  <b-col md="12">
                    <produto-pesquisa
                      @retornaId="item.COD_PRO = $event"
                      @retornaNome="item.TX_NOME_PRODUTO = $event"
                      :idInicial="item.COD_PRO"
                      :desabilitarInput="controles.itemAlteracao"
                      :classe-required="!valCOD_PRO"
                      id="edCOD_PRO_LOTE"
                      ref="edCOD_PRO_LOTE"
                      label="Produto"
                      place="Busque pelo código ou nome do produto..."
                      labelBotao=""
                    />
                  </b-col>
                </b-row>

                <b-row class="mb-3">
                  <b-col md="3" sm="6">
                    <label class="modal-label-premium">{{ item.OP_CONTROLA_LOTE === '1' ? 'Quantidade Total (soma dos lotes)' : 'Quantidade' }}</label>
                    <vue-autonumeric
                      v-if="item.OP_CONTROLA_LOTE !== '1'"
                      v-model="item.QUANT"
                      ref="edQuantLote"
                      :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 6 }"
                      :class="['form-control rounded-pill shadow-xs text-right', { 'is-invalid': !valQUANT }]"
                    />
                    <vue-autonumeric
                      v-else
                      :value="somaLotesItem"
                      :disabled="true"
                      :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 3 }"
                      class="form-control rounded-pill shadow-xs bg-light font-weight-bold text-right text-success"
                    />
                  </b-col>
                  <b-col md="3" sm="6" v-if="!precoTabelado">
                    <label class="modal-label-premium">Preço Unit.</label>
                    <vue-autonumeric ref="edPrecoLote" v-model="item.VL_UNT" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 6 }" :class="['form-control rounded-pill shadow-xs font-weight-bold text-primary text-right', { 'is-invalid' : !valVL_UNT }]" />
                  </b-col>
                  <b-col md="3" sm="6" v-if="precoTabelado">
                    <label class="modal-label-premium">Tabela</label>
                    <b-form-select v-model="tabelaPreco.selected" :options="tabelaPreco.options" ref="comboTABELA_PRECO_LOTE" class="rounded-pill shadow-xs" />
                  </b-col>
                  <b-col md="3" sm="6">
                    <label class="modal-label-premium">Valor Bruto</label>
                    <vue-autonumeric :value="totalBruto" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 2 }" class="form-control rounded-pill shadow-xs bg-light font-weight-bold text-right" />
                  </b-col>
                  <b-col md="3" sm="6">
                    <label class="modal-label-premium">Centro de Estoque</label>
                    <b-form-select v-model="item.COD_CENTRO" :options="estoqueProduto.options" class="rounded-pill shadow-xs border-info" />
                  </b-col>
                </b-row>

                <!-- SEÇÃO 2: Tabela de Lotes (apenas quando produto controla lote) -->
                <template v-if="item.OP_CONTROLA_LOTE === '1'">
                  <div class="modal-section-title mb-3">
                    <i class="fa fa-list mr-2 text-warning"></i> Lotes Disponíveis
                  </div>

                  <b-table
                    id="tblLotesItem"
                    small
                    hover
                    striped
                    :items="modalLotes.items"
                    :fields="[
                      { key: 'LOTE', label: 'Lote', sortable: true },
                      { key: 'DATA_VALIDADE', label: 'Validade', sortable: true },
                      { key: 'QUANT_SALDO', label: 'Saldo Disp.' },
                      { key: 'QUANT_PLANEJADA', label: 'Qtd. a Usar' },
                      { key: 'acoes', label: '' }
                    ]"
                    show-empty
                    empty-text="Nenhum lote disponível para este produto."
                    class="border rounded shadow-xs"
                  >
                    <template #cell(DATA_VALIDADE)="row">
                      {{ row.item.DATA_VALIDADE ? new Date(row.item.DATA_VALIDADE).toLocaleDateString('pt-BR') : '-' }}
                    </template>
                    <template #cell(QUANT_SALDO)="row">
                      <span class="font-weight-bold text-success">{{ Number(row.item.QUANT_SALDO || 0).toLocaleString('pt-BR', { minimumFractionDigits: 3 }) }}</span>
                    </template>
                    <template #cell(QUANT_PLANEJADA)="row">
                      <vue-autonumeric
                        v-model="row.item.QUANT_PLANEJADA"
                        :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0', decimalPlaces: 3 }"
                        class="form-control text-right rounded-pill"
                        style="width:100%"
                        @change.native="onLoteChange()"
                      />
                    </template>
                    <template #cell(acoes)="row">
                      <b-button size="sm" variant="outline-success" pill @click="vincularSaldoLote(row.item)">
                        <i class="fa fa-check-circle mr-1"></i> Usar Todo
                      </b-button>
                    </template>
                  </b-table>
                </template>

                <!-- SEÇÃO 3: Tributos (leitura) e totais -->
                <div class="bg-light p-3 rounded border mt-3 shadow-sm">
                  <b-row>
                    <b-col md="3" class="border-right">
                      <div class="modal-section-title mb-2 font-sm"><i class="fa fa-home mr-2 text-info"></i> Estoque</div>
                      <b-row>
                        <b-col sm="6">
                          <label class="modal-label-premium">Disponível</label>
                          <vue-autonumeric v-model="estoqueProduto.QUANT" :disabled="true" :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalCharacterAlternative: '.', roundingMethod: 'U', minimumValue: '0' }" class="form-control rounded-pill shadow-xs bg-light text-right font-sm" />
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="5" class="border-right">
                      <div class="modal-section-title mb-2 font-sm"><i class="fa fa-calculator mr-2 text-primary"></i> Tributos Federais/Estaduais</div>
                      <b-row>
                        <b-col sm="6">
                          <label class="modal-label-premium">ICMS / ST</label>
                          <b-input-group size="sm" class="rounded-pill overflow-hidden border shadow-xs">
                            <vue-autonumeric v-model="item.VL_ICMS" :disabled="true" class="form-control bg-soft-info border-0 text-right font-weight-bold" />
                            <vue-autonumeric v-model="item.VL_ICMS_ST" :disabled="true" class="form-control bg-soft-info border-0 border-left text-right font-weight-bold" />
                          </b-input-group>
                        </b-col>
                        <b-col sm="6">
                          <label class="modal-label-premium">PIS / COFINS</label>
                          <b-input-group size="sm" class="rounded-pill overflow-hidden border shadow-xs">
                            <vue-autonumeric v-model="item.VL_PIS" :disabled="true" class="form-control bg-soft-primary border-0 text-right font-weight-bold" />
                            <vue-autonumeric v-model="item.VL_COFINS" :disabled="true" class="form-control bg-soft-primary border-0 border-left text-right font-weight-bold" />
                          </b-input-group>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="4" class="d-flex align-items-center justify-content-center">
                      <div class="text-center w-100">
                        <small class="text-uppercase font-weight-bold text-muted" style="letter-spacing: 1px; font-size: 10px">Total Líquido</small>
                        <h3 class="mb-0 font-weight-bold text-success mt-1">{{totalBruto.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h3>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>

              <div class="modal-footer-premium p-3 bg-light border-top">
                  <b-row class="w-100 m-0">
                      <b-col class="p-0">
                          <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modalItemLote')">
                              CANCELAR
                          </b-button>
                      </b-col>
                      <b-col class="p-0 text-right">
                          <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click="controles.itemAlteracao ? editItemLote() : postItemLote()">
                              <i class="fa fa-save mr-1"></i> {{ controles.itemAlteracao ? 'SALVAR ALTERAÇÕES' : 'CONFIRMAR E ADICIONAR' }}
                          </b-button>
                      </b-col>
                  </b-row>
              </div>
            </b-overlay>
        </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL CANCELAMENTO 
            ----------------------------------------------------------------------------------- -->
    <div>
      
        <b-modal ref="modal-excluir-item" 
            id="modal-excluir-item" 
            hide-header
            hide-footer
            body-class="p-0 overflow-hidden"
            size="lg"
            content-class="border-0 shadow-lg"
            @shown="focusModaldeleteItem()"
        >
          <b-overlay :show="cancelamento.parametros.overlayBaixando" no-wrap fixed z-index="1100" spinner-variant="primary" spinner-type="border">
            <template #overlay>
              <div class="text-center p-4 bg-white rounded shadow-lg border">
                <b-icon icon="trash" font-scale="3" animation="pulse" class="text-danger mb-3"></b-icon>
                <h5 class="font-weight-bold">Removendo Item...</h5>
                <p class="text-muted mb-0">Por favor, aguarde um momento.</p>
              </div>
            </template>
          </b-overlay>

          <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%) !important;">
                <div class="header-icon-wrapper-modal mr-3 bg-white-20">
                    <i class="fa fa-trash text-white"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold text-white">Remover Item da Venda</h5>
                    <small class="text-white opacity-75">Confirme a exclusão do produto selecionado</small>
                </div>
                <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-excluir-item')">
                    <i class="fa fa-times fa-lg"></i>
                </b-button>
          </div>

          <div class="p-4 bg-white">
              <div class="modal-info-bar mb-4 bg-soft-danger border-danger-20">
                 <h5 class="mb-0 font-weight-bold text-danger text-center w-100">
                    {{itemExcluir.CODIGO_NOME_PRODUTO}}
                 </h5>
              </div>
              
              <b-row class="text-center">
                 <b-col md="4" class="border-right">
                    <small class="modal-label-premium">Quantidade</small>
                    <h4 class="mb-0 font-weight-bold">{{itemExcluir.QUANT_MASK}}</h4>
                 </b-col>
                 <b-col md="4" class="border-right">
                    <small class="modal-label-premium">Preço Unit.</small>
                    <h4 class="mb-0 font-weight-bold">{{itemExcluir.VL_UNT_MASK}}</h4>
                 </b-col>
                 <b-col md="4">
                    <small class="modal-label-premium text-danger">Total do Item</small>
                    <h4 class="mb-0 font-weight-bold text-danger">{{itemExcluir.VL_TOTAL_BRUTO_MASK}}</h4>
                 </b-col>
              </b-row>
              
              <div class="mt-4 p-3 bg-light rounded text-center font-italic text-muted border">
                Deseja realmente remover este produto da lista de pedidos?
              </div>
          </div>

          <div class="modal-footer-premium p-3 bg-light border-top">
              <b-row class="w-100 m-0">
                  <b-col class="p-0">
                       <b-button variant="soft-primary" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-excluir-item')">
                          MANTER ITEM
                      </b-button>
                  </b-col>
                  <b-col class="p-0 text-right">
                       <b-button variant="danger" pill class="px-4 font-weight-bold shadow-sm" @click="deleteItem()">
                          CONFIRMAR EXCLUSÃO
                      </b-button>
                  </b-col>
              </b-row>
          </div>
        </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL REABRIR VENDA 
            ----------------------------------------------------------------------------------- -->
    <div>
      
        <b-modal ref="modal-reabrir" 
            id="modal-reabrir" 
            hide-header
            hide-footer
            body-class="p-0 overflow-hidden"
            :no-close-on-backdrop="true"
            size="lg"
            content-class="border-0 shadow-lg"
            @shown="focusModalReabrir()"
        >
          <b-overlay :show="modalReabrir.parametros.overlayBaixando" no-wrap fixed z-index="1100" spinner-variant="primary" spinner-type="border">
            <template #overlay>
              <div class="text-center p-4 bg-white rounded shadow-lg border">
                <b-icon icon="unlock" font-scale="3" animation="pulse" class="text-warning mb-3"></b-icon>
                <h5 class="font-weight-bold">Reabrindo Pedido...</h5>
                <p class="text-muted mb-0">Processando solicitações.</p>
              </div>
            </template>
          </b-overlay>

          <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #f39c12 0%, #d35400 100%) !important;">
                <div class="header-icon-wrapper-modal mr-3 bg-white-20">
                    <i class="fa fa-unlock-alt text-white"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold text-white">Reabrir Venda Finalizada</h5>
                    <small class="text-white opacity-75">O pedido voltará para o estado de digitação</small>
                </div>
                <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-reabrir')">
                    <i class="fa fa-times fa-lg"></i>
                </b-button>
          </div>

          <div class="p-4 bg-white">
              <div class="modal-info-bar mb-4 bg-soft-warning border-warning-20 d-flex justify-content-between align-items-center">
                 <div>
                    <small class="modal-label-premium">Pedido nº</small>
                    <h5 class="mb-0 font-weight-bold text-dark">{{venda.N_VENDA}}</h5>
                 </div>
                 <div class="text-center mx-3 flex-grow-1">
                    <small class="modal-label-premium">Cliente</small>
                    <h5 class="mb-0 font-weight-bold text-primary">{{cliente.CODIGO}} - {{cliente.RAZAOSOCIAL}}</h5>
                 </div>
                 <div class="text-right">
                    <small class="modal-label-premium">Valor Total</small>
                    <h5 class="mb-0 font-weight-bold text-success">{{totalVenda.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h5>
                 </div>
              </div>
              
              <div class="form-group mb-0 p-3 bg-light rounded border">
                <label class="modal-label-premium" for="edMotivoReabrir">Motivo para Reabertura <span class="text-danger">*</span></label>
                <b-form-textarea 
                    id="edMotivoReabrir" 
                    ref="edMotivoReabrir"
                    v-model="venda.OBS3"
                    rows="3"
                    no-resize
                    :state="venda.OBS3 != null && venda.OBS3 != ''"
                    class="rounded-pill-20 shadow-xs px-4 py-3"
                    placeholder="Descreva detalhadamente o motivo para reabrir esta venda..."
                />
              </div>
          </div>

          <div class="modal-footer-premium p-3 bg-light border-top">
              <b-row class="w-100 m-0">
                  <b-col class="p-0">
                       <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-reabrir')">
                          CANCELAR
                      </b-button>
                  </b-col>
                  <b-col class="p-0 text-right">
                       <b-button variant="warning" pill class="px-4 font-weight-bold shadow-sm" @click="reabrir()">
                          CONFIRMAR REABERTURA
                      </b-button>
                  </b-col>
              </b-row>
          </div>
        </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL LIBERAR DÉBITOS 
            ----------------------------------------------------------------------------------- -->
    <div>
        <b-modal ref="modal-liberar-debitos" 
            id="modal-liberar-debitos" 
            hide-header
            hide-footer
            body-class="p-0 overflow-hidden"
            :no-close-on-backdrop="true"
            size="lg"
            content-class="border-0 shadow-lg"
            @shown="focusModalLiberarDebitos()"
        >
          <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #f1c40f 0%, #f39c12 100%) !important;">
                <div class="header-icon-wrapper-modal mr-3 bg-white-20">
                    <i class="fa fa-exclamation-triangle text-white"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold text-white">Liberar Débitos da Venda</h5>
                    <small class="text-white opacity-75">Títulos financeiros serão removidos para permitir edição</small>
                </div>
                <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-liberar-debitos')">
                    <i class="fa fa-times fa-lg"></i>
                </b-button>
          </div>

          <div class="p-4 bg-white">
            <b-overlay :show="modalLiberarDebitos.parametros.overlayBaixando" rounded="lg" opacity="0.6">
              <div class="modal-info-bar mb-4 bg-soft-warning border-warning-20 d-flex justify-content-between align-items-center shadow-xs">
                 <div>
                    <small class="modal-label-premium">Pedido nº</small>
                    <h5 class="mb-0 font-weight-bold">{{venda.N_VENDA}}</h5>
                 </div>
                 <div class="text-center mx-3 flex-grow-1 border-left border-right">
                    <small class="modal-label-premium">Cliente</small>
                    <h5 class="mb-0 font-weight-bold text-primary">{{cliente.RAZAOSOCIAL}}</h5>
                 </div>
                 <div class="text-right">
                    <small class="modal-label-premium">Valor em Aberto</small>
                    <h5 class="mb-0 font-weight-bold text-success">{{totalVenda.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}</h5>
                 </div>
              </div>

              <b-alert show variant="soft-warning" class="border-warning-20">
                <div class="d-flex align-items-center">
                  <i class="fa fa-info-circle fa-2x mr-3 text-warning"></i>
                  <div>
                    <h6 class="font-weight-bold mb-1">Atenção Necessária</h6>
                    <small>Esta venda já gerou títulos no Contas a Receber. A liberação irá excluir esses débitos e reverter o status da venda para edição.</small>
                  </div>
                </div>
              </b-alert>

              <div class="form-group mt-4 p-3 bg-light rounded border">
                <label class="modal-label-premium" for="edMotivoLiberarDebitos">Motivo da Liberação <span class="text-danger">*</span></label>
                <b-form-input 
                    id="edMotivoLiberarDebitos" 
                    ref="edMotivoLiberarDebitos"
                    v-model="modalLiberarDebitos.motivo"
                    :state="modalLiberarDebitos.motivo != null && modalLiberarDebitos.motivo != ''"
                    class="rounded-pill shadow-xs px-4"
                    placeholder="Descreva o motivo da liberação financeira..."
                />
              </div>
            </b-overlay>
          </div>

          <div class="modal-footer-premium p-3 bg-light border-top">
              <b-row class="w-100 m-0">
                  <b-col class="p-0">
                       <b-button variant="soft-primary" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-liberar-debitos')">
                          FECHAR
                      </b-button>
                  </b-col>
                  <b-col class="p-0 text-right">
                       <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" @click="liberarDebitos()">
                          CONFIRMAR LIBERAÇÃO
                      </b-button>
                  </b-col>
              </b-row>
          </div>
        </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL TIPO DE MOVIMENTAÇÃO 
            ----------------------------------------------------------------------------------- -->
    <div>
        <b-modal ref="modal-tipo-movimentacao" 
            id="modal-tipo-movimentacao" 
            size="xl"
            hide-footer
            hide-header
            body-class="p-0 overflow-hidden"
            content-class="border-0 shadow-lg font-sm"
        >
          <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #1abc9c 0%, #16a085 100%) !important;">
                <div class="header-icon-wrapper-modal mr-3 bg-white-20">
                    <i class="fa fa-exchange text-white"></i>
                </div>
                <div>
                    <h5 class="mb-0 font-weight-bold text-white">Tipo de Movimentação</h5>
                    <small class="text-white opacity-75">Selecione a operação desejada para o pedido</small>
                </div>
                <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-tipo-movimentacao')">
                    <i class="fa fa-times fa-lg"></i>
                </b-button>
          </div>

          <div class="p-4 bg-white">
            <div class="modal-filter-bar mb-4 p-3 bg-light rounded border shadow-xs">
              <b-row align-v="center">
                <b-col md="12">
                   <div class="d-flex align-items-center">
                     <i class="fa fa-search mr-3 text-muted"></i>
                     <b-form-input
                        id="filtro-tipo-mov"
                        v-model="modalTipoMovimentacao.filtro"
                        type="text"
                        placeholder="Pesquisar por código ou descrição da operação..."
                        class="rounded-pill border-0 shadow-none bg-transparent"
                        style="font-size: 1.1rem;"
                      />
                   </div>
                </b-col>
              </b-row>
            </div>
            
            <div class="rounded border shadow-sm overflow-hidden">
                <b-table
                  striped
                  hover
                  :sticky-header="true"
                  :small="true"
                  :items="tipoMovimentacaoItemsFiltrados"
                  :fields="modalTipoMovimentacao.fields"
                  select-mode="single"
                  selectable
                  @row-selected="selecionarTipoMovimentacao"
                  show-empty
                  empty-text="Nenhum tipo de movimentação encontrado"
                  class="mb-0 table-finance"
                >
                </b-table>
            </div>
          </div>

          <div class="modal-footer-premium p-3 bg-light border-top text-right">
             <b-button variant="soft-danger" pill class="px-5 font-weight-bold" @click="$bvModal.hide('modal-tipo-movimentacao')">
                FECHAR
            </b-button>
          </div>
        </b-modal>
      <VendaBoletoModal ref="modalBoletoVenda" @atualizar="atualizarVendaAposDocumento" />
      <VendaNotaFiscalModal ref="modalNotaFiscalVenda" :forcarMotorNode="true" @atualizar="atualizarVendaAposDocumento" />
    </div>
  </div>
</template>

<script>
import VendedorPesquisa from '../../pesquisa/VendedorPesquisa.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import FuncionarioPesquisa from '../../pesquisa/FuncionarioPesquisa.vue'
import ProdutoPesquisa from '../../pesquisa/ProdutoPesquisa.vue'
import VueAutonumeric from 'vue-autonumeric'
import moment from 'moment'
import Tools from '@/tools/tools.js'
import { Callout } from '../../../components/'
import CecSelectSearch from '../../componentes/dropdown/CecSelectSearch.vue'
import VendedorDropdown from '../../componentes/dropdown/VendedorDropdown.vue'
import FuncionarioDropdown from '../../componentes/dropdown/FuncionarioDropdown.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import HeaderPadrao from '../../../components/Cec/HeaderPadrao.vue'
import { imprimirFaturaVenda } from './VendaFaturaHTML'
import VendaBoletoModal from './components/VendaBoletoModal.vue'
import VendaNotaFiscalModal from './components/VendaNotaFiscalModal.vue'

const CAMPOS_NAO_PERSISTENTES_VENDA = Object.freeze([
  'ORDEM_ENTREGA_STATUS',
  'OP_PDF_ONLINE',
  'ITENS_VENDA',
  'VENCIMENTO',
  'PERCENTUAL',
  'ULT_BAIXA_DIAS',
  'VALOR_EM_ABERTO',
  'SITUACAO_TRADUZIDO',
  'NFE_RELACIONADA',
  'NOTA_FISCAL_ID',
  'EMPRESA_NOTA_FISCAL_ID',
  'NFE_OP_STATUS',
  'OP_STATUS_BOLETO_EMITIDO',
  'OP_STATUS_NOTA_FISCAL_EMITIDA',
  'NOME_CLIENTE',
  'NOME_VENDEDOR',
  'EXISTE_BOLETO',
  'TEM_FINANCEIRO',
  'OP_ALTERADO',
  'ID'
])

function montarVendaPersistivel(venda = {}) {
  const payload = { ...venda }
  CAMPOS_NAO_PERSISTENTES_VENDA.forEach(campo => {
    delete payload[campo]
  })
  return payload
}

export default {
  components: {
    VendedorPesquisa,
    ClientePesquisa,
    FuncionarioPesquisa,
    ProdutoPesquisa,
    VueAutonumeric,
    CecSelectSearch,
    VendedorDropdown,
    FuncionarioDropdown,
    CecInputData,
    Callout,
    HeaderPadrao,
    VendaBoletoModal,
    VendaNotaFiscalModal
  },
  data () {
    return {
      permiteAlterarDataVenda: false,
      permiteAlterarPesoManual: false,
      tabIndex: 0,
      precoTabelado: false,
      vlTotalAntes: 0.00,
      diasIniciarPagamento: null,
      tipoMovimentacaoDescricao: '',
      tipoMovimentacoes : {
        selected: null,
        options: null,
        items: []
      },
      modalTipoMovimentacao: {
        show: false,
        filtro: '',
        fields: [
          {
            key: 'ID',
            label: 'Código',
            sortable: true,
            thStyle: { width: '10%' }
          },
          {
            key: 'DESCRICAO',
            label: 'Descrição',
            sortable: true,
            thStyle: { width: '30%' }
          },
          {
            key: 'GERA_IMPOSTO_ICMS',
            label: 'Gera ICMS',
            sortable: true,
            thStyle: { width: '10%' },
            formatter: (value) => value === '1' ? 'Sim' : 'Não'
          },
          {
            key: 'OP_DESTINO_OPERACAO',
            label: 'Destino',
            sortable: true,
            thStyle: { width: '12%' },
            formatter: (value) => {
              if (value === '1') return 'Interna'
              if (value === '2') return 'Externa'
              return value
            }
          },
          {
            key: 'OP_MOVIMENTA_ESTOQUE',
            label: 'Mov. Estoque',
            sortable: true,
            thStyle: { width: '13%' },
            formatter: (value) => value === '1' ? 'Sim' : 'Não'
          },
          {
            key: 'OP_GERA_FINANCEIRO',
            label: 'Gera Financ.',
            sortable: true,
            thStyle: { width: '12%' },
            formatter: (value) => value === '1' ? 'Sim' : 'Não'
          },
          {
            key: 'FORMA',
            label: 'Forma',
            sortable: true,
            thStyle: { width: '13%' }
          }
        ],
        items: []
      },
      controles: {
        montagemTelaConcluida : false,
        vendaEmAlteracao: false,
        vendaReaberta: false,
        fechada: false,
        falhaNaAbertura: false,
        itemAlteracao: false,
        situacaoCliente : 'Cliente',
        clienteBloqueado : false,
        OP_ICMS_SITUACAO_TRIBUTARIA: null,
        COD_PRO: null,
        salvandoVenda: false,
        botaoGerarDocumento: {
          value: 'Some value',
          busy: false,
          clicou: false
        }
      },
      cliente: {
        CODIGO: null,
        NOME: null,
        RAZAOSOCIAL: null,
        ID_UF: null,
        FIZ_JUR: null,
        ISENTO_ICMS: null,
        COD_VEND: null,
        VL_CREDITO: 0.00,
        LIMITE_CREDITO: 0.00,
        NOTAS_EM_ABERTO: 0,
        PRAZO: null,
        TIPO_CLI: null,
        GRUPO_ARECEBER_ID: null
      },
      venda: {
        SEQUENCIA                 : null,
        N_VENDA                   : null,
        DT_SAIDA                  : null,
        COD_CLI                   : null,
        OP_PEDIDO                 : null,
        DT_PAG                    : null,
        PAG1                      : null,
        PAG2                      : null,
        PAG3                      : null,
        PAG4                      : null,
        PAG5                      : null,
        TIPO                      : null,
        TIPO_VEN                  : null,
        FORMA                     : null,
        COD_VENDEDOR              : null,
        COD_MOTORISTA             : null,
        VL_TOTAL                  : null,
        OBS2                      : null,
        OBS3                      : null,
        LOTE                      : null,
        TIPO_DOCPAG               : null,
        N_DOCPAG                  : null,
        COD_REPRES                : null,
        COD_CONFERENTE            : null,
        TIPO_VENDEDOR             : null,
        ITENS                     : null,
        NENTREGA                  : null,
        PLACA                     : null,
        VL_ENTRADA                : null,
        VL_DESCONTO               : null,
        CFOP                      : null,
        UFENT                     : null,
        TELENT                    : null,
        CONTATOENT                : null,
        BAIRROENT                 : null,
        CIDADEENT                 : null,
        ENDENT                    : null,
        USUARIO                   : null,
        MOT_CANC                  : null,
        NUMNF                     : null,
        SERIENF                   : null,
        UFPLACA                   : null,
        PORCONTA                  : null,
        VOLUMES                   : null,
        PESOLIQUIDO               : null,
        PESOBRUTO                 : null,
        TOTALNF                   : null,
        DT_CANC                   : null,
        DT_ALTERACAO              : null,
        TX_USUARIO_ALTERACAO      : null,
        VL_TOTAL_ANTES_ALTERACAO  : null,
        VL_BASE_CALC_ICMS         : 0.00,
        VL_TOTAL_ICMS             : 0.00,
        VL_BASE_CALC_ST_ICMS      : 0.00,
        VL_TOTAL_ST_ICMS          : 0.00,
        VL_TOTAL_IPI              : 0.00,
        VL_TOTAL_PIS              : 0.00,
        VL_TOTAL_COFINS           : 0.00,
        VBCIBSCBSTOT              : 0.00,
        VIBSTOT                   : 0.00,
        VCBS_TOT                  : 0.00,
        VL_TOTAL_DESCONTO         : 0.00,
        VL_TOTAL_SEGURO           : 0.00,
        VL_TOTAL_OUTRAS_DESP      : 0.00,
        VL_TOTAL_FRETE            : 0.00,
        NR_PESO_BRUTO             : 0.00,
        VL_TOTAL_PRODUTOS         : 0.00,
        NR_PESO_LIQUIDO           : 0.00,
        VL_TOTAL_NFE              : 0.00,
        OP_FORMA_PAGTO            : null,
        TX_USUARIO_CANCELAMENTO   : null,
        NR_PARCELAS               : null,
        COD_TRANSP                : null,
        ORIGEM                    : null,
        DT_PREVISAO_ENTREGA       : null,
        HORA                      : null,
        DT_PEDIDO                 : null,
        DT_SISTEMA_CANCELAMENTO   : null,
        DT_CADASTRO_SISTEMA       : null,
        DT_ALTERACAO_SISTEMA      : null,
        OBSERVACOES               : null,
        SITUACAO                  : null,
        DT_RETORNO                : null,
        NOME_RESPONSAVEL_RETORNO  : null,
        DT_LANCAMENTO_RETORNO     : null,
        OBS_RETORNO               : null,
        USUARIO_RETORNO           : null,
        VL_TOTAL_RETORNO_BKP      : 0.00,
        VL_TOTAL_RETORNO          : 0.00,
        DT_LANCAMENTO_WEB         : null,
        OP_LANCAMENTO_WEB         : null,
        USUARIO_LANCAMENTO_WEB    : null,
        OBS_PEDIDO                : null,
        DT_INICIAR_PAGAMENTO      : null,
        TIPO_MOVIMENTACAO_ID      : null
      },
      tabelaPreco:{
        selected: null,
        options:[]
      },
      itemExcluir: {
        CONTROLE: null,
        COD_PRO: null,
        COD_CENTRO: null,
        CODIGO_NOME_PRODUTO: '',
        QUANT: 0.00,
        PECAS: 0,
        TX_UNIDADE_COMERCIAL: '',
        VL_UNT: 0.00,
        VL_DESCONTO: 0.00,
        VL_TOTAL: 0.00
      },
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          processando: false,
          busy: false
        }
      },
      modalReabrir: {
        parametros: {
          overlayBaixando: false,
          processando: false,
          busy: false,
        }
      },
      modalLiberarDebitos: {
        motivo: null,
        parametros: {
          overlayBaixando: false,
          processando: false,
          busy: false,
        }
      },
      parametros: {},
      modalLotes: {
        items: [],
        carregando: false
      },
      item: {
        CONTROLE                       : null, 
        SEQUENCIA                      : null, 
        COD_PRO                        : null, 
        EAN                            : null, 
        QUANT                          : null, 
        VL_UNT                         : null, 
        VL_CUSTO                       : null, 
        UND_PECAS                      : null, 
        PECAS                          : null, 
        DT_VENDA                       : null, 
        TIPO_CLI                       : null, 
        MARCA                          : null, 
        TIPO_VEN                       : null, 
        ALTERA                         : null, 
        ITEM                           : null, 
        VL_COMISSAO                    : null, 
        COD_CENTRO                     : null, 
        ICMS                           : null, 
        IPI                            : null, 
        ISS                            : null, 
        IRRF                           : null, 
        ICMSSUBSTITUI                  : null, 
        FORMA                          : null, 
        ID_CFOP                        : null, 
        OP_STATUS_PRECO                : null, 
        VL_TOTAL_BRUTO                 : 0.00, 
        VL_TOTAL_DESCONTO              : null, 
        OP_ICMS_SITUACAO_TRIBUTARIA    : null, 
        OP_ICMS_ORIGEM                 : null, 
        OP_ICMS_MODAL_DETERM_BC        : null, 
        VL_ICMS_PERCENT_REDUC_BC       : null, 
        VL_ICMS_BASE_CALC              : null, 
        VL_ICMS_ALIQUOTA               : null, 
        VL_ICMS                        : null, 
        OP_ICMS_MODAL_DETERM_BC_ST     : null, 
        VL_ICMS_MARGEM_VL_ADIC_ST      : null, 
        VL_ICMS_PERCENT_REDUC_BC_ST    : null, 
        VL_ICMS_BASE_CALC_ST           : null, 
        VL_ICMS_ALIQUOTA_ST            : null, 
        VL_ICMS_ST                     : null, 
        OP_IPI_SITUACAO_TRIBUTARIA     : null, 
        OP_IPI_CLASS_ENQ_CIG_BEB       : null, 
        TX_IPI_CODIGO_ENQUAD_LEGAL     : null, 
        TX_IPI_CNPJ_PRODUTOR           : null, 
        TX_IPI_NUM_SELO_CONTROLE       : null, 
        OP_IPI_TIPO_CALCULO            : null, 
        VL_IPI_BASE_CALC               : null, 
        VL_IPI_ALIQUOTA                : null, 
        VL_IPI_QUANT_TOTAL_UND_PADRAO  : null, 
        VL_IPI_UNIDADE                 : null, 
        VL_IPI                         : null, 
        OP_PIS_SITUACAO_TRIBUTARIA     : null, 
        OP_PIS_TIPO_CALCULO            : null, 
        VL_PIS_BASE_CALC               : null, 
        VL_PIS_ALIQUOTA_PERCENT        : null, 
        VL_PIS_ALIQUOTA_REAIS          : null, 
        VL_PIS_QUANT_VENDIDA           : null, 
        VL_PIS                         : null, 
        OP_PISST_TIPO_CALCULO          : null, 
        VL_PISST_BASE_CALC             : null, 
        VL_PISST_ALIQUOTA_PERCENT      : null, 
        VL_PISST_ALIQUOTA_REAIS        : null, 
        VL_PISST_QUANT_VENDIDA         : null, 
        VL_PISST                       : null, 
        OP_COFINS_SITUACAO_TRIBUTARIA  : null, 
        OP_COFINS_TIPO_CALCULO         : null, 
        VL_COFINS_BASE_CALC            : null, 
        VL_COFINS_ALIQUOTA_PERCENT     : null, 
        VL_COFINS_ALIQUOTA_REAIS       : null, 
        VL_COFINS_QUANT_VENDIDA        : null, 
        VL_COFINS                      : null, 
        OP_COFINSST_TIPO_CALCULO       : null, 
        VL_COFINSST_BASE_CALC          : null, 
        VL_COFINSST_ALIQUOTA_PERCENT   : null, 
        VL_COFINSST_ALIQUOTA_REAIS     : null, 
        VL_COFINSST_QUANT_VENDIDA      : null, 
        VL_COFINSST                    : null, 
        CST_IBSCBS                     : null,
        CCLASSTRIB_IBSCBS              : null,
        VIBSUF                         : null,
        VCBS                           : null,
        TX_OBSERVACOES                 : null, 
        OP_COMPOE_VALOR_NFE            : null, 
        VL_ICMS_BC_ST_RETIDO_ANT       : null, 
        VL_ICMS_ST_RETIDO_ANT          : null, 
        VL_ICMS_PERC_BC_OPER_PROPRIA   : null, 
        ID_UF_ICMS_ST                  : null, 
        OP_MOTIVO_DESONERACAO          : null, 
        VL_ALIQ_APLICAVEL_CALC_CREDITO : null, 
        VL_CREDITO_ICMS_APROVEITADO    : null, 
        VL_DESCONTO_PERC               : null, 
        TX_NCM                         : null, 
        TX_NOME_PRODUTO                : null, 
        TX_UNIDADE_COMERCIAL           : null, 
        OP_OCORRENCIA_PRECO            : null, 
        VL_DESCONTO                    : null, 
        ID_UNIDADE_COMERCIAL           : null, 
        OP_TRIBUTACAO                  : null, 
        CEST                           : null, 
        QUANT_BKP                      : null, 
        QUANT_RETORNO                  : null, 
        PECAS_BKP                      : null, 
        PECAS_RETORNO                  : null, 
        OBS_RETORNO                    : null, 
        QUANT_PEDIDO                   : null,
        PECAS_PEDIDO                   : null,
        OP_TIPO_TABELA_PRECO           : null,
        OP_REPESAR                     : null,
        VL_ICMS_ALIQUOTA_DESONERA      : null,
        VL_ICMS_DESONERA               : null,
        OP_IND_DEDUZ_DESONERA          : null,
        IND_BEM_MOVEL_USADO            : null,
        VITEM_REFORMA                  : null,
        CHAVE_DFE_REF                  : null,
        NITEM_DFE_REF                  : null,
        CSTIS                          : null,
        CCLASSTRIBIS                   : null,
        VBCIS                          : null,
        PIS_SELETIVO                   : null,
        PISESPEC                       : null,
        UTRIBIS                        : null,
        QTRIBIS                        : null,
        VIS                            : null,
        CST_IBSCBS                     : null,
        CCLASSTRIB_IBSCBS              : null,
        VBC_IBSCBS                     : null,
        PIBSUF                         : null,
        VIBSUF                         : null,
        PDIF_IBSUF                     : null,
        VDIF_IBSUF                     : null,
        VDEVTRIB_IBSUF                 : null,
        PREDALIQ_IBSUF                 : null,
        PALIQEFET_IBSUF                : null,
        PIBSMUN                        : null,
        VIBSMUN                        : null,
        PDIF_IBSMUN                    : null,
        VDIF_IBSMUN                    : null,
        VDEVTRIB_IBSMUN                : null,
        PREDALIQ_IBSMUN                : null,
        PALIQEFET_IBSMUN               : null,
        PCBS                           : null,
        VCBS                           : null,
        PDIF_CBS                       : null,
        VDIF_CBS                       : null,
        VDEVTRIB_CBS                   : null,
        PREDALIQ_CBS                   : null,
        PALIQEFET_CBS                  : null,
        OP_CONTROLA_LOTE               : '0',

      },
      pesagem: {
        peso: 0.00,
        manual: false,
        liberadoParaEdicao: false,
        fields: [
          { 
            key: 'ID', 
            stickyColumn: true, 
            isRowHeader: true, 
            variant: this.isDark == true ? '' : 'light',
            thStyle: { width: '60px', minWidth: '60px', maxWidth: '60px' },
            tdStyle: { width: '60px', minWidth: '60px', maxWidth: '60px' }
          },
          {
            key: 'COL1',
            thStyle: { width: '9.2%', minWidth: '70px' },
            tdStyle: { width: '9.2%', minWidth: '70px' },
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {
            key: 'COL2',
            thStyle: { width: '9.2%', minWidth: '70px' },
            tdStyle: { width: '9.2%', minWidth: '70px' },
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {
            key: 'COL3',
            thStyle: { width: '9.2%', minWidth: '70px' },
            tdStyle: { width: '9.2%', minWidth: '70px' },
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {
            key: 'COL4',
            thStyle: { width: '9.2%', minWidth: '70px' },
            tdStyle: { width: '9.2%', minWidth: '70px' },
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {
            key: 'COL5',
            thStyle: { width: '9.2%', minWidth: '70px' },
            tdStyle: { width: '9.2%', minWidth: '70px' },
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {
            key: 'COL6',
            thStyle: { width: '9.2%', minWidth: '70px' },
            tdStyle: { width: '9.2%', minWidth: '70px' },
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {
            key: 'COL7',
            thStyle: { width: '9.2%', minWidth: '70px' },
            tdStyle: { width: '9.2%', minWidth: '70px' },
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {
            key: 'COL8',
            thStyle: { width: '9.2%', minWidth: '70px' },
            tdStyle: { width: '9.2%', minWidth: '70px' },
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {
            key: 'COL9',
            thStyle: { width: '9.2%', minWidth: '70px' },
            tdStyle: { width: '9.2%', minWidth: '70px' },
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
          {
            key: 'COL10',
            thStyle: { width: '9.2%', minWidth: '70px' },
            tdStyle: { width: '9.2%', minWidth: '70px' },
            formatter: (value, key, item) => 
                typeof value === 'number' ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          },
        ],
        items:[]
      },
      tipoVenda: [
        { value: 'VENDA', text: '1 - Romaneio de Vendas' },
        { value: 'PEDIDO', text: '2 - Pedido de Vendas' },
        { value: 'TROCA', text: '3 - Troca de Mercadoria' },
      ],
      tipoPagamento: [
        { value: 'V', text: 'A VISTA' },
        { value: 'P', text: 'A PRAZO'}
      ],
      tipoContatoOptions: [
        { value: '0', text: 'Telefone' },
        { value: '1', text: 'Visita' },
        { value: '2', text: 'Internet' }
      ],
      parcelasVezes: [],
      dias:[],
      tabelaParcelamento: {
        fields: [
          {
            key: "PARCELA",
            label: 'Parcela'
          },
          {
            key: 'VENCIMENTO',
            label: 'Vencimento',
            formatter: (value, key, item) => 
              moment(value).format("DD/MM/YYYY")
          },
          {
            key: 'VALOR', 
            class:'text-right', 
            label: 'Valor (R$)',
            formatter: (value, key, item) => 
                value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : null
          }
        ],
        items: []
      },
      estoqueProduto: {
        options: [],
        QUANT: 0.00,
        PECAS: 0,
      },
      tabelaItens: {
        fields: [
          {
            key: "CODIGO_NOME_PRODUTO",
            label: 'Produto'
          },
          {
            key: "QUANT",
            label: 'Quantidade',
            class:'text-right', 
            formatter: (value, key, item) => 
                value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0.00
          },
          {
            key: "PECAS",
            label: 'Peças',
            class:'text-right', 
          },
          {
            key: "TX_UNIDADE_COMERCIAL",
            label: 'UND'
          },
          {
            key: 'VL_ICMS_ALIQUOTA', 
            class:'text-right', 
            label: 'ICMS (%)', 
            formatter: (value, key, item) => 
               value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : 0.00
          },
          {
            key: 'VL_PIS_ALIQUOTA_PERCENT', 
            class:'text-right', 
            label: 'PIS (%)', 
            formatter: (value, key, item) => 
                value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : 0.00
          },
          {
            key: 'VL_COFINS_ALIQUOTA_PERCENT', 
            class:'text-right', 
            label: 'COFINS (%)', 
            formatter: (value, key, item) => 
                value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : 0.00
          },
          {
            key: 'VL_UNT', 
            class:'text-right', 
            label: 'Valor (R$)', 
            formatter: (value, key, item) => 
               value && value > 0.00 ?  value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          },
          {
            key: 'VL_TOTAL_BRUTO', 
            class:'text-right', 
            label: 'Total (R$)', 
            formatter: (value, key, item) => 
                value && value > 0.00 ?  value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          },
          
          {
            key: "actions" ,
            class:'text-center p-0',
            label: 'Ações' 
          }
        ],
        items: []
      },
      produto: {
        id: null,
        quantidade : 0.00,
        pecas : 0,
        valor: 0.00,
        total: 0.00
      },
      modalItem:{
        overlayBaixando: false,
        icms: {
          opTipoSituacaoTributariaSimples: [
            { value : '00', text : 'ICMS 00 -Tributada Integralmente'},
            { value : '10', text : 'ICMS 10 - Tributada com cobrança do ICMS por Substituição Tributária'},
            { value : '20', text : 'ICMS 20 - Com redução na base de cálculo'},
            { value : '30', text : 'ICMS 30 - Isenta ou não tributada com cobrança do ICMS por substituição tributária'},
            { value : '40', text : 'ICMS 40 - Isenta'},
            { value : '41', text : 'ICMS 41 - Não tributada'},
            { value : '50', text : 'ICMS 50 - Suspensão'},
            { value : '51', text : 'ICMS 51 - Diferimento'},
            { value : '60', text : 'ICMS 60 - Cobrado anteriormente por substiruição tributária'},
            { value : '70', text : 'ICMS 70 - Com redução da base de cálculo e cobrança do ICMS por substituição tributária'},
            { value : '90', text : 'ICMS 90 - Outras'},
          ],
          opTipoSituacaoTributariaNormal: [
            { value: '101', text: 'ICMS 101 - Tributada com permissão de crédito'},
            { value: '102', text: 'ICMS 102 - Trib utada sem permissão de crédito'},
            { value: '103', text: 'ICMS 103 - Isenção do ICMS para faixa de receita bruta'},
            { value: '201', text: 'ICMS 201 - Tributada com permissão de crédito e com cobrança do ICMS por ST'},
            { value: '202', text: 'ICMS 202 - Tributada sem permissão de crédito e com cobrança do ICMS por ST'},
            { value: '203', text: 'ICMS 203 - Isenção do ICMS para faixa de receita bruta e com cobrança do ICMS por ST'},
            { value: '300', text: 'ICMS 300 - Imune'},
            { value: '400', text: 'ICMS 400 - Não tributada'},
            { value: '500', text: 'ICMS 500 - ICMS cobrado anteriormente por ST ou por antecipação'},
            { value: '900', text: 'ICMS 900 - Outros'}
          ],
          opOrigemMercadoria: [
            { value: '0', text: 'Nacional'},
            { value: '1', text: 'Extrangeira - Importação Direta'},
            { value: '2', text: 'Extrangeira - Adquirida no Mercado Interno'},
          ],
          opModalidade: [
            { value: '0', text: 'Margem Valor Agregado'},
            { value: '1', text: 'Pauta Valor'},
            { value: '2', text: 'Preço tabelado Max. Valor'},
            { value: '3', text: 'Valor da Operação'},
          ],
          opMotivoDesoneracao: [
            { value: '', text: ''},
            { value: '1', text: 'Taxi'},
            { value: '2', text: 'Deficiente Fisico'},
            { value: '3', text: 'Produto Agropecuário'},
            { value: '4', text: 'Frotista/Locadora'},
            { value: '5', text: 'Diplomata/Consultor'},
            { value: '9', text: 'Outros'},
            { value: '6', text: 'Utilit. e Motoc. da Amazônia Ocidental'},
            { value: '7', text: 'SUFRAMA'},
          ],
          opModalidadeST: [
            { value: '0', text: 'Preço Tabelado ou Máximo Sugerido'},
            { value: '1', text: 'Lista Negativa (Valor)'},
            { value: '2', text: 'Lista Positiva (valor)'},
            { value: '3', text: 'Lista Neutra (valor)'},
            { value: '4', text: 'Margem Valor Agregado (%)'},
            { value: '5', text: 'Pauta (valor)'},
          ],
        },
        pis:{
          opTipoSituacaoTributaria: [
            { value: '01', text : 'PIS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text : 'PIS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text : 'PIS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text : 'PIS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text : 'PIS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text : 'PIS 07 - Operação Isenta da Contribuição'},
            { value: '08', text : 'PIS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text : 'PIS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text : 'PIS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        },
        cofins:{
          opTipoSituacaoTributaria: [
            { value: '01', text: 'COFINS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text: 'COFINS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text: 'COFINS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text: 'COFINS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text: 'COFINS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text: 'COFINS 07 - Operação Isenta da Contribuição'},
            { value: '08', text: 'COFINS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text: 'COFINS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text: 'COFINS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        }
      },   
      icms: {
        habilitado: {
          comboOP_ICMS_ORIGEM              : true, // Sempre Visivel
          
          //Grupo ICMS Normal
          comboOP_ICMS_MODAL_DETERM_BC     : false,
          edVL_ICMS_PERCENT_REDUC_BC       : false,
          edVL_ICMS_BASE_CALC              : false,
          edVL_ICMS_ALIQUOTA               : false,
          edVL_ICMS_PERC_BC_OPER_PROPRIA   : false,
          edVL_ICMS                        : false,

          comboOP_MOTIVO_DESONERACAO       : false,

          //Grupo ICMS Normal ST
          comboOP_ICMS_MODAL_DETERM_BC_ST  : false,
          edVL_ICMS_PERCENT_REDUC_BC_ST    : false,
          edVL_ICMS_MARGEM_VL_ADIC_ST      : false,
          edVL_ICMS_BASE_CALC_ST           : false,
          edVL_ICMS_ALIQUOTA_ST            : false,
          edVL_ICMS_ST                     : false,
          comboID_UF_ICMS_ST               : false,

          //Grupo ICMS Simples
          edVL_ALIQ_APLICAVEL_CALC_CREDITO : false,
          edVL_CREDITO_ICMS_APROVEITADO    : false,

          //Grupo ICMS Simples ST
          edVL_ICMS_BC_ST_RETIDO_ANT       : false,
          edVL_ICMS_ST_RETIDO_ANT          : false,

          
        }
      },

    }
  },
      
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    produtoTotal: {
       get() {
        return 0.00
       },
       set() {

       }
    },
    habilitarBotaoReabrir() {
      return ((['1'].includes(this.venda.SITUACAO))   && (this.controles.falhaNaAbertura == false) )
      // return ((this.controles.fechada == true) && (this.controles.falhaNaAbertura == false) )
    },
    habilitarAcoesVendaFechada() {
      return Boolean(this.venda.SEQUENCIA) &&
        ['1'].includes(String(this.venda.SITUACAO || '').trim()) &&
        this.controles.falhaNaAbertura == false
    },
    statusBoletoVenda() {
      return String(this.venda?.OP_STATUS_BOLETO_EMITIDO == null ? '' : this.venda.OP_STATUS_BOLETO_EMITIDO).trim().toUpperCase()
    },
    statusNotaFiscalVenda() {
      return String(this.venda?.OP_STATUS_NOTA_FISCAL_EMITIDA == null ? '' : this.venda.OP_STATUS_NOTA_FISCAL_EMITIDA).trim().toUpperCase()
    },
    statusNotaFiscalVendaReal() {
      return String(this.venda?.NFE_OP_STATUS == null ? '' : this.venda.NFE_OP_STATUS).trim().toUpperCase()
    },
    mostrarBotaoBoletoVenda() {
      return Boolean(this.venda.SEQUENCIA) && this.controles.falhaNaAbertura == false
    },
    mostrarBotaoNotaFiscalVenda() {
      return Boolean(this.venda.SEQUENCIA) && this.controles.falhaNaAbertura == false
    },
    podeEmitirBoletoVenda() {
      return this.habilitarAcoesVendaFechada && ['0', '1', ''].includes(this.statusBoletoVenda)
    },
    podeVisualizarBoletoVenda() {
      return this.mostrarBotaoBoletoVenda && !this.podeEmitirBoletoVenda && !['', '0', '1'].includes(this.statusBoletoVenda)
    },
    podeEmitirNotaFiscalVenda() {
      if (this.statusNotaFiscalVendaReal) {
        return this.habilitarAcoesVendaFechada && this.statusNotaFiscalVendaReal !== '2'
      }
      return this.habilitarAcoesVendaFechada && this.statusNotaFiscalVenda !== '2'
    },
    podeVisualizarNotaFiscalVenda() {
      return this.mostrarBotaoNotaFiscalVenda && this.statusNotaFiscalVendaReal === '2'
    },
    habilitarBotaoBoletoVenda() {
      return this.podeEmitirBoletoVenda || this.podeVisualizarBoletoVenda
    },
    habilitarBotaoNotaFiscalVenda() {
      return this.podeEmitirNotaFiscalVenda || this.podeVisualizarNotaFiscalVenda
    },
    textoBotaoBoletoVenda() {
      if (this.podeVisualizarBoletoVenda) return 'VISUALIZAR BOLETO'
      if (this.podeEmitirBoletoVenda) return 'EMITIR BOLETO'
      return 'BOLETO'
    },
    textoBotaoNotaFiscalVenda() {
      if (this.podeVisualizarNotaFiscalVenda) return 'VISUALIZAR NOTA FISCAL'
      if (this.podeEmitirNotaFiscalVenda) return 'EMITIR NOTA FISCAL'
      return 'NOTA FISCAL'
    },
    iconeBotaoBoletoVenda() {
      return this.podeVisualizarBoletoVenda ? 'fa-eye' : 'fa-barcode'
    },
    iconeBotaoNotaFiscalVenda() {
      return this.podeVisualizarNotaFiscalVenda ? 'fa-eye' : 'fa-file-text-o'
    },
    habilitarBotaoFinalizar() {
      return ((this.controles.fechada == false) && (this.controles.clienteBloqueado == false) && (this.controles.falhaNaAbertura == false))
    },
    habilitaBotaoGravar() {
      return (this.controles.fechada == false) && 
             (this.controles.clienteBloqueado == false) &&
             (this.controles.falhaNaAbertura == false) &&
             (['2','3','4','5','6'].includes(this.venda.SITUACAO))
    },
    opPedido(){
      return this.venda.OP_PEDIDO??null
    },
    valN_VENDA(){
      return ((this.venda.N_VENDA ) && (this.venda.N_VENDA > 0)) ? true : false
    },
    valCOD_CLI(){
      return ((this.venda.COD_CLI ) && (this.venda.COD_CLI > 0)) ? true : false
    },
    valCOD_VENDEDOR(){
      return ((this.venda.COD_VENDEDOR ) && (this.venda.COD_VENDEDOR > 0)) ? true : false
    },
    valCOD_CONFERENTE(){
      return ((this.venda.COD_CONFERENTE ) && (this.venda.COD_CONFERENTE > 0)) ? true : false
    },
    valCOD_MOTORISTA(){
      return ((this.venda.COD_MOTORISTA ) && (this.venda.COD_MOTORISTA > 0)) ? true : false
    },
    valTIPO_MOVIMENTACAO_ID() {
      return ((this.venda.TIPO_MOVIMENTACAO_ID ) && (this.venda.TIPO_MOVIMENTACAO_ID > 0)) ? true : false
    },
    valDT_INICIAR_PAGAMENTO() {
      if (this.venda.OP_FORMA_PAGTO !== 'P') return true
      return (this.venda.DT_INICIAR_PAGAMENTO != null && this.venda.DT_INICIAR_PAGAMENTO != '')
    },
    valDT_PREVISAO_ENTREGA() {
      return (this.venda.DT_PREVISAO_ENTREGA != null && this.venda.DT_PREVISAO_ENTREGA != '')
    },
    valDiasIniciarPagamento() {
      if (!this.venda.OP_FORMA_PAGTO) return null
      
      const dias = Number(this.diasIniciarPagamento)
      
      if (this.venda.OP_FORMA_PAGTO === 'V') {
        // À Vista: deve ser 0
        return dias == 0 ? true : false
      } else if (this.venda.OP_FORMA_PAGTO === 'P') {
        // A Prazo: deve ser > 0
        return dias > 0 ? true : false
      }
      return null
    },
    valNR_PARCELAS() {
      if (!this.venda.OP_FORMA_PAGTO) return null
      
      const parcelas = Number(this.venda.NR_PARCELAS)
      
      if (this.venda.OP_FORMA_PAGTO === 'V') {
        // À Vista: deve ser 1
        return parcelas == 1 ? true : false
      } else if (this.venda.OP_FORMA_PAGTO === 'P') {
        // A Prazo: deve ser > 0
        return parcelas > 0 ? true : false
      }
      return null
    },
    valOP_FORMA_PAGTO() {
      return ((this.venda.OP_FORMA_PAGTO ) && (this.venda.OP_FORMA_PAGTO != '')) ? true : false
    },
    valPAG1() {
      if (!this.venda.OP_FORMA_PAGTO) return null
      
      const diasEntre = Number(this.venda.PAG1)
      const parcelas = Number(this.venda.NR_PARCELAS)
      
      if (this.venda.OP_FORMA_PAGTO === 'V') {
        // À Vista: deve ser 0
        return diasEntre == 0 ? true : false
      } else if (this.venda.OP_FORMA_PAGTO === 'P') {
        // A Prazo:
        if (parcelas === 1) {
          // Se 1 parcela: deve ser 0
          return diasEntre == 0 ? true : false
        }
        if (parcelas > 1) {
          // Se múltiplas parcelas: deve ser >= 2 (não pode ser null, 0 ou 1)
          if (this.venda.PAG1 === null || this.venda.PAG1 === undefined ||
              diasEntre == 0 || diasEntre == 1) {
            return false
          }
          return diasEntre >= 2 ? true : false
        }
        return null
      }
      return null
    },
    valCOD_PRO(){
      return ((this.item.COD_PRO ) && (this.item.COD_PRO > 0)) ? true : false
    },
    somaLotesItem() {
      return this.modalLotes.items.reduce((soma, lote) => soma + Number(lote.QUANT_PLANEJADA || 0), 0)
    },
    usarModalLotes() {
      return String(this.parametros.OP_VENDA_MAPEAR_LOTE || '0').trim() === '1'
    },
    valQUANT(){
      return ((this.item.QUANT ) && (this.item.QUANT > 0)) ? true : false
    },
    valPECAS(){
      return ((this.item.PECAS ) && (this.item.PECAS > 0)) ? true : false
    },
    valVL_UNT(){
      return ((this.item.VL_UNT ) && (this.item.VL_UNT > 0)) ? true : false
    },
    valOBS3() {
      return ((this.venda.OBS3 ) && (this.venda.OBS3 != '')) ? true : false
    },
    totalVenda() {
      return this.venda.VL_TOTAL_NFE?? 0.00
    },
    limiteCredito: {
      get() {
        return this.cliente.LIMITE_CREDITO ?? 0.00
      },
      set(val) {
        this.cliente.LIMITE_CREDITO = val
      }
    },
    totalBruto() {
      return this.item.VL_TOTAL_BRUTO?? 0.00
    },
    totalPIS() {
      return this.venda.VL_TOTAL_PIS?? 0
    },
    totalCOFINS() {
      return this.venda.VL_TOTAL_COFINS?? 0
    },
    totalDesconto() {
      return this.venda.VL_TOTAL_DESCONTO?? 0
    },
    totalICMS() {
      return this.venda.VL_TOTAL_ICMS?? 0
    },
    
    totalQuant(){
      let soma = 0.00
      if (this.tabelaItens.items){
        if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
          [...this.tabelaItens.items].forEach(it => {
            soma += it.QUANT
          })
        } 
        return soma
      } else {
        return 0.00
      }
    },
    totalPecas(){
      let soma = 0
      if (this.tabelaItens.items){
        if (this.tabelaItens.items.length && this.tabelaItens.items.length > 0) {
          [...this.tabelaItens.items].forEach(it => {
            soma += it.PECAS
          })
        } 
        return soma
      } else {
        return 0
      }
    },
    tamanhocampoPagina () {
      if (this.venda.PAGINA) {
        return this.venda.PAGINA.length > 2 ? null : false
      }
      return false
    },
    textoImposto() {
      return this.cliente.ISENTO_ICMS ? (this.cliente.ISENTO_ICMS == 1 ? 'ISENTO' : 'SUJEITO') : 'AUSENTE'
    },
    tipoMovimentacaoItemsFiltrados() {
      if (!this.modalTipoMovimentacao.filtro) {
        return this.modalTipoMovimentacao.items
      }
      const filtroLower = this.modalTipoMovimentacao.filtro.toLowerCase()
      return this.modalTipoMovimentacao.items.filter(item => {
        return (
          (item.ID && item.ID.toString().includes(filtroLower)) ||
          (item.DESCRICAO && item.DESCRICAO.toLowerCase().includes(filtroLower))
        )
      })
    },
    tipoMovimentacaoSelecionadoTexto() {
      return this.tipoMovimentacaoDescricao
    }
  },
  methods: {
    async validarPermissaoAlterarDataVenda() {
      const permissaoPayLoad = {
        login: window.localStorage.getItem('login'),
        permissao: 'ACPropAlterarDataVenda'
      }

      try {
        const permissaoResult = await this.$http.post(`api/protected/seguranca/validarPermissao`, permissaoPayLoad)
        const permissao = permissaoResult?.data?.permissao ?? null
        this.permiteAlterarDataVenda = permissao === true
      } catch (err) {
        console.error('Erro ao validar permissão de alterar data da venda:', err)
        this.permiteAlterarDataVenda = false
      }
    },
    async validarPermissaoAlterarPesoManual() {
      const permissaoPayLoad = {
        login: window.localStorage.getItem('login'),
        permissao: 'AcPropAlterarPesoPreFatura'
      }

      try {
        const permissaoResult = await this.$http.post(`api/protected/seguranca/validarPermissao`, permissaoPayLoad)
        const permissao = permissaoResult?.data?.permissao ?? null
        this.permiteAlterarPesoManual = permissao === true
        return this.permiteAlterarPesoManual
      } catch (err) {
        console.error('Erro ao validar permissão de alterar peso manual:', err)
        this.permiteAlterarPesoManual = false
        return false
      }
    },
    async solicitarLiberacaoEdicaoPeso() {
      const temPermissao = await this.validarPermissaoAlterarPesoManual()
      
      if (temPermissao) {
        this.pesagem.liberadoParaEdicao = true
        this.$snotify.success('Edição de peso liberada! Você pode alterar a quantidade manualmente.', 'Permissão Concedida')
        // Foca no campo quantidade
        this.$nextTick(() => {
          if (this.$refs.edQuant) {
            this.$refs.edQuant.$el.focus()
            this.$refs.edQuant.$el.select()
          }
        })
      } else {
        this.$snotify.error('Você não possui permissão para alterar o peso com pesagem manual.', 'Acesso Negado')
      }
    },
    async retornarParaListagemVenda({ replace = false } = {}) {
      this.$store.commit('controle/setAguardando', true)
      if (this.venda.SEQUENCIA) {
        this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", this.venda.SEQUENCIA)
      }
      await this.atualizarPaginaPesquisa()
      if (replace) {
        this.$router.replace('/movimentos/vendas/listagem')
      } else {
        this.$router.push('/movimentos/vendas/listagem')
      }
    },
    async voltar() {
        await this.retornarParaListagemVenda()
    },
    montarPayloadVenda() {
      return montarVendaPersistivel(this.venda)
    },
    async gravarPedidoEVoltar() {
      if (!this.venda.DT_SAIDA) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Informe a Data da Venda!!!` )
        return
      }
      if (!this.venda.DT_PREVISAO_ENTREGA) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Informe a Data de Entrega!!!` )
        return
      }
      if (!this.valCOD_CLI) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Inform o Cliente!!!` )
        return
      } 
      
      // Proteção contra cliques múltiplos no botão GRAVAR
      if (this.controles.salvandoVenda) {
        console.log('Aguarde... salvando venda')
        return
      }
      
      try{
        this.$store.commit('controle/setAguardando', true)
        try {
          
          if ((this.controles.vendaEmAlteracao == true) || (this.venda.SEQUENCIA)) {
            await this.$http.post(`/api/protected/venda/editDesktop`, { venda: this.montarPayloadVenda() })
          } else {
            // Proteção double-check: bloqueia imediatamente antes do POST
            this.controles.salvandoVenda = true
            
            // Dupla verificação após setar a flag
            if (this.venda.SEQUENCIA) {
              // Já foi criada por outro clique, continua normalmente
              this.controles.salvandoVenda = false
            } else {
              try {
                const response = await this.$http.post(`/api/protected/venda/postOnly`, this.montarPayloadVenda())
                // Atualiza o SEQUENCIA da venda com o retorno do backend
                if (response.data && response.data.SEQUENCIA) {
                  this.venda.SEQUENCIA = response.data.SEQUENCIA
                }
              } finally {
                this.controles.salvandoVenda = false
              }
            }
          }

          await this.retornarParaListagemVenda()
        } catch (err) {
          const mensagemErro =
            (err.response && err.response.data && (err.response.data.message || JSON.stringify(err.response.data))) ||
            err.message || 'Erro inesperado'

          this.$root.$bvToast.toast(`Aviso: ${mensagemErro}`, {
            title: 'Erro',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    async atualizarPaginaPesquisa(ctx) {
      try {
        await this.$store.dispatch('venda/GERAR_LISTA')
        return true
      } catch (error) {
        return false
      }
    },
    async atualizarVendaAposDocumento() {
      await this.atualizarPaginaPesquisa()
      await this.atualizarStatusAcoesVenda()
    },
    async atualizarStatusAcoesVenda() {
      if (!this.venda?.SEQUENCIA || !this.venda?.DT_SAIDA) {
        return
      }

      try {
        const response = await this.$http.get('/api/protected/venda/pesquisar', {
          params: {
            id: this.venda.SEQUENCIA,
            dt1: this.venda.DT_SAIDA,
            dt2: this.venda.DT_SAIDA
          }
        })

        const vendaPesquisa = response?.data?.[0]
        if (!vendaPesquisa) {
          return
        }

        this.venda = {
          ...this.venda,
          OP_STATUS_BOLETO_EMITIDO: vendaPesquisa.OP_STATUS_BOLETO_EMITIDO,
          OP_STATUS_NOTA_FISCAL_EMITIDA: vendaPesquisa.OP_STATUS_NOTA_FISCAL_EMITIDA,
          NOTA_FISCAL_ID: vendaPesquisa.NOTA_FISCAL_ID,
          EMPRESA_NOTA_FISCAL_ID: vendaPesquisa.EMPRESA_NOTA_FISCAL_ID,
          NFE_RELACIONADA: vendaPesquisa.NFE_RELACIONADA,
          NFE_OP_STATUS: vendaPesquisa.NFE_OP_STATUS
        }
      } catch (err) {
        console.error('Erro ao atualizar status de boleto/NF da venda:', err)
      }
    },
    montarItemVendaParaAcoes() {
      const nomeCliente = this.venda.NOME_CLIENTE || this.cliente.NOME || ''
      return {
        ...this.venda,
        SEQUENCIA: this.venda.SEQUENCIA,
        ID: this.venda.SEQUENCIA,
        COD_CLI: this.venda.COD_CLI || this.cliente.CODIGO,
        NOME_CLIENTE: nomeCliente,
        NOME_VENDEDOR: this.venda.NOME_VENDEDOR || '',
        SITUACAO: this.venda.SITUACAO,
        N_VENDA: this.venda.N_VENDA || this.venda.SEQUENCIA,
        DT_SAIDA: this.venda.DT_SAIDA,
        VL_TOTAL_NFE: this.venda.VL_TOTAL_NFE || this.totalVenda || 0,
        TIPO_MOVIMENTACAO_ID: this.venda.TIPO_MOVIMENTACAO_ID,
        OP_STATUS_BOLETO_EMITIDO: this.venda.OP_STATUS_BOLETO_EMITIDO || '0',
        OP_STATUS_NOTA_FISCAL_EMITIDA: this.venda.OP_STATUS_NOTA_FISCAL_EMITIDA || '0',
        NOTA_FISCAL_ID: this.venda.NOTA_FISCAL_ID || null,
        EMPRESA_NOTA_FISCAL_ID: this.venda.EMPRESA_NOTA_FISCAL_ID || null,
        NFE_OP_STATUS: this.venda.NFE_OP_STATUS || ''
      }
    },
    validarAcaoVendaFinalizada() {
      if (!this.habilitarAcoesVendaFechada) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Finalize a prefatura antes de executar esta acao.')
        return false
      }

      this.$store.commit('venda/SET_REGISTRO_SELECIONADO_ID', this.venda.SEQUENCIA)
      return true
    },
    async abrirBoletoDaVenda() {
      if (this.podeVisualizarBoletoVenda) {
        await this.visualizarBoletoDaVenda()
        return
      }

      if (!this.validarAcaoVendaFinalizada()) return
      this.$refs.modalBoletoVenda.abrir(this.montarItemVendaParaAcoes())
    },
    async abrirNotaFiscalDaVenda() {
      if (this.podeVisualizarNotaFiscalVenda) {
        await this.visualizarNotaFiscalDaVenda()
        return
      }

      if (!this.validarAcaoVendaFinalizada()) return
      this.$refs.modalNotaFiscalVenda.abrir(this.montarItemVendaParaAcoes())
    },
    async visualizarBoletoDaVenda() {
      if (!this.venda?.SEQUENCIA) {
        return
      }

      this.$store.commit('venda/SET_REGISTRO_SELECIONADO_ID', this.venda.SEQUENCIA)

      try {
        this.$store.commit('controle/setAguardando', true)

        const areceberResponse = await this.$http.get(`/api/protected/areceber/getByVendaId/${this.venda.SEQUENCIA}`)
        const titulos = Array.isArray(areceberResponse?.data) ? areceberResponse.data : []
        const titulosComBoleto = titulos.filter(item => Number(item.BOLETO_ID) > 0)
        const boletoIds = titulosComBoleto.map(item => Number(item.BOLETO_ID)).filter(id => id > 0)
        const contaId = titulosComBoleto.find(item => Number(item.CONTA_BOLETO_ID) > 0)?.CONTA_BOLETO_ID || null

        if (!boletoIds.length) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Nao foi localizado um boleto emitido para esta prefatura.')
          return
        }

        const response = await this.$http.post('/api/protected/integrador/downloadPDFBoleto/', {
          boletoId: boletoIds[0],
          boletoIds,
          contaId
        })

        const resultado = response?.data ?? null
        if (!resultado || !resultado.sucesso || !resultado.pdfBase64) {
          const erro = resultado?.erro || 'Nao foi possivel baixar o PDF do boleto.'
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro)
          return
        }

        const byteCharacters = atob(resultado.pdfBase64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        window.open(window.URL.createObjectURL(blob))
      } catch (err) {
        console.error('Erro ao visualizar boleto da venda:', err)
        const erroMsg = err?.response?.data?.erro || err?.response?.data?.message || err?.message || 'Falha inesperada ao visualizar o boleto.'
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', erroMsg)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async visualizarNotaFiscalDaVenda() {
      if (!this.venda?.SEQUENCIA) {
        return
      }

      this.$store.commit('venda/SET_REGISTRO_SELECIONADO_ID', this.venda.SEQUENCIA)

      try {
        this.$store.commit('controle/setAguardando', true)

        const response = await this.$http.get(`/api/protected/notaFiscal/downloadPDFVendaId/${this.venda.SEQUENCIA}`, {
          responseType: 'arraybuffer'
        })

        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
        window.open(url)
      } catch (err) {
        console.error('Erro ao visualizar nota fiscal da venda:', err)
        const erroMsg = err?.response?.data?.erro || err?.response?.data?.message || err?.message || 'Falha inesperada ao visualizar a nota fiscal.'
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', erroMsg)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    /* ****************************  ITEM *****************/
    async abrirModalItemNovo () {
      // A VENDA AINDA NÃO FOI SALVA
      if (!this.venda.DT_SAIDA) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `É necessário informar a Data da Venda!!` )
        return
      }
      if (!this.venda.DT_PREVISAO_ENTREGA) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `E necessario informar a Data de Entrega!!` )
        return
      }
      if (!this.venda.COD_CLI) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `É necessário informar o CLIENTE!!` )
        return
      }

      // Proteção contra cliques múltiplos - verifica AMBAS as condições atomicamente
      if (!this.venda.SEQUENCIA && !this.controles.salvandoVenda) {
        try {
          // Bloqueia imediatamente para evitar corrida
          this.controles.salvandoVenda = true
          
          // Dupla verificação após setar a flag (double-check locking pattern)
          if (this.venda.SEQUENCIA) {
            this.controles.salvandoVenda = false
            // Já foi criada por outro clique, continua normalmente
          } else {
            this.venda.USUARIO = window.localStorage.getItem('login')
            const { data } = await this.$http.post(`/api/protected/venda/post`, this.montarPayloadVenda())

            if (!data || !data.SEQUENCIA) {
              throw new Error('Resposta da API inválida ao iniciar nova venda')
            }

            this.venda = data
            this.ajustarCamposTabelaVendas(this.venda)
            await this.atualizarStatusAcoesVenda()
            this.$store.commit("venda/SET_REGISTRO_SELECIONADO_ID", this.venda.SEQUENCIA)

            // Atualiza a URL para o modo de edição
            this.$router.push(`/movimentos/vendas/edit/${this.venda.SEQUENCIA}`)
          }

        } catch (erro) {
          console.error('Erro ao iniciar nova venda:', erro)
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', erro || 'Não foi possível iniciar uma nova venda!!')
          return
        } finally {
          // Libera para novos cliques
          this.controles.salvandoVenda = false
        }
      } else if (this.controles.salvandoVenda) {
        // Se já está salvando, apenas retorna silenciosamente
        console.log('Aguarde... venda sendo criada')
        return
      }

      this.limparItem(false, {})
      
      this.pesagem.items = []
      this.pesagem.manual = false
      this.atualizarTabelaPesagem()

      this.item.SEQUENCIA     = this.venda.SEQUENCIA
      this.item.OP_TRIBUTACAO = '0'
      this.item.COD_CENTRO    = this.parametros.COD_CENTROESTOQUE
      this.item.ID_CFOP       = this.parametros.COD_CFOPVEN

      this.controles.OP_ICMS_SITUACAO_TRIBUTARIA = null
      this.controles.COD_PRO = null
      this.controles.itemAlteracao = false

      if (this.usarModalLotes) {
        this.modalLotes.items = []
        this.$refs['modalItemLote'].show()
      } else {
        this.$refs.modalItem.show()
      }
    },
    async abrirModalItemEditar(item) {
      
      if (this.controles.fechada) return

      // Quando disparado por @row-dblclicked do b-table, o 'item' é o próprio objeto da linha, não um array.
      // Se for disparado por seleção múltipla ou outro método que retorne array, tratamos também.
      const itemData = Array.isArray(item) ? item[0] : item

      if (itemData && itemData.CONTROLE) {
        
        try {
          this.$store.commit('controle/setAguardando', true)
          this.controles.itemAlteracao = true
          try {
            const result = await this.$http.get(`/api/protected/venda/item/getById/${itemData.CONTROLE}`)
            this.limparItem(true, result.data[0])
            this.gerarPesagemAlteracao()
            if (this.usarModalLotes) {
              if (String(this.item.OP_CONTROLA_LOTE || '0').trim() === '1') {
                await this.carregarLotesDisponiveis()
              } else {
                this.modalLotes.items = []
              }
              this.$refs['modalItemLote'].show()
            } else {
              this.$refs['modalItem'].show()
            }
          } catch (err) {
            Tools.exibirMensagem(this.$store, 'Erro', 'danger', `Não foi possível carregar o item!! ${err.message || err}`)
          } 
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
      }
    },
    montarTabelaItens(itens) {
      this.tabelaItens.items = []
          
      if ( (itens) && (itens.length) ) {

        const dados = itens
        for (let i = 0; i < dados.length; i++) {
          
          if ((dados[i].VL_UNT) && (dados[i].VL_UNT > 0) ) {
              dados[i].VL_UNT = dados[i].VL_UNT.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2})
          }
          
          this.tabelaItens.items.push(dados[i])
        }  
      }
    },
    async verificarItemDuplicado(vendaId, produtoId) {
      try {
        const itensDuplicados = await this.$http.post(`/api/protected/venda/item/verificarDuplicados`, {vendaId, produtoId})
        if (itensDuplicados.data.length && itensDuplicados.data[0].EXISTE && itensDuplicados.data[0].EXISTE > 0) { 
          return true
        } else {
          return false
        }
      } catch (err) {
        return true
      }
    },
    async postItem() {
      if (! this.avisosItem()) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', `Preencha todas as informações OBRIGATÓRIAS!!!` )
        return  
      }
      try {
        this.$store.commit('controle/setAguardando', true)
        this.item.SEQUENCIA = this.venda.SEQUENCIA
        this.limparPesagemEmBranco()

        const pacote = {
          venda: this.montarPayloadVenda(),
          item: this.item,
          pesagem: this.pesagem.items
        }

        try {
          await this.$http.post(`/api/protected/venda/item/post`, pacote)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }

        try {
          const response = await this.$http.get('/api/protected/venda/item/getListagemByVenda/' + this.venda.SEQUENCIA)
          this.montarTabelaItens(response.data)
        } catch(err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }
        try {
          const sincronizacao = await this.sincronizarVendaComRecalculo({
            atualizarItens: true,
            exibirToastTotalAlterado: true
          })

          if (!sincronizacao.ok) {
            return
          }

          this.$refs['modalItem'].hide()
        } catch(err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }
        this.$refs['modalItem'].hide()
        
        
      } finally {
          this.$store.commit('controle/setAguardando', false)
      }
    },
    editItem(){
      this.$store.commit('controle/setAguardando', true)
      this.item.SEQUENCIA = this.venda.SEQUENCIA
      this.limparPesagemEmBranco()
      
      let pacote = {
        venda : this.montarPayloadVenda(),
        item : this.item,
        pesagem : this.pesagem.items
      }
      this.$http.post(`/api/protected/venda/item/edit`, pacote)
      .then(async () =>{
        try {
          const sincronizacao = await this.sincronizarVendaComRecalculo({
            atualizarItens: true,
            exibirToastTotalAlterado: true
          })

          if (!sincronizacao.ok) {
            return
          }

          this.$refs['modalItem'].hide()
        } catch (erro) {
          this.$refs['modalItem'].hide()
          this.toastCount++
          this.$root.$bvToast.toast(`Falha ao executar ao Alterar o Item da Venda!! ${erro}`, {
            title: 'Erro',
            autoHideDelay: 15000,
            variant: 'danger',
            appendToast: true
          })
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
      })
      .catch(erro => {
        this.toastCount++
        this.$root.$bvToast.toast(`Falha ao alterar o Produto!! ${erro.response && erro.response.data ? erro.response.statusText : ''}`, {
          title: 'Erro',
          autoHideDelay: 15000,
          variant: 'danger',
          appendToast: true
        })
        this.$refs['modalItem'].hide()
        this.$store.commit('controle/setAguardando', false)
      })

    },
    async deleteItem(){
      this.$store.commit('controle/setAguardando', true)
      this.venda.SITUACAO = '2' //LANCANDO
      let pacote = {
        venda: this.montarPayloadVenda(),
        item: this.itemExcluir
      }
      try { 
        try {
          await this.$http.post(`/api/protected/venda/item/delete`, pacote)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err )
          return
        }
        const sincronizacao = await this.sincronizarVendaComRecalculo({
          atualizarItens: true,
          exibirToastTotalAlterado: true
        })

        if (!sincronizacao.ok) {
          return
        }
        
      } finally {
        this.$refs['modal-excluir-item'].hide()
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    gerarComboParcelas() {
      this.parcelasVezes = [] 
      for (let i = 0; i < 48; i++) {
        this.parcelasVezes.push({ value: (i+1).toString() , text: (i+1)+'X' })
      }
    },
    gerarDias() {
      this.dias = [] 
      this.dias.push({ value: null , text: '' })
      this.dias.push({ value: '0' , text: ' 0' })
      for (let i = 0; i < 60; i++) {
        this.dias.push({ value: (i+1).toString() , text: (i+1)+' dias' })
      }
      this.dias.push({ value: '120' , text: ' 120 dias' })
      this.dias.push({ value: '150' , text: ' 150 dias' })
      this.dias.push({ value: '180' , text: ' 180 dias' })
      this.dias.push({ value: '210' , text: ' 210 dias' })
      this.dias.push({ value: '240' , text: ' 240 dias' })
      this.dias.push({ value: '270' , text: ' 270 dias' })
      this.dias.push({ value: '300' , text: ' 300 dias' })
      this.dias.push({ value: '360' , text: ' 360 dias' })
    }, 

    async finalizarVenda(){
      if (!this.avisosVenda()) return

      this.$store.commit('controle/setAguardando', true)

      try {
        const recalculoFinal = await this.sincronizarVendaComRecalculo({
          salvarVenda: true,
          atualizarItens: true,
          exibirToastTotalAlterado: true
        })

        if (!recalculoFinal.ok) {
          return
        }

        if (this.venda.OP_FORMA_PAGTO === 'P' && !this.parcelamentoConfereComTotal()) {
          Tools.exibirMensagem(
            this.$store,
            'Aviso',
            'warning',
            'O total da prefatura foi recalculado. Clique em Parcelar novamente para atualizar as parcelas antes de finalizar.'
          )
          return
        }

        let pacote = {
          venda: this.montarPayloadVenda(),
          vendaEmAlteracao: this.vendaEmAlteracao || false,
          parcelamento: this.tabelaParcelamento.items,
          login: window.localStorage.getItem('login')
        }

        try {
          await this.$http.post(`/api/protected/venda/finalizar`, pacote)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
          return
        }
        
        // Atualiza a lista no store para que VendaListagem já tenha os dados atualizados
        await this.$store.dispatch('venda/GERAR_LISTA')

        // Gera a fatura HTML
        let faturaGerada = false
        try {
          await imprimirFaturaVenda(this.venda.SEQUENCIA, this.$http)
          faturaGerada = true
        } catch (err) {
          console.error('Erro ao gerar relatório:', err)
        }
        
        // Exibe mensagem de sucesso
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Venda finalizada com sucesso!')
        
        // Define o registro selecionado para destacar na listagem
        this.$store.commit('venda/SET_REGISTRO_SELECIONADO_ID', this.venda.SEQUENCIA)
        
        this.venda.SITUACAO = '1'
        this.controles.fechada = true
        
        
        // Se impressão direta ativa e fatura não foi ainda exibida, tenta novamente
        if (!faturaGerada && this.parametros.OP_IMPRIME_VENDA_DIRETO === '1') {
          setTimeout(async () => {
            try {
              await imprimirFaturaVenda(this.venda.SEQUENCIA, this.$http)
            } catch (e) {
              console.error('Erro ao imprimir fatura:', e)
            }
          }, 500)
        }
        
      } catch (err) {
        console.error('Erro ao finalizar venda:', err)
        Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Erro ao finalizar venda')
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    /*
    gerarParcelamento() {
      if (this.controles.fechada) {
        return
      }

      if (
             this.venda.VL_TOTAL_NFE === null 
          || this.venda.VL_TOTAL_NFE === ''
          || this.venda.VL_TOTAL_NFE <= 0.00) {
        return
      }
      let auxParcelas, 
        valordaParcela, 
        valordaUltimaParcela, 
        diferenca = 0.00

      this.tabelaParcelamento.items = []
      
      // AVISTA
      if (this.venda.OP_FORMA_PAGTO === 'V') {
        this.tabelaParcelamento.items.push({
          ID_VENDAS : this.venda.SEQUENCIA,
          PARCELA : 1,
          VENCIMENTO : new Date(),
          VALOR : parseFloat(this.venda.VL_TOTAL_NFE),
          JUROS : 0.00
        })
        return  
      }
      // A PRAZO
      valordaParcela =  parseFloat(parseFloat(this.venda.VL_TOTAL_NFE) / parseFloat(this.venda.NR_PARCELAS)).toFixed(2)
      valordaUltimaParcela = parseFloat(parseFloat(this.venda.VL_TOTAL_NFE) / parseFloat(this.venda.NR_PARCELAS)).toFixed(2)

      diferenca = parseFloat(valordaParcela * this.venda.NR_PARCELAS) - (this.venda.VL_TOTAL_NFE)

      if (diferenca > 0) {
        valordaUltimaParcela = valordaParcela - diferenca
      }
      else if (diferenca < 0) {
        valordaUltimaParcela = valordaParcela + diferenca
      }


      if (this.venda.OP_FORMA_PAGTO === 'V') {
        auxParcelas = 1
      } else {
        auxParcelas = this.venda.NR_PARCELAS
      }
      for (let i = 0; i < auxParcelas; i++) {
        let vencimento;
        
        // Se o pagamento é à vista (V), define o vencimento como a data atual
        if (this.venda.OP_FORMA_PAGTO === 'V') {
            vencimento = new Date();
        }
        // Se o pagamento for mensal, use 'month' para adicionar meses corretamente
        else if (this.venda.PAG1 === '30') {
            vencimento = moment(new Date()).add(i + 1, 'months');
        }
        // Caso contrário, adiciona dias (pagamentos não mensais)
        else {
            vencimento = moment(new Date()).add((this.venda.PAG1 * (i + 1)), 'days');
        }
        
        this.tabelaParcelamento.items.push({
            ID_VENDAS: this.venda.SEQUENCIA,
            PARCELA: i + 1,
            VENCIMENTO: vencimento.format('YYYY-MM-DD'), // Formatando a data no padrão desejado
            VALOR: parseFloat(valordaParcela),
            JUROS: 0.00
        });
        
        // Ajusta o valor da última parcela
        if (i === auxParcelas - 1) {
            this.tabelaParcelamento.items[i].VALOR = parseFloat(valordaUltimaParcela);
        }
      }

    }*/
   gerarParcelamento() {

    if (this.controles.fechada) return

    const total = parseFloat(this.venda.VL_TOTAL_NFE)
    const parcelas = parseInt(this.venda.NR_PARCELAS)
    const dataInicial = this.venda.DT_INICIAR_PAGAMENTO 
                        ? moment(this.venda.DT_INICIAR_PAGAMENTO)
                        : null

    // Sempre limpa a tabela primeiro
    this.tabelaParcelamento.items = []

    if (!total || total <= 0 || !parcelas || parcelas <= 0) return

      // PAGAMENTO À VISTA
      if (this.venda.OP_FORMA_PAGTO === 'V') {
        if (!this.venda.DT_PREVISAO_ENTREGA) return
        this.tabelaParcelamento.items.push({
          ID_VENDAS: this.venda.SEQUENCIA,
          PARCELA: 1,
          VENCIMENTO: this.venda.DT_PREVISAO_ENTREGA,
          VALOR: parseFloat(total.toFixed(2)),
          JUROS: 0.00
        })
        return
      }

      // PAGAMENTO A PRAZO
      if (!dataInicial) return

      let valorParcela = parseFloat((total / parcelas).toFixed(2))
      let somaParcelas = parseFloat((valorParcela * parcelas).toFixed(2))
      let diferenca = parseFloat((total - somaParcelas).toFixed(2))
      let valorUltimaParcela = parseFloat((valorParcela + diferenca).toFixed(2))

      for (let i = 0; i < parcelas; i++) {
        let vencimento

        const diasEntre = parseInt(this.venda.PAG1 || 0)
        vencimento = moment(dataInicial).add(i * diasEntre, 'days')

        this.tabelaParcelamento.items.push({
          ID_VENDAS: this.venda.SEQUENCIA,
          PARCELA: i + 1,
          VENCIMENTO: vencimento.format('YYYY-MM-DD'),
          VALOR: i === parcelas - 1 ? valorUltimaParcela : valorParcela,
          JUROS: 0.00
        })
      }
    },

    abrirModaldeleteItem(item) { 
      this.$store.commit('controle/setAguardando', true)
      this.itemExcluir.CODIGO_NOME_PRODUTO = item.CODIGO_NOME_PRODUTO
      this.itemExcluir.CONTROLE = item.CONTROLE
      this.$http.get('/api/protected/venda/item/getById/'+this.itemExcluir.CONTROLE)
      .then(result => {
         this.itemExcluir.CONTROLE = result.data[0].CONTROLE
         this.itemExcluir.COD_PRO = result.data[0].COD_PRO
         this.itemExcluir.COD_CENTRO = result.data[0].COD_CENTRO
         this.itemExcluir.QUANT = result.data[0].QUANT
         this.itemExcluir.PECAS = result.data[0].PECAS
         this.itemExcluir.TX_UNIDADE_COMERCIAL = result.data[0].ID_UNIDADE_COMERCIAL
         this.itemExcluir.VL_UNT = result.data[0].VL_UNT
         this.itemExcluir.VL_DESCONTO = result.data[0].VL_DESCONTO
         this.itemExcluir.VL_TOTAL_BRUTO = result.data[0].VL_TOTAL_BRUTO
         
         this.itemExcluir.QUANT_MASK          = result.data[0].QUANT ? result.data[0].QUANT.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0.00
         this.itemExcluir.VL_UNT_MASK         = result.data[0].VL_UNT ? result.data[0].VL_UNT.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
         this.itemExcluir.VL_DESCONTO_MASK    = result.data[0].VL_DESCONTO ? result.data[0].VL_DESCONTO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
         this.itemExcluir.VL_TOTAL_BRUTO_MASK = result.data[0].VL_TOTAL_BRUTO ? result.data[0].VL_TOTAL_BRUTO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
         
         this.$store.commit('controle/setAguardando', false)
         this.$refs['modal-excluir-item'].show()
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        this.toastCount++
        this.$root.$bvToast.toast(`O sistema não localizou o item !! ${erro}`, {
          title: 'Erro',
          autoHideDelay: 3000,
          variant: 'danger',
          appendToast: true
        })
       
      })
    },
    async abrirModalReabrir() {
      try {
        this.$store.commit('controle/setAguardando', true)
        
        let permiteAlterarResult = null
        try {
          permiteAlterarResult = await this.$http.get(`/api/protected/venda/getPermiteAlterar/${this.venda.SEQUENCIA}`)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', err?.response?.data?.message || 'Erro ao verificar permissões')
          return
        }

        const sucesso = permiteAlterarResult?.data?.sucesso ?? false
        const tipo = permiteAlterarResult?.data?.tipo ?? ''
        const msg = permiteAlterarResult?.data?.msg ?? 'Operação não concluída'

        // Caso que abre modal de liberação de débitos (verificar primeiro, independente do sucesso)
        if (tipo === 'TITULO_LANCADO') {
          this.modalLiberarDebitos.motivo = null
          this.$refs['modal-liberar-debitos'].show()
          return
        }

        // Casos que abrem o modal de reabrir
        const tiposPermitir = ['SUCESSO', 'PERMITE_ALTERAR']
        if (sucesso && tiposPermitir.includes(tipo)) {
          this.venda.OBS3 = null
          this.$refs['modal-reabrir'].show()
          return
        }

        // Casos que só exibem mensagem
        const tiposBloquear = ['FALHA', 'PRAZO_EXCEDIDO', 'PEDIDO_CANCELADO', 'PEDIDO_INDISPONIVEL', 'FINANCEIRO_LANCADO']
        if (!sucesso || tiposBloquear.includes(tipo)) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', msg)
          return
        }

        // Caso padrão - exibir mensagem
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', msg)

      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    
    async reabrir() {
      if (!this.valOBS3) {
        this.toastCount++
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Motivo' )
        return
      }

      try {
        this.$store.commit('controle/setAguardando', true)
        let vendaReabrir = { 
          SEQUENCIA: this.venda.SEQUENCIA,
          OBS3: this.venda.OBS3,
          DT_ALTERACAO: Tools.getHoraAtual(),
          TX_USUARIO_ALTERACAO: window.localStorage.getItem('login'),
          VL_TOTAL_ANTES_ALTERACAO: this.venda.VL_TOTAL_NFE,
          SITUACAO: '2' //LANCANDO
         }
        try {

          await this.$http.post(`/api/protected/venda/edit`, vendaReabrir)
          
          Tools.exibirMensagem(this.$store, 'Aviso', 'success', 'Prefatura Reaberta com Sucesso! Recarregando venda...' )
          this.$refs['modal-reabrir'].hide()

          // Recarregar a tela de venda
          await this.recarregarVenda()
          
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Tente novamente' )
          return
        }

      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    focusModalReabrir(){
        this.$refs.edMotivoReabrir.focus()
    },
    focusModalLiberarDebitos(){
        this.$refs.edMotivoLiberarDebitos.focus()
    },
    async liberarDebitos() {
      if (!this.modalLiberarDebitos.motivo || this.modalLiberarDebitos.motivo.trim() === '') {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Motivo da Liberação')
        return
      }
      
      try {
        this.modalLiberarDebitos.parametros.overlayBaixando = true
        
        const payload = {
          usuario: window.localStorage.getItem('login'),
          motivo: this.modalLiberarDebitos.motivo,
          vendaId: this.venda.SEQUENCIA
        }
        
        try {
          await this.$http.post(`/api/protected/venda/liberarDebitos`, payload)
          
          Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Débitos liberados com sucesso! Recarregando venda...')
          this.$refs['modal-liberar-debitos'].hide()
          
          // Recarregar a tela de venda
          await this.recarregarVenda()
          
        } catch (err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Erro', 'danger', err?.response?.data?.message || 'Erro ao liberar débitos. Tente novamente')
          return
        }
      } finally {
        this.modalLiberarDebitos.parametros.overlayBaixando = false
      }
    },
    async recarregarVenda() {
      try {
        // Recarrega apenas os dados da venda, não a página inteira
        const vendaResponse = await this.$http.get(`/api/protected/venda/getById/${this.venda.SEQUENCIA}`)
        this.venda = vendaResponse?.data?.[0] ?? null
        
        if (!this.venda) {
          throw new Error('Falha ao recarregar dados da venda')
        }
        
        this.ajustarCamposTabelaVendas(this.venda)
        await this.atualizarStatusAcoesVenda()
        
        // Recarregar itens
        try {
          this.tabelaItens.items = await this.getItens()
        } catch (err) {
          console.error('Erro ao recarregar itens:', err)
        }
        
        // Recarregar parcelamento
        try {
          this.tabelaParcelamento.items = await this.getParcelamento()
        } catch (err) {
          console.error('Erro ao recarregar parcelamento:', err)
        }
        
        // Aplicar as mesmas regras do created para atualizar controles
        await this.atualizarControlesAposRecarregar()
        
      } catch (err) {
        console.error('Erro ao recarregar venda:', err)
        throw err
      }
    },
    async atualizarControlesAposRecarregar() {
      try {
        // Aplicar regra de fechada conforme tipo e situação da venda
        if (!this.venda.OP_PEDIDO || this.venda.OP_PEDIDO === '0') {
          if (['2'].includes(this.venda.SITUACAO)) {
            this.controles.fechada = false
          } else {
            this.controles.fechada = true
          }
        } else if (this.venda.OP_PEDIDO === '1') {
          if (['6'].includes(this.venda.SITUACAO)) {
            this.controles.fechada = false
          } else {
            this.controles.fechada = true
          }
        } else if (this.venda.OP_PEDIDO === '2') {
          this.controles.fechada = true
        } else {
          this.controles.fechada = true
        }
        
        // Atualizar flags de controle
        this.controles.vendaEmAlteracao = true
        this.controles.vendaReaberta = true
        
        // Atualizar dados do cliente se necessário
        if (this.venda.COD_CLI) {
          await this.atualizarCliente()
        }
        
        // Atualizar dias prazo se houver datas
        if (this.venda.DT_PREVISAO_ENTREGA && this.venda.DT_INICIAR_PAGAMENTO) {
          this.atualizarDiasPrazo(this.venda.DT_INICIAR_PAGAMENTO)
        }
        
        await this.$nextTick()
        
      } catch (err) {
        console.error('Erro ao atualizar controles após recarregar:', err)
      }
    },
    focusModaldeleteItem(){

    },
    focusTabPesagem() {
      // Acessa o input encapsulado e aplica o foco
      this.$nextTick(() => {
        if (this.$refs.edPeso && this.$refs.edPeso.$el) {
          this.$refs.edPeso.$el.focus()
          this.$refs.edPeso.$el.select()
        }
      })
    },
    focusModalItem() {
      this.$nextTick(() => {
        if (this.controles.itemAlteracao) {
          this.$refs.edQuant.$el.focus()
        } else {
          this.$refs.edCOD_PRO.$refs.auto.$refs.autocomplete.focus()
        }
      })
    },
    focusModalItemLote() {
      this.$nextTick(() => {
        if (!this.controles.itemAlteracao) {
          if (this.$refs.edCOD_PRO_LOTE) {
            this.$refs.edCOD_PRO_LOTE.$refs.auto.$refs.autocomplete.focus()
          }
        }
      })
    },
    async carregarLotesDisponiveis() {
      this.modalLotes.carregando = true
      try {
        const controle = this.item.CONTROLE || '0'
        const centroId = this.item.COD_CENTRO || ''
        const response = await this.$http.get(`/api/protected/ordemexpedicao/getLotesDisponiveisPorItem/${controle}/${this.item.COD_PRO}?centroId=${centroId}`)
        this.modalLotes.items = response.data.map(l => ({
          ...l,
          QUANT_PLANEJADA: Number(l.QUANT_PLANEJADA || 0)
        }))
      } catch (err) {
        this.$root.$bvToast.toast('Erro ao carregar lotes: ' + (err.message || err), { title: 'Erro', variant: 'danger', autoHideDelay: 5000, appendToast: true })
      } finally {
        this.modalLotes.carregando = false
      }
    },
    avisosItemLote() {
      if (!this.valCOD_PRO) {
        this.$root.$bvToast.toast('Informe o produto!', { title: 'Campo Obrigatório', variant: 'warning', autoHideDelay: 5000, appendToast: true })
        return false
      }
      if (String(this.item.OP_CONTROLA_LOTE || '0').trim() === '1') {
        if (this.somaLotesItem <= 0) {
          this.$root.$bvToast.toast('Informe as quantidades dos lotes!', { title: 'Campo Obrigatório', variant: 'warning', autoHideDelay: 5000, appendToast: true })
          return false
        }
        for (const lote of this.modalLotes.items) {
          if (Number(lote.QUANT_PLANEJADA) > Number(lote.QUANT_SALDO)) {
            this.$root.$bvToast.toast(`Lote ${lote.LOTE}: quantidade informada excede o saldo disponível!`, { title: 'Aviso', variant: 'warning', autoHideDelay: 5000, appendToast: true })
            return false
          }
        }
      } else {
        if (!this.valQUANT) {
          this.$root.$bvToast.toast('Informe a quantidade!', { title: 'Campo Obrigatório', variant: 'warning', autoHideDelay: 5000, appendToast: true })
          return false
        }
        if (!this.valVL_UNT) {
          this.$root.$bvToast.toast('Informe o preço unitário!', { title: 'Campo Obrigatório', variant: 'warning', autoHideDelay: 5000, appendToast: true })
          return false
        }
      }
      return true
    },
    onLoteChange() {
      this.item.QUANT = this.somaLotesItem
      this.somarTotalItem()
    },
    vincularSaldoLote(lote) {
      lote.QUANT_PLANEJADA = Number(lote.QUANT_SALDO || 0)
      this.onLoteChange()
    },
    async postItemLote() {
      if (!this.avisosItemLote()) return
      const controlaLote = String(this.item.OP_CONTROLA_LOTE || '0').trim() === '1'
      if (controlaLote) {
        this.item.QUANT = this.somaLotesItem
        this.somarTotalItem()
      }
      this.$store.commit('controle/setAguardando', true)
      try {
        this.item.SEQUENCIA = this.venda.SEQUENCIA
        const pacote = {
          venda: this.montarPayloadVenda(),
          item: this.item,
          pesagem: this.pesagem.items
        }
        const postResponse = await this.$http.post('/api/protected/venda/item/post', pacote)
        if (controlaLote) {
          const controle = postResponse.data?.CONTROLE || postResponse.data?.[0]?.CONTROLE
          if (controle) {
            await this.$http.post('/api/protected/ordemexpedicao/salvarVinculoLoteItem', {
              controle,
              lotes: this.modalLotes.items.filter(l => Number(l.QUANT_PLANEJADA) > 0),
              usuario: window.localStorage.getItem('login')
            })
          }
        }
        const sincronizacao = await this.sincronizarVendaComRecalculo({
          atualizarItens: true,
          exibirToastTotalAlterado: true
        })
        if (!sincronizacao.ok) return
        this.$refs['modalItemLote'].hide()
      } catch (err) {
        const msg = err?.response?.data?.message || err?.response?.data || err.message || err
        this.$root.$bvToast.toast(`Falha: ${msg}`, { title: 'Erro', variant: 'danger', autoHideDelay: 5000, appendToast: true })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async editItemLote() {
      if (!this.avisosItemLote()) return
      const controlaLote = String(this.item.OP_CONTROLA_LOTE || '0').trim() === '1'
      if (controlaLote) {
        this.item.QUANT = this.somaLotesItem
        this.somarTotalItem()
      }
      this.$store.commit('controle/setAguardando', true)
      try {
        const pacote = {
          venda: this.montarPayloadVenda(),
          item: this.item,
          pesagem: this.pesagem.items
        }
        await this.$http.post('/api/protected/venda/item/edit', pacote)
        if (controlaLote) {
          await this.$http.post('/api/protected/ordemexpedicao/salvarVinculoLoteItem', {
            controle: this.item.CONTROLE,
            lotes: this.modalLotes.items.filter(l => Number(l.QUANT_PLANEJADA) > 0),
            usuario: window.localStorage.getItem('login')
          })
        }
        const sincronizacao = await this.sincronizarVendaComRecalculo({
          atualizarItens: true,
          exibirToastTotalAlterado: true
        })
        if (!sincronizacao.ok) return
        this.$refs['modalItemLote'].hide()
      } catch (err) {
        const msg = err?.response?.data?.message || err?.response?.data || err.message || err
        this.$root.$bvToast.toast(`Falha: ${msg}`, { title: 'Erro', variant: 'danger', autoHideDelay: 5000, appendToast: true })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    focarCliente() {
      if (this.controles.fechada) return
      
      // Função recursiva com retentativa para garantir o foco
      const tentarFocar = (tentativa = 1) => {
        this.$nextTick(() => {
            try {
              const input = this.$refs.edCOD_CLI?.$refs?.auto?.$refs?.autocomplete
              
              if (input && !input.disabled) {
                  input.focus()
                  
                  // Se o foco pegou, seleciona o texto e encerra
                  if (document.activeElement === input) {
                      if (typeof input.select === 'function') {
                        input.select()
                      }
                      return 
                  }
              }
            } catch (err) {
              console.warn('Tentativa de foco falhou:', err)
            }

            // Se não pegou o foco, tenta novamente (limite de 5 tentativas)
            if (tentativa < 5) {
                setTimeout(() => tentarFocar(tentativa + 1), 500)
            }
        })
      }

      // Inicia o processo
      setTimeout(() => tentarFocar(), 300)
    },
    focusTabProduto() {
    /*
      if (this.$refs.edCOD_PRO) {
        this.$refs.edCOD_PRO.$refs.auto.$refs.autocomplete.focus()
      } else {
      }
    */
   
    },
    /** ****************************** ICMS ***************************************** */
    regraOP_ICMS_SITUACAO_TRIBUTARIA() {
      this.icms.habilitado.comboOP_ICMS_SITUACAO_TRIBUTARIA = false
      this.icms.habilitado.comboOP_ICMS_ORIGEM              = false 

      //Grupo ICMS Normal}
      this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = false
      this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC       = false
      this.icms.habilitado.edVL_ICMS_BASE_CALC              = false
      this.icms.habilitado.edVL_ICMS_ALIQUOTA               = false
      this.icms.habilitado.edVL_ICMS_PERC_BC_OPER_PROPRIA   = false
      this.icms.habilitado.edVL_ICMS                        = false

      this.icms.habilitado.comboOP_MOTIVO_DESONERACAO       = false

      //Grupo ICMS Normal ST}
      this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = false
      this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = false
      this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = false
      this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = false
      this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = false
      this.icms.habilitado.edVL_ICMS_ST                     = false
      this.icms.habilitado.comboID_UF_ICMS_ST               = false

      //Grupo ICMS Simples}
      this.icms.habilitado.edVL_ALIQ_APLICAVEL_CALC_CREDITO = false
      this.icms.habilitado.edVL_CREDITO_ICMS_APROVEITADO    = false

      //Grupo ICMS Simples ST}
      this.icms.habilitado.edVL_ICMS_BC_ST_RETIDO_ANT       = false
      this.icms.habilitado.edVL_ICMS_ST_RETIDO_ANT          = false

      if (this.item.COD_PRO && this.item.COD_PRO > 0 ) {
        this.icms.habilitado.comboOP_ICMS_SITUACAO_TRIBUTARIA = true
        this.icms.habilitado.comboOP_ICMS_ORIGEM              = true
        switch (this.item.OP_ICMS_SITUACAO_TRIBUTARIA) {
          case '00' : //ICMS 00}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.edVL_ICMS                        = true
            break
          case '10': // ICMS 10}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.edVL_ICMS                        = true

            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true
            break
          case '20': //{ICMS 20}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC       = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.EdVL_ICMS                        = true
            break
          case '30': //ICMS 30}
            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.EdVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true
            break
          case '40': //ICMS 40}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_MOTIVO_DESONERACAO       = true
            break
          case '41': //ICMS 41}
            //Grupo ICMS Normal}
            this.icms.habilitado.edVL_ICMS_BC_ST_RETIDO_ANT       = true
            this.icms.habilitado.edVL_ICMS_ST_RETIDO_ANT          = true
            this.icms.habilitado.comboOP_MOTIVO_DESONERACAO       = true
            break
          case '50': //ICMS 50}
            //Grupo ICMS Normal}
            break
          case '51': //ICMS 51}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC       = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.edVL_ICMS                        = true
            this.icms.habilitado.edVL_ICMS_BC_ST_RETIDO_ANT       = true
            this.icms.habilitado.edVL_ICMS_ST_RETIDO_ANT          = true
            this.icms.habilitado.comboOP_MOTIVO_DESONERACAO       = true
            break
          case '60': //ICMS 60}
            //Grupo ICMS Simples ST}
            this.icms.habilitado.edVL_ICMS_BC_ST_RETIDO_ANT       = true
            this.icms.habilitado.edVL_ICMS_ST_RETIDO_ANT          = true
            break
          case '70': //ICMS 70}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC       = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.edVL_ICMS                        = true

            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true
          break
          case '90': //ICMS 90}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC       = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.edVL_ICMS                        = true

            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true
            this.icms.habilitado.comboID_UF_ICMS_ST               = true
            break

          case '101': //ICMS 101}
            //Grupo ICMS Simples}
            this.icms.habilitado.edVL_ALIQ_APLICAVEL_CALC_CREDITO = true
            this.icms.habilitado.edVL_CREDITO_ICMS_APROVEITADO    = true
            break
          case '102': //ICMS 102}
            break
          case '103': //ICMS 103}
            break
          case '201': // ICMS 201}
            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true

            //Grupo ICMS Simples}
            this.icms.habilitado.edVL_ALIQ_APLICAVEL_CALC_CREDITO = true
            this.icms.habilitado.edVL_CREDITO_ICMS_APROVEITADO    = true
            break
          case '202': //ICMS 202}
            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true
            break
          case '203': //ICMS 203}
            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true
            break
          case '300': //ICMS 300}
            break
          case '400': //ICMS 400}
            break
          case '500': //ICMS 500}
            //Grupo ICMS Simples ST}
            this.icms.habilitado.edVL_ICMS_BC_ST_RETIDO_ANT       = true
            this.icms.habilitado.edVL_ICMS_ST_RETIDO_ANT          = true
            break
          case '900': //ICMS 900}
            //Grupo ICMS Normal}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC     = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC       = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC              = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA               = true
            //this.icms.habilitado.edVL_ICMS                        = true

            //Grupo ICMS Normal ST}
            this.icms.habilitado.comboOP_ICMS_MODAL_DETERM_BC_ST  = true
            this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST    = true
            this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST      = true
            this.icms.habilitado.edVL_ICMS_BASE_CALC_ST           = true
            this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST            = true
            this.icms.habilitado.edVL_ICMS_ST                     = true

            //Grupo ICMS Simples}
            this.icms.habilitado.edVL_ALIQ_APLICAVEL_CALC_CREDITO = true
            this.icms.habilitado.edVL_CREDITO_ICMS_APROVEITADO    = true
            break
          default:
        }
      }
    },
    /*calculaICMSeIPIGeral() {

      //Não calcula nada ate que o produto seja criado no promise que pega os dados do produto
      if (this.controles.montandoItem == true) {
        return
      }

      let
        frete, seguro, despesas, totalBruto, ipiAliquota, ipiBC,
        ipiTotal, icmsBC, icmsTotal, icmsSTBC, icmsSTTotal, icmsReducao,
        icmsAliquota, icmsMVAAliquota, icmsMVA, icmsSTReducao,
        icmsSTAliquota 

      frete = 0.00
      seguro = 0.00
      despesas = 0.00
      totalBruto = this.item.VL_TOTAL_BRUTO?? 0.00

      ipiBC = totalBruto + seguro + despesas
      if (this.cliente.FIZ_JUR === '0') {
        ipiBC = ipiBC + frete
      }

      // BASE CALC DO IPI*********************************************************** 
      // Se a transportadora NÃO for da empresa emitente então deve-se retirar o frete 
      ipiAliquota = this.item.VL_IPI_ALIQUOTA

      ipiTotal = 0.00
      if (ipiAliquota > 0.00) {
        ipiTotal = ((ipiBC / 100.00) * ipiAliquota )
      }

      icmsReducao = this.item.VL_ICMS_PERCENT_REDUC_BC
      icmsAliquota = this.item.VL_ICMS_ALIQUOTA

      // BASE CALC DO ICMS************************************************************ 
      // Produto para consumo da industria não acrescentao o IPI na Base de Calculo 
      icmsBC = totalBruto
      if (this.cliente.FIZ_JUR === '0') {
        icmsBC = totalBruto + ipiTotal
      }

      if (icmsReducao > 0.00) {
        icmsBC = icmsBC - ((totalBruto / 100.00) * icmsReducao )
      }

      icmsTotal = 0.00
      if (icmsAliquota > 0)  {
        icmsTotal = ((icmsBC / 100.00) * icmsAliquota)
      }
      // MVA ************************************************************************* 
      icmsMVAAliquota = this.item.VL_ICMS_MARGEM_VL_ADIC_ST
      icmsMVA = 0.00
      if (icmsMVAAliquota > 0.00) {
        icmsMVA = ((icmsBC / 100.00) * icmsMVAAliquota)
      }

      // BASE CALC DO ICMS ST********************************************************** 
      icmsSTReducao = this.item.VL_ICMS_PERCENT_REDUC_BC_ST
      icmsSTAliquota = this.item.VL_ICMS_ALIQUOTA_ST
      icmsSTBC = ipiTotal + icmsBC + icmsMVA

      if (icmsSTReducao > 0.00) {
        icmsSTBC = icmsSTBC - ((icmsSTBC / 100.00  ) * icmsSTReducao )
      }

      icmsSTTotal = ((icmsSTBC /100.00) * icmsSTAliquota ) - icmsTotal

      // Atualizar Valores

      this.item.VL_IPI_BASE_CALC      = null
      this.item.VL_IPI_ALIQUOTA       = null
      this.item.VL_IPI                = null
      this.item.VL_ICMS_BASE_CALC     = null
      this.item.VL_ICMS               = null
      this.item.VL_ICMS_BASE_CALC_ST  = null
      this.item.VL_ICMS_ST            = null

      // IPI
      if (this.item.OP_IPI_TIPO_CALCULO === '1') {
        this.item.VL_IPI_ALIQUOTA = ipiAliquota
        this.item.VL_IPI_BASE_CALC = ipiBC
        this.item.VL_IPI = ipiTotal
      }

      // ICMS
      this.item.VL_ICMS_BASE_CALC = null
      this.item.VL_ICMS           = null
      this.item.OP_ICMS_SITUACAO_TRIBUTARIA + ''
      var aux = "00,10,20,70".split(",")
      for (var i = 0; i < aux.length; i++) {
          switch(aux[i]){
              case this.item.OP_ICMS_SITUACAO_TRIBUTARIA:
                this.item.VL_ICMS_BASE_CALC = icmsBC
                this.item.VL_ICMS = icmsTotal
              break
          }
      }
      
      
      // ICMS ST
      this.item.VL_ICMS_BASE_CALC_ST = null
      this.item.VL_ICMS_ST = null
      var aux = "10,30,70,201,202,203".split(",")
      for (var i = 0; i < aux.length; i++) {
          switch(aux[i]){
              case this.item.OP_ICMS_SITUACAO_TRIBUTARIA:
                this.item.VL_ICMS_BASE_CALC_ST = icmsSTBC
                this.item.VL_ICMS_ST = icmsSTTotal
              break
          }
      }
    },*/

    limpaEditsSemValorICMSeIPI(){
      //ICMS
      if (!this.icms.habilitado.edVL_ICMS_BASE_CALC) {  this.item.VL_ICMS_BASE_CALC = null }
      if (!this.icms.habilitado.edVL_ICMS) { this.item.VL_ICMS = null }
      if (!this.icms.habilitado.edVL_ICMS_BASE_CALC_ST) { this.item.VL_ICMS_BASE_CALC_ST = null }
      if (!this.icms.habilitado.edVL_ICMS_ST) { this.item.VL_ICMS_ST = null }

      if (!this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC) { this.item.VL_ICMS_PERCENT_REDUC_BC = null }
      if (!this.icms.habilitado.edVL_ICMS_ALIQUOTA) { this.item.VL_ICMS_ALIQUOTA = null }
      if (!this.icms.habilitado.edVL_ICMS_MARGEM_VL_ADIC_ST) { this.item.VL_ICMS_MARGEM_VL_ADIC_ST = null }
      if (!this.icms.habilitado.edVL_ICMS_PERCENT_REDUC_BC_ST) {this.item.VL_ICMS_PERCENT_REDUC_BC_ST = null }
      if (!this.icms.habilitado.edVL_ICMS_ALIQUOTA_ST) { this.item.VL_ICMS_ALIQUOTA_ST = null }
      if (!this.icms.habilitado.edVL_ICMS_PERC_BC_OPER_PROPRIA) { this.item.VL_ICMS_PERC_BC_OPER_PROPRIA = null }
      if (!this.icms.habilitado.edVL_ICMS_BC_ST_RETIDO_ANT) { this.item.VL_ICMS_BC_ST_RETIDO_ANT = null }
      if (!this.icms.habilitado.edVL_ICMS_ST_RETIDO_ANT) { this.item.VL_ICMS_ST_RETIDO_ANT = null }
      if (!this.icms.habilitado.edVL_ALIQ_APLICAVEL_CALC_CREDITO) { this.item.VL_ALIQ_APLICAVEL_CALC_CREDITO = null }
      if (!this.icms.habilitado.edVL_CREDITO_ICMS_APROVEITADO) { this.item.VL_CREDITO_ICMS_APROVEITADO = null }
    },
    atualizarEstoqueProduto(){
      if (this.item.COD_CENTRO != null && this.item.COD_PRO != null) {
        this.$http.get(`/api/protected/estoque/listarResumoByProdutoIdCentroEstoqueId/${this.item.COD_PRO}/${this.item.COD_CENTRO}`)
        .then(result => {
          
          this.estoqueProduto.QUANT = result.data[0].QUANT && result.data[0].QUANT > 0 ? result.data[0].QUANT : 0.00
          this.estoqueProduto.PECAS = result.data[0].PECAS
        })
        .catch(() => {
          this.estoqueProduto.QUANT = 0.00
          this.estoqueProduto.PECAS = 0

          this.toastCount++
          this.$root.$bvToast.toast(`Não foi possível Atualizar o Estoque!!`, {
            title: 'Erro',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
        })
      } else {
        this.estoqueProduto.QUANT = 0.00
        this.estoqueProduto.PECAS = 0
      }
    },
    atualizarTabelaPesagem(){
      let linhas = 0
      // atualiza o ID
      for (let i = 0; i < this.pesagem.items.length; i++) {
        this.pesagem.items[i].ID = i + 1;
        linhas += 1
      }
      
      //Adiciona as linhas em branco
      for (let i = linhas; i < 30; i++) {
        this.pesagem.items.push(
          { ID: i + 1, COL1: null, COL2: null, COL3: null, COL4: null, COL5: null, COL6: null, COL7: null, COL8: null, COL9: null, COL10: null }
        )
        
      }

    },
    limparPesagemEmBranco(){
      let preenchidas = []
      let brancos = []
      for (let i = 0; i < this.pesagem.items.length; i++) {
       if ((this.pesagem.items[i].COL1  === null) && 
            (this.pesagem.items[i].COL2 === null) &&
            (this.pesagem.items[i].COL3 === null) &&
            (this.pesagem.items[i].COL4 === null) &&
            (this.pesagem.items[i].COL5 === null) &&
            (this.pesagem.items[i].COL6 === null) &&
            (this.pesagem.items[i].COL7 === null) &&
            (this.pesagem.items[i].COL8 === null) &&
            (this.pesagem.items[i].COL9 === null) &&
            (this.pesagem.items[i].COL10 === null)) {
         brancos.push(this.pesagem.items[i])     
        } else {
          preenchidas.push(this.pesagem.items[i])     
        }
      }
      this.pesagem.items = []
      this.pesagem.items =  preenchidas
      //let vendaAux = JSON.parse(JSON.stringify(this.venda))
    },
    gerarPesagemAlteracao(){
      this.$http.get(`/api/protected/venda/pesagem/getByVenda/${this.item.CONTROLE}`)
      .then(result => {
        this.pesagem.items = result.data
        
        // Verifica se há pesos individuais já cadastrados
        const colunas = ['COL1', 'COL2', 'COL3', 'COL4', 'COL5', 'COL6', 'COL7', 'COL8', 'COL9', 'COL10']
        let temPesosIndividuais = false
        
        for (let i = 0; i < this.pesagem.items.length && !temPesosIndividuais; i++) {
          for (let j = 0; j < colunas.length && !temPesosIndividuais; j++) {
            const coluna = colunas[j]
            const valor = this.pesagem.items[i][coluna]
            if (typeof valor === 'number' && valor > 0) {
              temPesosIndividuais = true
            }
          }
        }
        
        // Se houver pesos individuais, ativa o modo manual
        if (temPesosIndividuais) {
          this.pesagem.manual = true
        }
        
        this.atualizarTabelaPesagem()
        
      })
      
    },
    lancarPeso(){
      // Validação: não permite lançar pesos vazios ou zerados
      if (!this.pesagem.peso || parseFloat(this.pesagem.peso) <= 0) {
        this.$snotify.warning('Informe um peso válido maior que zero', 'Atenção');
        this.$refs.edPeso.$el.focus();
        this.$refs.edPeso.$el.select();
        return;
      }

      const colunas = ['COL1', 'COL2', 'COL3', 'COL4', 'COL5', 'COL6', 'COL7', 'COL8', 'COL9', 'COL10']
      const pesoNumerico = parseFloat(this.pesagem.peso)
      let pesoLancado = false

      // Procura a primeira célula vazia para adicionar o novo peso
      for (let i = 0; i < this.pesagem.items.length && !pesoLancado; i++) {
        for (let j = 0; j < colunas.length && !pesoLancado; j++) {
          const coluna = colunas[j]
          if (this.pesagem.items[i][coluna] === null || this.pesagem.items[i][coluna] === undefined) {
            // Adiciona o peso na célula vazia
            this.pesagem.items[i][coluna] = pesoNumerico
            pesoLancado = true
          }
        }
      }

      if (!pesoLancado) {
        this.$snotify.warning('Todas as células de pesagem estão preenchidas!', 'Atenção');
        this.pesagem.peso = ''
        return
      }

      // Recalcula QUANT e PECAS somando TODOS os pesos da tabela
      this.recalcularTotaisPesagem()
      
      // Marca como pesagem manual
      this.pesagem.manual = true
      
      // Limpa o campo e foca novamente
      this.pesagem.peso = ''
      this.$refs.edPeso.$el.focus();
      this.$refs.edPeso.$el.select();
    },
    excluirPeso(){
      const colunas = ['COL1', 'COL2', 'COL3', 'COL4', 'COL5', 'COL6', 'COL7', 'COL8', 'COL9', 'COL10']
      let pesoExcluido = false

      // Busca o último peso preenchido (de trás para frente)
      for (let i = this.pesagem.items.length - 1; i >= 0 && !pesoExcluido; i--) {
        for (let j = colunas.length - 1; j >= 0 && !pesoExcluido; j--) {
          const coluna = colunas[j]
          const valor = this.pesagem.items[i][coluna]
          
          if (typeof valor === 'number' && valor > 0) {
            // Limpa a célula
            this.pesagem.items[i][coluna] = null
            pesoExcluido = true
          }
        }
      }

      if (!pesoExcluido) {
        this.$snotify.info('Não há pesos para excluir', 'Informação')
        return
      }

      // Recalcula os totais
      this.recalcularTotaisPesagem()
      
      // Se não houver mais pesos, desativa o modo manual
      if (this.item.QUANT <= 0) {
        this.pesagem.manual = false
      }
    },
    limparCelulaPesagem(linhaId, coluna) {
      // Encontra o índice da linha pelo ID
      const index = this.pesagem.items.findIndex(item => item.ID === linhaId)
      
      if (index === -1) {
        return
      }

      const valorAtual = this.pesagem.items[index][coluna]
      if (valorAtual === null || valorAtual === undefined) {
        return
      }

      // Limpa a célula
      this.pesagem.items[index][coluna] = null
      
      // Recalcula os totais
      this.recalcularTotaisPesagem()
      
      // Se não há mais pesagens, desabilita o modo manual
      if (this.item.QUANT <= 0) {
        this.pesagem.manual = false
      }
    },
    recalcularTotaisPesagem() {
      // Função centralizada para recalcular QUANT e PECAS com base nos pesos individuais
      const colunas = ['COL1', 'COL2', 'COL3', 'COL4', 'COL5', 'COL6', 'COL7', 'COL8', 'COL9', 'COL10']
      let totalQuant = 0
      let totalPecas = 0

      for (let i = 0; i < this.pesagem.items.length; i++) {
        for (let j = 0; j < colunas.length; j++) {
          const coluna = colunas[j]
          const valor = this.pesagem.items[i][coluna]
          
          if (typeof valor === 'number' && valor > 0) {
            totalQuant += valor
            totalPecas += 1
          }
        }
      }

      this.item.QUANT = totalQuant
      this.item.PECAS = totalPecas
    },
    excluirPesagem(){
      const colunas = ['COL1', 'COL2', 'COL3', 'COL4', 'COL5', 'COL6', 'COL7', 'COL8', 'COL9', 'COL10']
      
      // Limpa todas as células de peso
      for (let i = 0; i < this.pesagem.items.length; i++) {
        for (let j = 0; j < colunas.length; j++) {
          const coluna = colunas[j]
          if (this.pesagem.items[i][coluna] !== null && this.pesagem.items[i][coluna] !== undefined) {
            this.pesagem.items[i][coluna] = null
          }
        }
      }
      
      this.item.QUANT = 0.00
      this.item.PECAS = 0
      this.pesagem.manual = false
      this.pesagem.liberadoParaEdicao = false
      
      this.$refs.edPeso.$el.focus();
      this.$refs.edPeso.$el.select();
    },
    onHidden_botaoParcelamento() {
      // Return focus to the button
      this.$refs.bt_gerarParcelamento.focus()
    },
    avisosVenda(){
      let retorno = true
      if (!this.venda.DT_SAIDA) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe a Data da Venda!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      }
      if (!this.venda.DT_PREVISAO_ENTREGA) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe a Data de Entrega!! `, {
          title: 'Campo ObrigatÃ³rio',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      }
      if (!this.valN_VENDA) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe o Número do Pedido!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (!this.valCOD_CLI) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe o Cliente!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (!this.valCOD_VENDEDOR) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe o Vendedor!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (!this.valCOD_CONFERENTE) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe o Conferente!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (!this.valCOD_MOTORISTA) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe o Motorista!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if (!this.valOP_FORMA_PAGTO) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Informe a forma de Pagamento!! `, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      if ((this.totalQuant <= 0.00)) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Adicione os Produtos!!`, {
          title: 'Aviso',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      } 
      // Validações de forma de pagamento
      if (this.venda.OP_FORMA_PAGTO === 'V') {
        // À Vista - Auto-ajuste para campos que ficam ocultos na UI
        // Isso resolve bloqueios em vendas vindas da expedição com dados inconsistentes
        if (Number(this.diasIniciarPagamento) !== 0) {
          this.diasIniciarPagamento = 0
        }
        if (Number(this.venda.NR_PARCELAS) !== 1) {
          this.venda.NR_PARCELAS = 1
        }
        if (Number(this.venda.PAG1) !== 0) {
          this.venda.PAG1 = 0
        }
        // Ajusta a data de início para a mesma data da venda
        if (this.venda.DT_PREVISAO_ENTREGA && this.venda.DT_INICIAR_PAGAMENTO !== this.venda.DT_PREVISAO_ENTREGA) {
          this.venda.DT_INICIAR_PAGAMENTO = this.venda.DT_PREVISAO_ENTREGA
        }

        // Garante que o parcelamento à vista exista (resolve erro de parcelamento vazio vindo da expedição)
        if (this.tabelaParcelamento.items.length === 0) {
          this.gerarParcelamento()
        }
      } else if (this.venda.OP_FORMA_PAGTO === 'P') {
        // A Prazo - validações (converter para número)
        const diasInicio = Number(this.diasIniciarPagamento)
        const numParcelas = Number(this.venda.NR_PARCELAS)
        const diasEntreParcelas = Number(this.venda.PAG1)
        
        if (!this.diasIniciarPagamento || diasInicio <= 0) {
          retorno = false
          this.toastCount++
          this.$root.$bvToast.toast(`Para pagamento A Prazo, informe Dias para Início Pagto (deve ser maior que 0)!!`, {
            title: 'Campo Obrigatório',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
        }
        if (!this.venda.NR_PARCELAS || numParcelas <= 0) {
          retorno = false
          this.toastCount++
          this.$root.$bvToast.toast(`Para pagamento A Prazo, informe o Nº de Parcelas (deve ser maior que 0)!!`, {
            title: 'Campo Obrigatório',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
        }
        // Validar dias entre parcelas
        if (numParcelas === 1 && diasEntreParcelas != 0) {
          retorno = false
          this.toastCount++
          this.$root.$bvToast.toast(`Para parcelamento em 1x, Dias entre Parcelas deve ser 0!!`, {
            title: 'Aviso',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
        }
        if (numParcelas > 1) {
          if (this.venda.PAG1 === null || this.venda.PAG1 === undefined || this.venda.PAG1 === '') {
            retorno = false
            this.toastCount++
            this.$root.$bvToast.toast(`Para parcelamento em múltiplas vezes, informe os Dias entre Parcelas!!`, {
              title: 'Campo Obrigatório',
              autoHideDelay: 5000,
              variant: 'warning',
              appendToast: true
            })
          } else if (diasEntreParcelas == 0) {
            retorno = false
            this.toastCount++
            this.$root.$bvToast.toast(`Para parcelamento em múltiplas vezes, Dias entre Parcelas não pode ser 0!!`, {
              title: 'Aviso',
              autoHideDelay: 5000,
              variant: 'warning',
              appendToast: true
            })
          } else if (diasEntreParcelas == 1) {
            retorno = false
            this.toastCount++
            this.$root.$bvToast.toast(`Para parcelamento em múltiplas vezes, Dias entre Parcelas não pode ser 1 dia!!`, {
              title: 'Aviso',
              autoHideDelay: 5000,
              variant: 'warning',
              appendToast: true
            })
          }
        }
      }

      // Validar se tem parcelamento (agora fora do bloco 'P' para cobrir também o 'V')
      if (!this.tabelaParcelamento.items || !this.tabelaParcelamento.items.length) {
        retorno = false
        this.toastCount++
        this.$root.$bvToast.toast(`Faça o parcelamento!!`, {
          title: 'Campo Obrigatório',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
      }

      return retorno
    },
    avisosItem(){
      return this.valCOD_PRO && this.valQUANT
    },
    
    onHidden_botaoGerarDocumento() {
      // Return focus to the button
      //console.log(this.$refs)
      this.$refs.ob_edDocumento.focus()
    },
    calcularPercentualLimiteCredito(){
      let credito = 0.00
      let usado = 0.00
      if (this.cliente.VL_CREDITO !== null && this.cliente.VL_CREDITO > 0) {
        credito = this.cliente.VL_CREDITO
      }
      if (this.cliente.LIMITE_CREDITO !== null && this.cliente.LIMITE_CREDITO > 0) {
        usado = this.cliente.LIMITE_CREDITO
      } 
      if (credito <= 0) {
        return 100
      } else {
        return 100 - ((credito - usado) / credito) * 100
      }
      
    },
    postProduto(){

    },
    post () {
      if ( !this.venda.SEQUENCIA || this.venda.SEQUENCIA === null || this.venda.SEQUENCIA === undefined ) {
        this.novo()
      } else {
        this.editar()
      }
    },
    showModalImposto () {
      this.$refs['modal-imposto'].show()
      
    },
    editar() {
      this.$store.commit('controle/setAguardando', true)
      this.controles.botaoGerarDocumento.busy = false
      

      if (!this.isValid) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        this.controles.botaoGerarDocumento.busy = false
        return
      }
      if (this.venda.SEQUENCIA > 0) {
      this.$http.post(`/api/protected/venda/edit`, this.montarPayloadVenda())
        .then(async response => {
          this.$store.commit('controle/setAguardando', true)
          this.$root.$bvToast.toast(`venda ATUALIZADO com Sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
          })
          await this.retornarParaListagemVenda({ replace: true })
        })
        .catch(erro => {
          this.$root.$bvToast.toast(`Falha ao executar a operação!! ` + erro, {
            title: 'Erro',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
          this.$store.commit('controle/setAguardando', false)
          this.controles.botaoGerarDocumento.busy = false
        })
      }
    },
    async atualizarProduto(clienteId, produtoId, tipoMovimentacaoId) {
      this.$store.commit('controle/setAguardando', true)
      let result = null
      try {
        result = await this.$http.get(`/api/protected/venda/item/getNovo/${clienteId}/${produtoId}/${tipoMovimentacaoId}`)
      } catch (err) {
        const mensagem = err.response?.data || err.message || 'Erro desconhecido'
        this.$store.commit('controle/setAguardando', false)
        throw new Error(mensagem)
      }

      const produtoBackEnd = result.data??null
      if (!produtoBackEnd) {
        this.$store.commit('controle/setAguardando', false)
        throw new Error('O produto não esta com os impostos cadastrados!')
      }
      this.$store.commit('controle/setAguardando', false)

      //this.item.CONTROLE                       : null, 
      //this.item.SEQUENCIA                      : null, 
      //this.item.COD_PRO                        : null, 
      //this.item.QUANT                          =  produtoBackEnd.QUANT                              ?? null
      
      //this.item.PECAS                          =  produtoBackEnd.PECAS                              ?? null
      //this.item.QUANT_PEDIDO                   =  produtoBackEnd.QUANT_PEDIDO                       ?? null
      //this.item.PECAS_PEDIDO                   =  produtoBackEnd.PECAS_PEDIDO                       ?? null
      this.item.COD_CENTRO                     =  this.item.COD_CENTRO ?? produtoBackEnd.COD_CENTRO                         ?? null
      this.item.EAN                            =  produtoBackEnd.EAN                                ?? null
      
      this.item.VL_UNT                         =  produtoBackEnd.VL_UNT                             ?? null
      this.item.VL_CUSTO                       =  produtoBackEnd.VL_CUSTO                           ?? null
      this.item.UND_PECAS                      =  produtoBackEnd.UND_PECAS                          ?? null
      
      this.item.DT_VENDA                       =  produtoBackEnd.DT_VENDA                           ?? null
      this.item.TIPO_CLI                       =  produtoBackEnd.TIPO_CLI                           ?? null
      this.item.MARCA                          =  produtoBackEnd.MARCA                              ?? null
      this.item.TIPO_VEN                       =  produtoBackEnd.TIPO_VEN                           ?? null
      this.item.ALTERA                         =  produtoBackEnd.ALTERA                             ?? null
      this.item.ITEM                           =  produtoBackEnd.ITEM                               ?? null
      this.item.VL_COMISSAO                    =  produtoBackEnd.VL_COMISSAO                        ?? null
      
      this.item.ICMS                           =  produtoBackEnd.ICMS                               ?? null
      this.item.IPI                            =  produtoBackEnd.IPI                                ?? null
      this.item.ISS                            =  produtoBackEnd.ISS                                ?? null
      this.item.IRRF                           =  produtoBackEnd.IRRF                               ?? null
      this.item.ICMSSUBSTITUI                  =  produtoBackEnd.ICMSSUBSTITUI                      ?? null
      this.item.FORMA                          =  produtoBackEnd.FORMA                              ?? null
      this.item.ID_CFOP                        =  produtoBackEnd.ID_CFOP                            ?? null
      this.item.OP_STATUS_PRECO                =  produtoBackEnd.OP_STATUS_PRECO                    ?? null
      this.item.VL_TOTAL_BRUTO                 =  produtoBackEnd.VL_TOTAL_BRUTO                     ?? null
      this.item.VL_TOTAL_DESCONTO              =  produtoBackEnd.VL_TOTAL_DESCONTO                  ?? null
      this.item.OP_COMPOE_VALOR_NFE            =  produtoBackEnd.OP_COMPOE_VALOR_NFE                ?? null
      this.item.TX_OBSERVACOES                 =  produtoBackEnd.TX_OBSERVACOES                     ?? null 
      this.item.OP_COMPOE_VALOR_NFE            =  produtoBackEnd.OP_COMPOE_VALOR_NFE                ?? null 
      this.item.VL_ICMS_BC_ST_RETIDO_ANT       =  produtoBackEnd.VL_ICMS_BC_ST_RETIDO_ANT           ?? null
      this.item.VL_ICMS_ST_RETIDO_ANT          =  produtoBackEnd.VL_ICMS_ST_RETIDO_ANT              ?? null
      this.item.VL_ICMS_PERC_BC_OPER_PROPRIA   =  produtoBackEnd.VL_ICMS_PERC_BC_OPER_PROPRIA       ?? null
      this.item.ID_UF_ICMS_ST                  =  produtoBackEnd.ID_UF_ICMS_ST                      ?? null 
      this.item.OP_MOTIVO_DESONERACAO          =  produtoBackEnd.OP_MOTIVO_DESONERACAO              ?? null 
      this.item.VL_ALIQ_APLICAVEL_CALC_CREDITO =  produtoBackEnd.VL_ALIQ_APLICAVEL_CALC_CREDITO     ?? null
      this.item.VL_CREDITO_ICMS_APROVEITADO    =  produtoBackEnd.VL_CREDITO_ICMS_APROVEITADO        ?? null
      this.item.VL_DESCONTO_PERC               =  produtoBackEnd.VL_DESCONTO_PERC                   ?? null
      this.item.TX_NCM                         =  produtoBackEnd.TX_NCM                             ?? null 
      this.item.TX_NOME_PRODUTO                =  produtoBackEnd.TX_NOME_PRODUTO                    ?? null 
      this.item.TX_UNIDADE_COMERCIAL           =  produtoBackEnd.TX_UNIDADE_COMERCIAL               ?? null 
      this.item.OP_OCORRENCIA_PRECO            =  produtoBackEnd.OP_OCORRENCIA_PRECO                ?? null 
      this.item.VL_DESCONTO                    =  produtoBackEnd.VL_DESCONTO                        ?? null 
      this.item.ID_UNIDADE_COMERCIAL           =  produtoBackEnd.ID_UNIDADE_COMERCIAL               ?? null 
      this.item.OP_TRIBUTACAO                  =  produtoBackEnd.OP_TRIBUTACAO                      ?? null 
      this.item.CEST                           =  produtoBackEnd.CEST                               ?? null 
      this.item.QUANT_BKP                      =  produtoBackEnd.QUANT_BKP                          ?? null 
      this.item.QUANT_RETORNO                  =  produtoBackEnd.QUANT_RETORNO                      ?? null 
      this.item.PECAS_BKP                      =  produtoBackEnd.PECAS_BKP                          ?? null 
      this.item.PECAS_RETORNO                  =  produtoBackEnd.PECAS_RETORNO                      ?? null 
      this.item.OBS_RETORNO                    =  produtoBackEnd.OBS_RETORNO                        ?? null 
      
      this.item.OP_TIPO_TABELA_PRECO           =  produtoBackEnd.OP_TIPO_TABELA_PRECO               ?? null
      this.item.OP_REPESAR                     =  produtoBackEnd.OP_REPESAR                         ?? null
      this.item.OP_CONTROLA_LOTE               =  String(produtoBackEnd.OP_CONTROLA_LOTE ?? '0').trim()
          
      this.item.OP_IPI_SITUACAO_TRIBUTARIA     =  produtoBackEnd.OP_IPI_SITUACAO_TRIBUTARIA         ?? null                             
      this.item.OP_IPI_CLASS_ENQ_CIG_BEB       =  produtoBackEnd.OP_IPI_CLASS_ENQ_CIG_BEB           ?? null                         
      this.item.TX_IPI_CODIGO_ENQUAD_LEGAL     =  produtoBackEnd.TX_IPI_CODIGO_ENQUAD_LEGAL         ?? null                             
      this.item.TX_IPI_CNPJ_PRODUTOR           =  produtoBackEnd.TX_IPI_CNPJ_PRODUTOR               ?? null                 
      this.item.TX_IPI_NUM_SELO_CONTROLE       =  produtoBackEnd.TX_IPI_NUM_SELO_CONTROLE           ?? null                         
      this.item.OP_IPI_TIPO_CALCULO            =  produtoBackEnd.OP_IPI_TIPO_CALCULO                ?? null             
      this.item.VL_IPI_ALIQUOTA                =  produtoBackEnd.VL_IPI_ALIQUOTA                    ?? null   
      this.item.VL_IPI_UNIDADE                 =  produtoBackEnd.VL_IPI_UNIDADE                     ?? null   
      
      
      //ICMS
      //this.controles.OP_ICMS_SITUACAO_TRIBUTARIA = produtoBackEnd.OP_ICMS_SITUACAO_TRIBUTARIA       ?? null
      this.item.OP_ICMS_SITUACAO_TRIBUTARIA      = produtoBackEnd.OP_ICMS_SITUACAO_TRIBUTARIA       ?? null                              
      this.item.OP_ICMS_ORIGEM                 =  produtoBackEnd.OP_ICMS_ORIGEM                     ?? null     
      
      this.item.OP_ICMS_MODAL_DETERM_BC        =  produtoBackEnd.OP_ICMS_MODAL_DETERM_BC            ?? null                     
      this.item.VL_ICMS_PERCENT_REDUC_BC       =  produtoBackEnd.VL_ICMS_PERCENT_REDUC_BC           ?? null                      
      this.item.VL_ICMS_ALIQUOTA               =  produtoBackEnd.VL_ICMS_ALIQUOTA                   ?? null      
      this.item.VL_ICMS_PERCENT_REDUC_BC_ST    =  produtoBackEnd.VL_ICMS_PERCENT_REDUC_BC_ST        ?? null                           
      this.item.VL_ICMS_MARGEM_VL_ADIC_ST      =  produtoBackEnd.VL_ICMS_MARGEM_VL_ADIC_ST          ?? null                       
      this.item.VL_ICMS_ALIQUOTA_ST            =  produtoBackEnd.VL_ICMS_ALIQUOTA_ST                ?? null          
      this.item.VL_ALIQ_APLICAVEL_CALC_CREDITO =  produtoBackEnd.VL_ALIQ_APLICAVEL_CALC_CREDITO     ?? null                                  
      this.item.VL_CREDITO_ICMS_APROVEITADO    =  produtoBackEnd.VL_CREDITO_ICMS_APROVEITADO        ?? null                           
      this.item.VL_ICMS_BC_ST_RETIDO_ANT       =  produtoBackEnd.VL_ICMS_BC_ST_RETIDO_ANT           ?? null                      
      this.item.VL_ICMS_ST_RETIDO_ANT          =  produtoBackEnd.VL_ICMS_ST_RETIDO_ANT              ?? null              
      this.item.VL_ICMS_PERC_BC_OPER_PROPRIA   =  produtoBackEnd.VL_ICMS_PERC_BC_OPER_PROPRIA       ?? null                              
      this.item.ID_UF_ICMS_ST                  =  produtoBackEnd.ID_UF_ICMS_ST                      ?? null
      this.item.OP_MOTIVO_DESONERACAO          =  produtoBackEnd.OP_MOTIVO_DESONERACAO              ?? null    
      this.item.VL_ICMS_ALIQUOTA_DESONERA      =  produtoBackEnd.VL_ICMS_ALIQUOTA_DESONERA          ?? null
      this.item.VL_ICMS_DESONERA               =  produtoBackEnd.VL_ICMS_DESONERA                   ?? null
      this.item.OP_IND_DEDUZ_DESONERA          =  produtoBackEnd.OP_IND_DEDUZ_DESONERA              ?? null
      
      // PIS 
      this.item.OP_PIS_SITUACAO_TRIBUTARIA     =  produtoBackEnd.OP_PIS_SITUACAO_TRIBUTARIA         ?? null
      this.item.OP_PIS_TIPO_CALCULO            =  produtoBackEnd.OP_PIS_TIPO_CALCULO                ?? null
      this.item.VL_PIS_ALIQUOTA_PERCENT        =  produtoBackEnd.VL_PIS_ALIQUOTA_PERCENT            ?? null
      this.item.VL_PIS_ALIQUOTA_REAIS          =  produtoBackEnd.VL_PIS_ALIQUOTA_REAIS              ?? null
      this.item.VL_PIS_BASE_CALC               =  produtoBackEnd.VL_PIS_BASE_CALC                   ?? null
      this.item.VL_PIS_QUANT_VENDIDA           =  produtoBackEnd.VL_PIS_QUANT_VENDIDA               ?? null

      // PIS ST
      this.item.OP_PISST_TIPO_CALCULO          =  produtoBackEnd.OP_PISST_TIPO_CALCULO              ?? null
      this.item.VL_PISST_BASE_CALC             =  produtoBackEnd.VL_PISST_BASE_CALC                 ?? null
      this.item.VL_PISST_ALIQUOTA_PERCENT      =  produtoBackEnd.VL_PISST_ALIQUOTA_PERCENT          ?? null
      this.item.VL_PISST_ALIQUOTA_REAIS        =  produtoBackEnd.VL_PISST_ALIQUOTA_REAIS            ?? null
      this.item.VL_PISST_QUANT_VENDIDA         =  produtoBackEnd.VL_PISST_QUANT_VENDIDA             ?? null
      this.item.VL_PISST                       =  produtoBackEnd.VL_PISST                           ?? null

      // COFINS
      this.item.OP_COFINS_SITUACAO_TRIBUTARIA  = produtoBackEnd.OP_COFINS_SITUACAO_TRIBUTARIA       ?? null
      this.item.OP_COFINS_TIPO_CALCULO         = produtoBackEnd.OP_COFINS_TIPO_CALCULO              ?? null
      this.item.VL_COFINS_ALIQUOTA_PERCENT     = produtoBackEnd.VL_COFINS_ALIQUOTA_PERCENT          ?? null
      this.item.VL_COFINS_ALIQUOTA_REAIS       = produtoBackEnd.VL_COFINS_ALIQUOTA_REAIS            ?? null
      this.item.VL_COFINS_BASE_CALC            = produtoBackEnd.VL_COFINS_BASE_CALC                 ?? null
      this.item.VL_COFINS_QUANT_VENDIDA        = produtoBackEnd.VL_COFINS_BASE_CALC                 ?? null

      // COFINS ST 
      this.item.OP_COFINSST_TIPO_CALCULO       = produtoBackEnd.OP_COFINSST_TIPO_CALCULO            ?? null
      this.item.VL_COFINSST_ALIQUOTA_PERCENT   = produtoBackEnd.VL_COFINSST_ALIQUOTA_PERCENT        ?? null
      this.item.VL_COFINSST_ALIQUOTA_REAIS     = produtoBackEnd.VL_COFINSST_ALIQUOTA_REAIS          ?? null
      this.item.VL_COFINSST_BASE_CALC          = produtoBackEnd.VL_COFINSST_BASE_CALC               ?? null 
      this.item.VL_COFINSST_QUANT_VENDIDA      = produtoBackEnd.VL_COFINSST_QUANT_VENDIDA           ?? null

      // REFORMA
      this.item.IND_BEM_MOVEL_USADO            = produtoBackEnd.IND_BEM_MOVEL_USADO            ?? null
      this.item.VITEM_REFORMA                  = produtoBackEnd.VITEM_REFORMA                  ?? null
      this.item.CHAVE_DFE_REF                  = produtoBackEnd.CHAVE_DFE_REF                  ?? null
      this.item.NITEM_DFE_REF                  = produtoBackEnd.NITEM_DFE_REF                  ?? null
      this.item.CSTIS                          = produtoBackEnd.CSTIS                          ?? null
      this.item.CCLASSTRIBIS                   = produtoBackEnd.CCLASSTRIBIS                   ?? null
      this.item.VBCIS                          = produtoBackEnd.VBCIS                          ?? null
      this.item.PIS_SELETIVO                   = produtoBackEnd.PIS_SELETIVO                   ?? null
      this.item.PISESPEC                       = produtoBackEnd.PISESPEC                       ?? null
      this.item.UTRIBIS                        = produtoBackEnd.UTRIBIS                        ?? null
      this.item.QTRIBIS                        = produtoBackEnd.QTRIBIS                        ?? null
      this.item.VIS                            = produtoBackEnd.VIS                            ?? null
      this.item.CST_IBSCBS                     = produtoBackEnd.CST_IBSCBS                     ?? null
      this.item.CCLASSTRIB_IBSCBS              = produtoBackEnd.CCLASSTRIB_IBSCBS              ?? null
      this.item.VBC_IBSCBS                     = produtoBackEnd.VBC_IBSCBS                     ?? null
      this.item.PIBSUF                         = produtoBackEnd.PIBSUF                         ?? null
      this.item.VIBSUF                         = produtoBackEnd.VIBSUF                         ?? null
      this.item.PDIF_IBSUF                     = produtoBackEnd.PDIF_IBSUF                     ?? null
      this.item.VDIF_IBSUF                     = produtoBackEnd.VDIF_IBSUF                     ?? null
      this.item.VDEVTRIB_IBSUF                 = produtoBackEnd.VDEVTRIB_IBSUF                 ?? null
      this.item.PREDALIQ_IBSUF                 = produtoBackEnd.PREDALIQ_IBSUF                 ?? null
      this.item.PALIQEFET_IBSUF                = produtoBackEnd.PALIQEFET_IBSUF                ?? null
      this.item.PIBSMUN                        = produtoBackEnd.PIBSMUN                        ?? null
      this.item.VIBSMUN                        = produtoBackEnd.VIBSMUN                        ?? null
      this.item.PDIF_IBSMUN                    = produtoBackEnd.PDIF_IBSMUN                    ?? null
      this.item.VDIF_IBSMUN                    = produtoBackEnd.VDIF_IBSMUN                    ?? null
      this.item.VDEVTRIB_IBSMUN                = produtoBackEnd.VDEVTRIB_IBSMUN                ?? null
      this.item.PREDALIQ_IBSMUN                = produtoBackEnd.PREDALIQ_IBSMUN                ?? null
      this.item.PALIQEFET_IBSMUN               = produtoBackEnd.PALIQEFET_IBSMUN               ?? null
      this.item.PCBS                           = produtoBackEnd.PCBS                           ?? null
      this.item.VCBS                           = produtoBackEnd.VCBS                           ?? null
      this.item.PDIF_CBS                       = produtoBackEnd.PDIF_CBS                       ?? null
      this.item.VDIF_CBS                       = produtoBackEnd.VDIF_CBS                       ?? null
      this.item.VDEVTRIB_CBS                   = produtoBackEnd.VDEVTRIB_CBS                   ?? null
      this.item.PREDALIQ_CBS                   = produtoBackEnd.PREDALIQ_CBS                   ?? null
      this.item.PALIQEFET_CBS                  = produtoBackEnd.PALIQEFET_CBS                  ?? null

      // Carregar lotes disponíveis ao selecionar produto (modal de novo item)
      if (this.usarModalLotes && String(this.item.OP_CONTROLA_LOTE || '0').trim() === '1') {
        this.carregarLotesDisponiveis()
      } else if (this.usarModalLotes) {
        this.modalLotes.items = []
      }

    },
    
    limparAliquotasICMS() {
      this.item.OP_COMPOE_VALOR_NFE             = null                                      
          
      this.item.OP_IPI_SITUACAO_TRIBUTARIA      = null                             
      this.item.OP_IPI_CLASS_ENQ_CIG_BEB        = null                         
      this.item.TX_IPI_CODIGO_ENQUAD_LEGAL      = null                             
      this.item.TX_IPI_CNPJ_PRODUTOR            = null                 
      this.item.TX_IPI_NUM_SELO_CONTROLE        = null                         
      this.item.OP_IPI_TIPO_CALCULO             = null             
      this.item.VL_IPI_ALIQUOTA                 = ''     
      this.item.VL_IPI_UNIDADE                  = ''     
      //controle do comboOP_ICMS_SITUACAO_TRIBUTARIA
      this.item.OP_ICMS_SITUACAO_TRIBUTARIA     = null
      this.controles.OP_ICMS_SITUACAO_TRIBUTARIA     = null                              
      
      this.item.OP_ICMS_ORIGEM                  = null     
      
      this.item.OP_ICMS_MODAL_DETERM_BC         = null                      
      this.item.VL_ICMS_PERCENT_REDUC_BC        = null                         
      this.item.VL_ICMS_ALIQUOTA                = null         
      this.item.VL_ICMS_PERCENT_REDUC_BC_ST     = null                              
      this.item.VL_ICMS_MARGEM_VL_ADIC_ST       = null                          
      this.item.VL_ICMS_ALIQUOTA_ST             = null             
      this.item.VL_ALIQ_APLICAVEL_CALC_CREDITO  = null     
      this.item.VL_ICMS_BASE_CALC               = null                                
      this.item.VL_CREDITO_ICMS_APROVEITADO     = null                              
      this.item.VL_ICMS_BC_ST_RETIDO_ANT        = null                         
      this.item.VL_ICMS_ST_RETIDO_ANT           = null                 
      this.item.VL_ICMS_PERC_BC_OPER_PROPRIA    = null                                 
      this.item.ID_UF_ICMS_ST                   = null 
      this.item.OP_MOTIVO_DESONERACAO           = null                 
      
      // PIS 
      this.item.OP_PIS_SITUACAO_TRIBUTARIA      = null
      this.item.OP_PIS_TIPO_CALCULO             = null
      this.item.VL_PIS_ALIQUOTA_PERCENT         = null
      this.item.VL_PIS_ALIQUOTA_REAIS           = null
      this.item.VL_PIS_BASE_CALC                = null
      this.item.VL_PIS_QUANT_VENDIDA            = null

      // PIS ST
      this.item.OP_PISST_TIPO_CALCULO           = null 
      this.item.VL_PISST_BASE_CALC              = null 
      this.item.VL_PISST_ALIQUOTA_PERCENT       = null 
      this.item.VL_PISST_ALIQUOTA_REAIS         = null 
      this.item.VL_PISST_QUANT_VENDIDA          = null 
      this.item.VL_PISST                        = null 

      // COFINS
      this.item.OP_COFINS_SITUACAO_TRIBUTARIA    = null
      this.item.OP_COFINS_TIPO_CALCULO           = null
      this.item.VL_COFINS_ALIQUOTA_PERCENT       = null
      this.item.VL_COFINS_ALIQUOTA_REAIS         = null
      this.item.VL_COFINS_BASE_CALC              = null
      this.item.VL_COFINS_QUANT_VENDIDA          = null

      // COFINS ST 
      this.item.OP_COFINSST_TIPO_CALCULO         = null
      this.item.VL_COFINSST_ALIQUOTA_PERCENT     = null
      this.item.VL_COFINSST_ALIQUOTA_REAIS       = null
      this.item.VL_COFINSST_BASE_CALC            = null    
      this.item.VL_COFINSST_QUANT_VENDIDA        = null 

    },
    limparItem(alteracao, item) {
      this.item.CONTROLE                       =    item.CONTROLE                       ? item.CONTROLE                       : null 
      this.item.SEQUENCIA                      =    item.SEQUENCIA                      ? item.SEQUENCIA                      : null 
      this.item.COD_PRO                        =    item.COD_PRO                        ? item.COD_PRO                        : null 
      this.item.EAN                            =    item.EAN                            ? item.EAN                            : null 
      this.item.QUANT                          =    item.QUANT                          ? item.QUANT                          : 0.00 
      this.item.VL_UNT                         =    item.VL_UNT                         ? item.VL_UNT                         : 0.00 
      this.item.VL_CUSTO                       =    item.VL_CUSTO                       ? item.VL_CUSTO                       : 0.00 
      this.item.UND_PECAS                      =    item.UND_PECAS                      ? item.UND_PECAS                      : null 
      this.item.PECAS                          =    item.PECAS                          ? item.PECAS                          : 0 
      this.item.DT_VENDA                       =    item.DT_VENDA                       ? item.DT_VENDA                       : new Date() 
      this.item.TIPO_CLI                       =    item.TIPO_CLI                       ? item.TIPO_CLI                       : null 
      this.item.MARCA                          =    item.MARCA                          ? item.MARCA                          : null 
      this.item.TIPO_VEN                       =    item.TIPO_VEN                       ? item.TIPO_VEN                       : null 
      this.item.ALTERA                         =    item.ALTERA                         ? item.ALTERA                         : null 
      this.item.ITEM                           =    item.ITEM                           ? item.ITEM                           : null 
      this.item.VL_COMISSAO                    =    item.VL_COMISSAO                    ? item.VL_COMISSAO                    : 0.00 
      this.item.COD_CENTRO                     =    item.COD_CENTRO                     ? item.COD_CENTRO                     : null 
      this.item.ICMS                           =    item.ICMS                           ? item.ICMS                           : null 
      this.item.IPI                            =    item.IPI                            ? item.IPI                            : null 
      this.item.ISS                            =    item.ISS                            ? item.ISS                            : null 
      this.item.IRRF                           =    item.IRRF                           ? item.IRRF                           : null 
      this.item.ICMSSUBSTITUI                  =    item.ICMSSUBSTITUI                  ? item.ICMSSUBSTITUI                  : null 
      this.item.FORMA                          =    item.FORMA                          ? item.FORMA                          : null 
      this.item.ID_CFOP                        =    item.ID_CFOP                        ? item.ID_CFOP                        : null 
      this.item.OP_STATUS_PRECO                =    item.OP_STATUS_PRECO                ? item.OP_STATUS_PRECO                : null 
      this.item.VL_TOTAL_BRUTO                 =    item.VL_TOTAL_BRUTO                 ? item.VL_TOTAL_BRUTO                 : 0.00 
      this.item.VL_TOTAL_DESCONTO              =    item.VL_TOTAL_DESCONTO              ? item.VL_TOTAL_DESCONTO              : 0.00 
      this.item.VL_DESCONTO_PERC               =    item.VL_DESCONTO_PERC               ? item.VL_DESCONTO_PERC               : 0.00 
      this.item.TX_NCM                         =    item.TX_NCM                         ? item.TX_NCM                         : null 
      this.item.TX_NOME_PRODUTO                =    item.TX_NOME_PRODUTO                ? item.TX_NOME_PRODUTO                : null 
      this.item.TX_UNIDADE_COMERCIAL           =    item.TX_UNIDADE_COMERCIAL           ? item.TX_UNIDADE_COMERCIAL           : null 
      this.item.OP_OCORRENCIA_PRECO            =    item.OP_OCORRENCIA_PRECO            ? item.OP_OCORRENCIA_PRECO            : null 
      this.item.VL_DESCONTO                    =    item.VL_DESCONTO                    ? item.VL_DESCONTO                    : 0.00 
      this.item.ID_UNIDADE_COMERCIAL           =    item.ID_UNIDADE_COMERCIAL           ? item.ID_UNIDADE_COMERCIAL           : null 
      this.item.OP_TRIBUTACAO                  =    item.OP_TRIBUTACAO                  ? item.OP_TRIBUTACAO                  : null 
      this.item.CEST                           =    item.CEST                           ? item.CEST                           : null 
      this.item.QUANT_BKP                      =    item.QUANT_BKP                      ? item.QUANT_BKP                      : null 
      this.item.QUANT_RETORNO                  =    item.QUANT_RETORNO                  ? item.QUANT_RETORNO                  : null 
      this.item.PECAS_BKP                      =    item.PECAS_BKP                      ? item.PECAS_BKP                      : null 
      this.item.PECAS_RETORNO                  =    item.PECAS_RETORNO                  ? item.PECAS_RETORNO                  : null 
      this.item.OBS_RETORNO                    =    item.OBS_RETORNO                    ? item.OBS_RETORNO                    : null 
      this.item.TX_OBSERVACOES                 =    item.TX_OBSERVACOES                 ? item.TX_OBSERVACOES                 : null 
      
      if (alteracao == true) {
        this.item.OP_ICMS_SITUACAO_TRIBUTARIA    =    item.OP_ICMS_SITUACAO_TRIBUTARIA    ? item.OP_ICMS_SITUACAO_TRIBUTARIA    : null 
        this.item.OP_ICMS_ORIGEM                 =    item.OP_ICMS_ORIGEM                 ? item.OP_ICMS_ORIGEM                 : null 
        this.item.OP_ICMS_MODAL_DETERM_BC        =    item.OP_ICMS_MODAL_DETERM_BC        ? item.OP_ICMS_MODAL_DETERM_BC        : null 
        this.item.VL_ICMS_PERCENT_REDUC_BC       =    item.VL_ICMS_PERCENT_REDUC_BC       ? item.VL_ICMS_PERCENT_REDUC_BC       : null 
        this.item.VL_ICMS_BASE_CALC              =    item.VL_ICMS_BASE_CALC              ? item.VL_ICMS_BASE_CALC              : null 
        this.item.VL_ICMS_ALIQUOTA               =    item.VL_ICMS_ALIQUOTA               ? item.VL_ICMS_ALIQUOTA               : null 
        this.item.VL_ICMS                        =    item.VL_ICMS                        ? item.VL_ICMS                        : null 
        this.item.OP_ICMS_MODAL_DETERM_BC_ST     =    item.OP_ICMS_MODAL_DETERM_BC_ST     ? item.OP_ICMS_MODAL_DETERM_BC_ST     : null 
        this.item.VL_ICMS_MARGEM_VL_ADIC_ST      =    item.VL_ICMS_MARGEM_VL_ADIC_ST      ? item.VL_ICMS_MARGEM_VL_ADIC_ST      : null 
        this.item.VL_ICMS_PERCENT_REDUC_BC_ST    =    item.VL_ICMS_PERCENT_REDUC_BC_ST    ? item.VL_ICMS_PERCENT_REDUC_BC_ST    : null 
        this.item.VL_ICMS_BASE_CALC_ST           =    item.VL_ICMS_BASE_CALC_ST           ? item.VL_ICMS_BASE_CALC_ST           : null 
        this.item.VL_ICMS_ALIQUOTA_ST            =    item.VL_ICMS_ALIQUOTA_ST            ? item.VL_ICMS_ALIQUOTA_ST            : null 
        this.item.VL_ICMS_ST                     =    item.VL_ICMS_ST                     ? item.VL_ICMS_ST                     : null 
        this.item.OP_IPI_SITUACAO_TRIBUTARIA     =    item.OP_IPI_SITUACAO_TRIBUTARIA     ? item.OP_IPI_SITUACAO_TRIBUTARIA     : null 
        this.item.OP_IPI_CLASS_ENQ_CIG_BEB       =    item.OP_IPI_CLASS_ENQ_CIG_BEB       ? item.OP_IPI_CLASS_ENQ_CIG_BEB       : null 
        this.item.TX_IPI_CODIGO_ENQUAD_LEGAL     =    item.TX_IPI_CODIGO_ENQUAD_LEGAL     ? item.TX_IPI_CODIGO_ENQUAD_LEGAL     : null 
        this.item.TX_IPI_CNPJ_PRODUTOR           =    item.TX_IPI_CNPJ_PRODUTOR           ? item.TX_IPI_CNPJ_PRODUTOR           : null 
        this.item.TX_IPI_NUM_SELO_CONTROLE       =    item.TX_IPI_NUM_SELO_CONTROLE       ? item.TX_IPI_NUM_SELO_CONTROLE       : null 
        this.item.OP_IPI_TIPO_CALCULO            =    item.OP_IPI_TIPO_CALCULO            ? item.OP_IPI_TIPO_CALCULO            : null 
        this.item.VL_IPI_BASE_CALC               =    item.VL_IPI_BASE_CALC               ? item.VL_IPI_BASE_CALC               : null 
        this.item.VL_IPI_ALIQUOTA                =    item.VL_IPI_ALIQUOTA                ? item.VL_IPI_ALIQUOTA                : null 
        this.item.VL_IPI_QUANT_TOTAL_UND_PADRAO  =    item.VL_IPI_QUANT_TOTAL_UND_PADRAO  ? item.VL_IPI_QUANT_TOTAL_UND_PADRAO  : null 
        this.item.VL_IPI_UNIDADE                 =    item.VL_IPI_UNIDADE                 ? item.VL_IPI_UNIDADE                 : null 
        this.item.VL_IPI                         =    item.VL_IPI                         ? item.VL_IPI                         : null 
        this.item.OP_PIS_SITUACAO_TRIBUTARIA     =    item.OP_PIS_SITUACAO_TRIBUTARIA     ? item.OP_PIS_SITUACAO_TRIBUTARIA     : null 
        this.item.OP_PIS_TIPO_CALCULO            =    item.OP_PIS_TIPO_CALCULO            ? item.OP_PIS_TIPO_CALCULO            : null 
        this.item.VL_PIS_BASE_CALC               =    item.VL_PIS_BASE_CALC               ? item.VL_PIS_BASE_CALC               : null 
        this.item.VL_PIS_ALIQUOTA_PERCENT        =    item.VL_PIS_ALIQUOTA_PERCENT        ? item.VL_PIS_ALIQUOTA_PERCENT        : null 
        this.item.VL_PIS_ALIQUOTA_REAIS          =    item.VL_PIS_ALIQUOTA_REAIS          ? item.VL_PIS_ALIQUOTA_REAIS          : null 
        this.item.VL_PIS_QUANT_VENDIDA           =    item.VL_PIS_QUANT_VENDIDA           ? item.VL_PIS_QUANT_VENDIDA           : null 
        this.item.VL_PIS                         =    item.VL_PIS                         ? item.VL_PIS                         : null 
        this.item.OP_PISST_TIPO_CALCULO          =    item.OP_PISST_TIPO_CALCULO          ? item.OP_PISST_TIPO_CALCULO          : null 
        this.item.VL_PISST_BASE_CALC             =    item.VL_PISST_BASE_CALC             ? item.VL_PISST_BASE_CALC             : null 
        this.item.VL_PISST_ALIQUOTA_PERCENT      =    item.VL_PISST_ALIQUOTA_PERCENT      ? item.VL_PISST_ALIQUOTA_PERCENT      : null 
        this.item.VL_PISST_ALIQUOTA_REAIS        =    item.VL_PISST_ALIQUOTA_REAIS        ? item.VL_PISST_ALIQUOTA_REAIS        : null 
        this.item.VL_PISST_QUANT_VENDIDA         =    item.VL_PISST_QUANT_VENDIDA         ? item.VL_PISST_QUANT_VENDIDA         : null 
        this.item.VL_PISST                       =    item.VL_PISST                       ? item.VL_PISST                       : null 
        this.item.OP_COFINS_SITUACAO_TRIBUTARIA  =    item.OP_COFINS_SITUACAO_TRIBUTARIA  ? item.OP_COFINS_SITUACAO_TRIBUTARIA  : null 
        this.item.OP_COFINS_TIPO_CALCULO         =    item.OP_COFINS_TIPO_CALCULO         ? item.OP_COFINS_TIPO_CALCULO         : null 
        this.item.VL_COFINS_BASE_CALC            =    item.VL_COFINS_BASE_CALC            ? item.VL_COFINS_BASE_CALC            : null 
        this.item.VL_COFINS_ALIQUOTA_PERCENT     =    item.VL_COFINS_ALIQUOTA_PERCENT     ? item.VL_COFINS_ALIQUOTA_PERCENT     : null 
        this.item.VL_COFINS_ALIQUOTA_REAIS       =    item.VL_COFINS_ALIQUOTA_REAIS       ? item.VL_COFINS_ALIQUOTA_REAIS       : null 
        this.item.VL_COFINS_QUANT_VENDIDA        =    item.VL_COFINS_QUANT_VENDIDA        ? item.VL_COFINS_QUANT_VENDIDA        : null 
        this.item.VL_COFINS                      =    item.VL_COFINS                      ? item.VL_COFINS                      : null 
        this.item.OP_COFINSST_TIPO_CALCULO       =    item.OP_COFINSST_TIPO_CALCULO       ? item.OP_COFINSST_TIPO_CALCULO       : null 
        this.item.VL_COFINSST_BASE_CALC          =    item.VL_COFINSST_BASE_CALC          ? item.VL_COFINSST_BASE_CALC          : null 
        this.item.VL_COFINSST_ALIQUOTA_PERCENT   =    item.VL_COFINSST_ALIQUOTA_PERCENT   ? item.VL_COFINSST_ALIQUOTA_PERCENT   : null 
        this.item.VL_COFINSST_ALIQUOTA_REAIS     =    item.VL_COFINSST_ALIQUOTA_REAIS     ? item.VL_COFINSST_ALIQUOTA_REAIS     : null 
        this.item.VL_COFINSST_QUANT_VENDIDA      =    item.VL_COFINSST_QUANT_VENDIDA      ? item.VL_COFINSST_QUANT_VENDIDA      : null 
        this.item.VL_COFINSST                    =    item.VL_COFINSST                    ? item.VL_COFINSST                    : null 
        
        this.item.OP_COMPOE_VALOR_NFE            =    item.OP_COMPOE_VALOR_NFE            ? item.OP_COMPOE_VALOR_NFE            : null 
        this.item.VL_ICMS_BC_ST_RETIDO_ANT       =    item.VL_ICMS_BC_ST_RETIDO_ANT       ? item.VL_ICMS_BC_ST_RETIDO_ANT       : null 
        this.item.VL_ICMS_ST_RETIDO_ANT          =    item.VL_ICMS_ST_RETIDO_ANT          ? item.VL_ICMS_ST_RETIDO_ANT          : null 
        this.item.VL_ICMS_PERC_BC_OPER_PROPRIA   =    item.VL_ICMS_PERC_BC_OPER_PROPRIA   ? item.VL_ICMS_PERC_BC_OPER_PROPRIA   : null 
        this.item.ID_UF_ICMS_ST                  =    item.ID_UF_ICMS_ST                  ? item.ID_UF_ICMS_ST                  : null 
        this.item.VL_CREDITO_ICMS_APROVEITADO    =    item.VL_CREDITO_ICMS_APROVEITADO    ? item.VL_CREDITO_ICMS_APROVEITADO    : null 
        
      
        this.item.OP_MOTIVO_DESONERACAO          =    item.OP_MOTIVO_DESONERACAO          ? item.OP_MOTIVO_DESONERACAO          : null 
        this.item.VL_ALIQ_APLICAVEL_CALC_CREDITO =    item.VL_ALIQ_APLICAVEL_CALC_CREDITO ? item.VL_ALIQ_APLICAVEL_CALC_CREDITO : null 
        
        // REFORMA
        this.item.IND_BEM_MOVEL_USADO            =    item.IND_BEM_MOVEL_USADO            ? item.IND_BEM_MOVEL_USADO            : null 
        this.item.VITEM_REFORMA                  =    item.VITEM_REFORMA                  ? item.VITEM_REFORMA                  : null 
        this.item.CHAVE_DFE_REF                  =    item.CHAVE_DFE_REF                  ? item.CHAVE_DFE_REF                  : null 
        this.item.NITEM_DFE_REF                  =    item.NITEM_DFE_REF                  ? item.NITEM_DFE_REF                  : null 
        this.item.CSTIS                          =    item.CSTIS                          ? item.CSTIS                          : null 
        this.item.CCLASSTRIBIS                   =    item.CCLASSTRIBIS                   ? item.CCLASSTRIBIS                   : null 
        this.item.VBCIS                          =    item.VBCIS                          ? item.VBCIS                          : null 
        this.item.PIS_SELETIVO                   =    item.PIS_SELETIVO                   ? item.PIS_SELETIVO                   : null 
        this.item.PISESPEC                       =    item.PISESPEC                       ? item.PISESPEC                       : null 
        this.item.UTRIBIS                        =    item.UTRIBIS                        ? item.UTRIBIS                        : null 
        this.item.QTRIBIS                        =    item.QTRIBIS                        ? item.QTRIBIS                        : null 
        this.item.VIS                            =    item.VIS                            ? item.VIS                            : null 
        this.item.CST_IBSCBS                     =    item.CST_IBSCBS                     ? item.CST_IBSCBS                     : null 
        this.item.CCLASSTRIB_IBSCBS              =    item.CCLASSTRIB_IBSCBS              ? item.CCLASSTRIB_IBSCBS              : null 
        this.item.VBC_IBSCBS                     =    item.VBC_IBSCBS                     ? item.VBC_IBSCBS                     : null 
        this.item.PIBSUF                         =    item.PIBSUF                         ? item.PIBSUF                         : null 
        this.item.VIBSUF                         =    item.VIBSUF                         ? item.VIBSUF                         : null 
        this.item.PDIF_IBSUF                     =    item.PDIF_IBSUF                     ? item.PDIF_IBSUF                     : null 
        this.item.VDIF_IBSUF                     =    item.VDIF_IBSUF                     ? item.VDIF_IBSUF                     : null 
        this.item.VDEVTRIB_IBSUF                 =    item.VDEVTRIB_IBSUF                 ? item.VDEVTRIB_IBSUF                 : null 
        this.item.PREDALIQ_IBSUF                 =    item.PREDALIQ_IBSUF                 ? item.PREDALIQ_IBSUF                 : null 
        this.item.PALIQEFET_IBSUF                =    item.PALIQEFET_IBSUF                ? item.PALIQEFET_IBSUF                : null 
        this.item.PIBSMUN                        =    item.PIBSMUN                        ? item.PIBSMUN                        : null 
        this.item.VIBSMUN                        =    item.VIBSMUN                        ? item.VIBSMUN                        : null 
        this.item.PDIF_IBSMUN                    =    item.PDIF_IBSMUN                    ? item.PDIF_IBSMUN                    : null 
        this.item.VDIF_IBSMUN                    =    item.VDIF_IBSMUN                    ? item.VDIF_IBSMUN                    : null 
        this.item.VDEVTRIB_IBSMUN                =    item.VDEVTRIB_IBSMUN                ? item.VDEVTRIB_IBSMUN                : null 
        this.item.PREDALIQ_IBSMUN                =    item.PREDALIQ_IBSMUN                ? item.PREDALIQ_IBSMUN                : null 
        this.item.PALIQEFET_IBSMUN               =    item.PALIQEFET_IBSMUN               ? item.PALIQEFET_IBSMUN               : null 
        this.item.PCBS                           =    item.PCBS                           ? item.PCBS                           : null 
        this.item.VCBS                           =    item.VCBS                           ? item.VCBS                           : null 
        this.item.PDIF_CBS                       =    item.PDIF_CBS                       ? item.PDIF_CBS                       : null 
        this.item.VDIF_CBS                       =    item.VDIF_CBS                       ? item.VDIF_CBS                       : null 
        this.item.VDEVTRIB_CBS                   =    item.VDEVTRIB_CBS                   ? item.VDEVTRIB_CBS                   : null 
        this.item.PREDALIQ_CBS                   =    item.PREDALIQ_CBS                   ? item.PREDALIQ_CBS                   : null 
        this.item.PALIQEFET_CBS                  =    item.PALIQEFET_CBS                  ? item.PALIQEFET_CBS                  : null 
      }
      
      // Reseta a flag de liberação de edição de peso ao limpar o item
      this.pesagem.liberadoParaEdicao = false
      this.pesagem.manual = false
      // Reseta controle de lote do produto
      this.item.OP_CONTROLA_LOTE = item.OP_CONTROLA_LOTE ? String(item.OP_CONTROLA_LOTE).trim() : '0'
    },
    limparVenda () {
      this.venda.SEQUENCIA                 = null
      this.venda.N_VENDA                   = null
      this.venda.DT_SAIDA                  = null
      this.venda.SITUACAO                  = null
      this.venda.PAG2                      = null
      this.venda.OP_PEDIDO                 = null
      this.venda.TIPO_VEN                  = null
      this.venda.FORMA                     = null
      this.venda.USUARIO                   = null
      this.venda.USUARIO_LANCAMENTO_WEB    = null
      this.venda.NENTREGA                  = null
      this.venda.VL_TOTAL_RETORNO_BKP      = null
      this.venda.VL_TOTAL_RETORNO          = null
      this.venda.PESOLIQUIDO               = null
      this.venda.PESOBRUTO                 = null
      this.venda.VL_TOTAL_ANTES_ALTERACAO  = null
      this.venda.VL_BASE_CALC_ICMS         = null
      this.venda.VL_TOTAL_ICMS             = null
      this.venda.VL_BASE_CALC_ST_ICMS      = null
      this.venda.VL_TOTAL_ST_ICMS          = null
      this.venda.VL_TOTAL_IPI              = null
      this.venda.VL_TOTAL_PIS              = null
      this.venda.VL_TOTAL_COFINS           = null
      this.venda.VBCIBSCBSTOT              = null
      this.venda.VIBSTOT                   = null
      this.venda.VCBS_TOT                  = null
      this.venda.VL_TOTAL_DESCONTO         = null
      this.venda.VL_TOTAL_SEGURO           = null
      this.venda.VL_TOTAL_OUTRAS_DESP      = null
      this.venda.VL_TOTAL_FRETE            = null
      this.venda.NR_PESO_BRUTO             = null
      this.venda.VL_TOTAL_PRODUTOS         = null
      this.venda.NR_PESO_LIQUIDO           = null
      this.venda.VL_TOTAL_NFE              = null
      this.venda.DT_INICIAR_PAGAMENTO      = null
      this.venda.COD_CLI                   = null
      this.venda.DT_PAG                    = null
      this.venda.PAG1                      = null
      this.venda.PAG3                      = null
      this.venda.PAG4                      = null
      this.venda.PAG5                      = null
      this.venda.TIPO                      = null
      this.venda.COD_VENDEDOR              = null
      this.venda.COD_MOTORISTA             = null
      this.venda.VL_TOTAL                  = null
      this.venda.OBS2                      = null
      this.venda.OBS3                      = null
      this.venda.LOTE                      = null
      this.venda.TIPO_DOCPAG               = null
      this.venda.N_DOCPAG                  = null
      this.venda.COD_REPRES                = null
      this.venda.COD_CONFERENTE            = null
      this.venda.TIPO_VENDEDOR             = null
      this.venda.ITENS                     = null
      this.venda.PLACA                     = null
      this.venda.VL_ENTRADA                = null
      this.venda.VL_DESCONTO               = null
      this.venda.CFOP                      = null
      this.venda.UFENT                     = null
      this.venda.TELENT                    = null
      this.venda.CONTATOENT                = null
      this.venda.BAIRROENT                 = null
      this.venda.CIDADEENT                 = null
      this.venda.ENDENT                    = null
      this.venda.MOT_CANC                  = null
      this.venda.NUMNF                     = null
      this.venda.SERIENF                   = null
      this.venda.UFPLACA                   = null
      this.venda.PORCONTA                  = null
      this.venda.VOLUMES                   = null
      this.venda.TOTALNF                   = null
      this.venda.DT_CANC                   = null
      this.venda.DT_ALTERACAO              = null
      this.venda.TX_USUARIO_ALTERACAO      = null
      this.venda.OP_FORMA_PAGTO            = null
      this.venda.TX_USUARIO_CANCELAMENTO   = null
      this.venda.NR_PARCELAS               = null
      this.venda.COD_TRANSP                = null
      this.venda.ORIGEM                    = null
      this.venda.DT_PREVISAO_ENTREGA       = null
      this.venda.HORA                      = null
      this.venda.DT_PEDIDO                 = null
      this.venda.DT_SISTEMA_CANCELAMENTO   = null
      this.venda.DT_CADASTRO_SISTEMA       = null
      this.venda.DT_ALTERACAO_SISTEMA      = null
      this.venda.OBSERVACOES               = null
      this.venda.DT_RETORNO                = null
      this.venda.NOME_RESPONSAVEL_RETORNO  = null
      this.venda.DT_LANCAMENTO_RETORNO     = null
      this.venda.OBS_RETORNO               = null
      this.venda.USUARIO_RETORNO           = null
      this.venda.DT_LANCAMENTO_WEB         = null
      this.venda.OP_LANCAMENTO_WEB         = null
      this.venda.TIPO_MOVIMENTACAO_ID      = null
      this.tipoMovimentacaoDescricao       = ''
    },
    ajustarCamposTabelaVendas(dados) {
        this.venda.DT_PEDIDO = Tools.formatarDataParaInput(dados.DT_PEDIDO)
        this.venda.DT_SAIDA = Tools.formatarDataParaInput(dados.DT_SAIDA)
        this.venda.DT_PREVISAO_ENTREGA = Tools.formatarDataParaInput(dados.DT_PREVISAO_ENTREGA)
        this.venda.DT_INICIAR_PAGAMENTO = Tools.formatarDataParaInput(dados.DT_INICIAR_PAGAMENTO)
        if (this.venda.DT_PAG) {
          this.venda.DT_PAG = Tools.formatarDataParaInput(this.venda.DT_PAG)
        }
    },
    recalcularTotalVenda() {
      const totalProdutos = parseFloat(this.venda.VL_TOTAL_PRODUTOS || 0)
      const totalIcmsSt = parseFloat(this.venda.VL_TOTAL_ST_ICMS || 0)
      const totalIpi = parseFloat(this.venda.VL_TOTAL_IPI || 0)
      const totalFrete = parseFloat(this.venda.VL_TOTAL_FRETE || 0)
      const totalSeguro = parseFloat(this.venda.VL_TOTAL_SEGURO || 0)
      const totalOutrasDespesas = parseFloat(this.venda.VL_TOTAL_OUTRAS_DESP || 0)
      const totalDesconto = parseFloat(this.venda.VL_TOTAL_DESCONTO || 0)

      this.venda.VL_TOTAL_NFE = parseFloat((
        totalProdutos
        + totalIcmsSt
        + totalIpi
        + totalFrete
        + totalSeguro
        + totalOutrasDespesas
        - totalDesconto
      ).toFixed(2))
    },
    async recalcular(id) {
      try {

        const bodyVenda = {
          vendaId: id
        }
        let responseRecalcular = null 
        try {
          responseRecalcular = await this.$http.post(`/api/protected/venda/recalcular/`, bodyVenda)
        } catch(err) {
          if (err?.response?.status === 400) {
            return {
              result: false,
              msg: err?.response?.data || 'Não foi possível recalcular os dados do pedido.'
            }
          }

          console.log(err)
          throw new Error('Não foi possivel calcular os dados do pedido. Procure a TI!')
        }

        const recalcularAux = responseRecalcular?.data?? null
        if (!recalcularAux) {
          throw new Error('Não foi possivel calcular os dados do pedido. Procure a TI!!')
        }

        if (recalcularAux.result == false) {
          console.log(recalcularAux.msg)
          return recalcularAux
        }

        return recalcularAux

      } catch (err) {
        throw err
      }
    },
    obterValorNumerico(valor) {
      const numero = parseFloat(valor)
      return Number.isFinite(numero) ? numero : 0
    },
    formatarValorMonetario(valor) {
      return this.obterValorNumerico(valor).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      })
    },
    somarParcelamentoAtual() {
      return (this.tabelaParcelamento.items || []).reduce((total, parcela) => {
        return total + this.obterValorNumerico(parcela.VALOR)
      }, 0)
    },
    parcelamentoConfereComTotal(totalReferencia = null) {
      const totalVenda = totalReferencia == null
        ? this.obterValorNumerico(this.venda.VL_TOTAL_NFE)
        : this.obterValorNumerico(totalReferencia)

      return Math.abs(this.somarParcelamentoAtual() - totalVenda) <= 0.01
    },
    avisarTotalRecalculado(totalAntes, totalDepois) {
      if (Math.abs(totalDepois - totalAntes) <= 0.01) {
        return
      }

      const mensagem = this.venda.OP_FORMA_PAGTO === 'V'
        ? `O total da prefatura foi recalculado de ${this.formatarValorMonetario(totalAntes)} para ${this.formatarValorMonetario(totalDepois)}.`
        : `O total da prefatura foi recalculado de ${this.formatarValorMonetario(totalAntes)} para ${this.formatarValorMonetario(totalDepois)}. Clique em Parcelar novamente para atualizar as parcelas.`

      this.toastCount++
      this.$root.$bvToast.toast(mensagem, {
        title: 'Recalculo da prefatura',
        autoHideDelay: 6000,
        variant: this.venda.OP_FORMA_PAGTO === 'V' ? 'info' : 'warning',
        appendToast: true
      })
    },
    async sincronizarVendaComRecalculo({
      salvarVenda = false,
      atualizarItens = true,
      exibirToastTotalAlterado = false
    } = {}) {
      if (!this.venda.SEQUENCIA) {
        return { ok: true, totalMudou: false }
      }

      const totalAntes = this.obterValorNumerico(this.venda.VL_TOTAL_NFE)

      if (salvarVenda) {
        try {
          await this.$http.post(`/api/protected/venda/edit`, this.montarPayloadVenda())
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err)
          return { ok: false }
        }
      }

      const recalculo = await this.recalcular(this.venda.SEQUENCIA)
      if (recalculo?.result === false) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', recalculo.msg || 'Nao foi possivel recalcular a prefatura.')
        return { ok: false, recalculo }
      }

      let vendaResponse = null
      try {
        vendaResponse = await this.$http.get(`/api/protected/venda/getById/${this.venda.SEQUENCIA}`)
      } catch (err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', err)
        return { ok: false }
      }

      const vendaAtualizada = vendaResponse?.data?.[0] ?? null
      if (!vendaAtualizada) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Nao foi possivel recarregar os dados da prefatura.')
        return { ok: false }
      }

      this.venda = vendaAtualizada
      this.ajustarCamposTabelaVendas(this.venda)
      await this.atualizarStatusAcoesVenda()

      if (atualizarItens) {
        try {
          const itens = await this.getItens()
          this.tabelaItens.items = itens || []
        } catch (err) {
          console.error('Erro ao recarregar itens apos o recalculo:', err)
        }
      }

      if (this.venda.OP_FORMA_PAGTO === 'V') {
        this.gerarParcelamento()
      }

      const totalDepois = this.obterValorNumerico(this.venda.VL_TOTAL_NFE)
      const totalMudou = Math.abs(totalDepois - totalAntes) > 0.01

      if (exibirToastTotalAlterado && totalMudou) {
        this.avisarTotalRecalculado(totalAntes, totalDepois)
      }

      return {
        ok: true,
        recalculo,
        totalAntes,
        totalDepois,
        totalMudou
      }
    },
    async getItens() {
      try {
        const response = await this.$http.get('/api/protected/venda/item/getListagemByVenda/'+this.venda.SEQUENCIA)
        const dados = response.data
        return dados

      } catch (err) {
        console.error('Erro em getItens:', err)
        return null
      }
    },
    async getParcelamento() {
      try {
        const response = await this.$http.get('/api/protected/venda/getParcelamento/'+this.venda.SEQUENCIA)
        const dados = response.data
        return dados

      } catch (err) {
        console.error('Erro em getParcelamento:', err)
        return null
      }
    },
    async atualizarPrecoVenda() {
      try {
        const result = await this.$http.get(`api/protected/venda/item/getAchaPrecoLivre/${this.venda.COD_CLI}/${this.item.COD_PRO}`)
        this.item.VL_UNT = result.data?.[0]?.PRECO || 0
        this.item.VL_CUSTO = result.data?.[0]?.CUSTO || 0
      } catch (err) {
        console.error('Erro ao atualizar preço de venda:', err)
      }
    },
    async getTipoMovimentacoes() {
      try {
        const response = await this.$http.get(`/api/protected/tipoMovimentacao/listar`)
        const dados = response.data

        //Armazenar também os itens
        this.tipoMovimentacoes.items = response.data
        this.modalTipoMovimentacao.items = response.data

        //preencher o combo
        this.tipoMovimentacoes.options = []
        if (Array.isArray(dados)) {
          for (const tipo of dados) {
            this.tipoMovimentacoes.options.push({
              value: tipo.ID,
              text: tipo.ID + ' - ' + tipo.DESCRICAO
            })
          }
        }

        // Atualizar a descrição do tipo atual se já houver um tipo selecionado
        if (this.venda.TIPO_MOVIMENTACAO_ID) {
          this.buscarDescricaoTipoMovimentacao(this.venda.TIPO_MOVIMENTACAO_ID)
        }

        return dados

      } catch (err) {
        console.error('Erro em getTipoMovimentacoes:', err)
        return null
      }
    },
    abrirModalTipoMovimentacao() {
      if (this.controles.fechada) {
        return
      }
      this.modalTipoMovimentacao.filtro = ''
      this.$refs['modal-tipo-movimentacao'].show()
    },
    async selecionarTipoMovimentacao(item) {
      if (item && item.length > 0) {
        this.venda.TIPO_MOVIMENTACAO_ID = item[0].ID
        this.tipoMovimentacaoDescricao = `${item[0].ID} - ${item[0].DESCRICAO}`
        this.$refs['modal-tipo-movimentacao'].hide()
      }
    },
    async buscarDescricaoTipoMovimentacao(tipoMovimentacaoId) {
      if (!tipoMovimentacaoId) {
        this.tipoMovimentacaoDescricao = ''
        return
      }

      // Primeiro tenta buscar no array local
      const tipoLocal = this.tipoMovimentacoes.items.find(t => 
        String(t.ID) === String(tipoMovimentacaoId)
      )

      if (tipoLocal) {
        this.tipoMovimentacaoDescricao = `${tipoLocal.ID} - ${tipoLocal.DESCRICAO}`
        return
      }

      // Se não encontrou localmente, busca na API
      try {
        const response = await this.$http.get(`/api/protected/tipoMovimentacao/getById/${tipoMovimentacaoId}`)
        const tipo = response.data
        if (tipo && tipo.ID) {
          this.tipoMovimentacaoDescricao = `${tipo.ID} - ${tipo.DESCRICAO}`
        } else {
          this.tipoMovimentacaoDescricao = ''
        }
      } catch (err) {
        console.error('Erro ao buscar tipo de movimentação:', err)
        this.tipoMovimentacaoDescricao = ''
      }
    },
    async carregarParametros () {
      try {
        const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/parametro/getDados'))
        const dados = response.data

        return dados?.[0]

      } catch (err) {
        console.error('Erro em carregarParametros:', err)
        return null
      }
    },
    async carregarListaEstoque() {
      try {
        const response = await this.$http.get(this.$http.defaults.baseURL.concat('api/protected/centroestoque/listartodos'))
        const dados = response.data

        this.estoqueProduto.options = []
        this.estoqueProduto.QUANT = 0.00
        this.estoqueProduto.PECAS = 0

        if (Array.isArray(dados)) {
          for (const estoque of dados) {
            this.estoqueProduto.options.push({
              value: estoque.CODIGO,
              text: estoque.NOME
            })
          }
        }
      } catch (err) {
        console.error('Erro em carregarListaEstoque:', err)
        throw new Error("O estoque está indisponível")
      }
    },
    colorirLimiteCredito(valor) {
      if (valor === 0) return 'primary'
      else if (valor > 0) return 'success'
      else return 'danger'
    },
    traduzirSituacao(registro) {
      const item = registro && typeof registro === 'object' ? registro : null
      const value = item ? item.SITUACAO : registro
      let $variant
      if ( value == '0'  ) {
        $variant = 'CANCELADO'
      } else if ( value == '1'  ) {
        if (item && String(item.OP_RETORNO_ENTREGA || '0').trim() === '1') $variant = 'ENTREGUE'
        else if (item && item.ORDEM_ENTREGA_ID) {
          const statusOrdem = String(item.ORDEM_ENTREGA_STATUS || '').trim()
          $variant = ['2', '3', '4'].includes(statusOrdem) ? 'EMBARCADO' : 'EM EMBARQUE'
        } else {
          $variant = 'FECHADO / AGUARD. CARGA'
        }
      } else if ( value == '2'  ) {
        $variant = 'EM CADASTRO'
      } else if ( value == '3'  ) {
        $variant = 'AGUARDANDO ORDEM'
      } else if ( value == '4'  ) {
        $variant = 'ORDEM EXPEDIÇÃO'
      } else if ( value == '5'  ) {
        $variant = 'EMBARCANDO'
      } else if ( value == '6'  ) {
        $variant = item && String(item.OP_CONFERENCIA_VENDA || '0').trim() === '1' ? 'CONFERIDO / PRONTO P/ VENDA' : 'EMBARCADO'
      }
      return $variant
    },
    colorirSituacao(value) {
      const mapping = {
        '0': 'soft-danger',
        '1': 'soft-success',
        '2': 'soft-warning',
        '3': 'soft-info',
        '4': 'soft-info',
        '5': 'soft-info',
        '6': 'soft-primary'
      }
      return mapping[value] || 'soft-secondary'
    },
    somarTotalItem() {
      let quantidade = this.item.QUANT != null && this.item.QUANT > 0 ? this.item.QUANT : 0
      let valor = this.item.VL_UNT != null && this.item.VL_UNT > 0 ? this.item.VL_UNT : 0
      let auxTotal = parseFloat(quantidade * valor).toFixed(2)
      auxTotal = parseFloat(auxTotal)
      
      this.item.VL_TOTAL_BRUTO = auxTotal
      
      if (this.item.VL_DESCONTO_PERC && this.item.VL_DESCONTO_PERC > 0) {
        let auxDesconto = this.item.VL_TOTAL_BRUTO *
                  ( this.item.VL_DESCONTO_PERC / 100)
          this.item.VL_TOTAL_DESCONTO = auxDesconto
          this.item.VL_TOTAL_BRUTO = auxTotal - auxDesconto
      }
    },
    carregarTabelaPreco(){
      if (this.item.COD_PRO && this.item.COD_PRO > 0 ) {
        this.$http.get(`/api/protected/tabelaPrecoProduto/getByProduto/${this.item.COD_PRO}`)
        .then(result => {
          this.tabelaPreco.options = []
          result.data.forEach(tabela => {
            this.tabelaPreco.options.push(
              { value: tabela.ID,
                text: tabela.VL_PRECO && tabela.VL_PRECO > 0 ? tabela.VL_PRECO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) + ' - ' + tabela.DESCRICAO : ''
              }
            )
          })
          this.tabelaPreco.selected = result.data[0].ID
        })
        .catch(() => {
          this.toastCount++
          this.$root.$bvToast.toast(`Não foi Possível encontrar as tabelas de Preços!!`, {
            title: 'Erro',
            autoHideDelay: 10000,
            variant: 'danger',
            appendToast: true
          })
        })
      } else {
        this.tabelaPreco.options = []
      }
    },
    async atualizarDadosDoProduto(produtoId) {
      this.$store.commit('controle/setAguardando', true)
      this.$http.get(`/api/protected/produto/getById/${produtoId}` )
      .then(result => {
        if (result) {
          this.item.TX_NOME_PRODUTO = result.data[0].DESCRICAO
          this.item.TX_NCM = result.data[0].TX_NCM
          this.item.EAN = result.data[0].EAN
          this.item.CEST = result.data[0].CEST
          this.item.ID_UNIDADE_COMERCIAL = result.data[0].ID_UNIDADE_COMERCIAL

          //this.item.COD_CENTRO.asString :=  CDSParametrosCOD_CENTROESTOQUE
          //this.item.ID_CFOP.asString := id_cfop;


          if (result.data[0].PROSERV == 'P') {
            this.item.OP_COMPOE_VALOR_NFE = '1'
          }
          else {
            this.item.OP_COMPOE_VALOR_NFE = '0'
          }
        }
        this.$store.commit('controle/setAguardando', false)
      })
      .catch(err => {
        this.$store.commit('controle/setAguardando', false)
        this.toastCount++
        this.$root.$bvToast.toast(`Não foi Possível atualizar os dados do Produto!! \n` + err, {
          title: 'Erro',
          autoHideDelay: 10000,
          variant: 'danger',
          appendToast: true
        })
      })
    },
    handleKeydown(event) {
      const key = event.key.toLowerCase()
      const modalAberto = this.$refs.modalItem?.isShow === true

      if (key === "insert" && !modalAberto) {
        this.$refs.btAdicionarItem?.click()
      } else if (key === "f9" && !modalAberto) {
        this.tabIndex = 0
      } else if (key === "f10" && !modalAberto) {
        this.tabIndex = 1
      } else if (event.altKey) {
        switch (key) {
          case "1": this.focusTabProduto(); break
          case "2": this.focusTabPesagem(); break
          case "3": break
          case "4": break
          case "5": break
          case "6": break
          case "g":
          case "c":
            if (modalAberto) {
              this.controles.itemAlteracao ? this.editItem() : this.postItem()
            }
            break
          case "v":
            if (!modalAberto) {
              this.voltar()
            }
            break
        }
      } else if (key === "escape" && modalAberto) {
        this.$refs.modalItem?.hide()
      }
    },
    adicionarDiasInicioPagamento(dias) {
      if (!this.venda.DT_PEDIDO) {
        // Garante data de hoje com hora 00:00 no fuso correto
        const hoje = new Date()
        hoje.setHours(0, 0, 0, 0)
        this.venda.DT_PEDIDO = hoje.toISOString().slice(0, 10) // "YYYY-MM-DD"
      }

      const baseDate = new Date(this.venda.DT_PEDIDO + 'T00:00:00')
      const novaData = new Date(baseDate)
      novaData.setDate(novaData.getDate() + dias)

      this.venda.DT_INICIAR_PAGAMENTO = novaData.toISOString().slice(0, 10)
    },

    resetarCliente() {
      this.cliente = {
        CODIGO: null,
        NOME: null,
        RAZAOSOCIAL: null,
        ID_UF: null,
        FIZ_JUR: null,
        ISENTO_ICMS: null,
        COD_VEND: null,
        LIMITE_CREDITO: 0.00,
        NOTAS_EM_ABERTO: 0,
        PRAZO: null,
        TIPO_CLI: null,
        GRUPO_ARECEBER_ID: null
      }

      this.venda.OP_FORMA_PAGTO = 'V'
      this.venda.NR_PARCELAS = '1'
      this.venda.PAG1 = '0'
      this.venda.DT_INICIAR_PAGAMENTO = null

      this.controles.situacaoCliente = 'Cliente:'
      this.controles.clienteBloqueado = false
    },
    getDataBaseParcelamento() {
      return this.venda.DT_PREVISAO_ENTREGA || null
    },
    calcularDataPorDias(dataBase, quantidadeDias) {
      if (!dataBase && dataBase !== 0) return null

      const dias = parseInt(quantidadeDias, 10)
      if (isNaN(dias)) return null

      return moment(dataBase).add(dias, 'days').format('YYYY-MM-DD')
    },
    aplicarParametrosFormaPagamento(formaPagamento, parametros = {}) {
      const forma = formaPagamento || 'V'
      const dataBase = parametros.dataBase || this.getDataBaseParcelamento()

      this.venda.OP_FORMA_PAGTO = forma

      if (forma === 'V') {
        this.diasIniciarPagamento = 0
        this.venda.NR_PARCELAS = 1
        this.venda.PAG1 = 0
        this.venda.DT_INICIAR_PAGAMENTO = dataBase
        return
      }

      const diasInicio = parametros.diasIniciarPagamento != null ? parseInt(parametros.diasIniciarPagamento) : null
      const numeroParcelas = parametros.numeroParcelas != null ? parseInt(parametros.numeroParcelas) : null
      const diasEntreParcelas = parametros.diasEntreParcelas != null ? parseInt(parametros.diasEntreParcelas) : null

      this.diasIniciarPagamento = diasInicio
      this.venda.NR_PARCELAS = numeroParcelas
      this.venda.PAG1 = numeroParcelas === 1 ? 0 : diasEntreParcelas

      if (!dataBase || diasInicio == null) {
        this.venda.DT_INICIAR_PAGAMENTO = null
        return
      }

      this.venda.DT_INICIAR_PAGAMENTO = this.calcularDataPorDias(dataBase, diasInicio)
    },
    async atualizarCliente() {
      try {
        const response = await this.$http.get(`/api/protected/clientes/getDetalhesParaVenda/${this.venda.COD_CLI}`)
        const cliente = response.data[0]

        if (!cliente) {
          throw new Error('Cliente não encontrado')
        }

        this.cliente = cliente
        this.cliente.ISENTO_ICMS = this.cliente.ISENTO_ICMS.trim()

        // Situação financeira
        if (cliente.OP_SITUACAO_FINANCEIRO === '1') {
          this.controles.situacaoCliente = 'Cliente: BLOQUEADO'
          this.controles.clienteBloqueado = true
          this.$root.$bvToast.toast(`Cliente Bloqueado!!!`, {
            title: 'Aviso',
            autoHideDelay: 4000,
            variant: 'danger',
            appendToast: true
          })
        } else {
          this.controles.situacaoCliente = 'Cliente: LIBERADO'
          this.controles.clienteBloqueado = false
        }

        // deve-se tratar this.diasIniciarPagamento aqui antes e depois para evitar que ele fique em branco
        this.diasIniciarPagamento = cliente.DIAS_INICIAR_PAGAMENTO != null ? parseInt(cliente.DIAS_INICIAR_PAGAMENTO) : 0

         if (this.controles.montagemTelaConcluida == true) {
          // Resetar a forma de pagamento
          this.venda.OP_FORMA_PAGTO = null
          await this.$nextTick()

          this.aplicarParametrosFormaPagamento(cliente.FORMA_PAGAMENTO, {
            dataBase: this.getDataBaseParcelamento(),
            diasIniciarPagamento: cliente.DIAS_INICIAR_PAGAMENTO,
            numeroParcelas: cliente.PRAZO,
            diasEntreParcelas: cliente.DIAS_ENTRE_PARCELAS
          })

          // Setar vendedor preferencial do cliente
          // Regra: Em modo de edição, só seta se o cliente for alterado (montagemTelaConcluida = true)
          // Em modo de nova venda, sempre seta quando alterar o cliente
          if (cliente.COD_VEND) {
            this.venda.COD_VENDEDOR = cliente.COD_VEND
          }
        
        } else {
          // Montagem da tela ainda não concluída
          // Em modo de nova venda (vendaEmAlteracao = false), setar o vendedor mesmo na carga inicial
          if (!this.controles.vendaEmAlteracao && cliente.COD_VEND) {
            this.venda.COD_VENDEDOR = cliente.COD_VEND
          }
        }

        

        return true

      } catch (error) {
        console.error('Erro ao atualizar cliente:', error)
        return false
      }
    },
    trocarClienteOuTipoMovimentacao() {

    },
    atualizarDiasPrazo(novaData) {
      if (!this.getDataBaseParcelamento() || !novaData) return
      const dataBase = moment(this.getDataBaseParcelamento())
      const dataInicio = moment(novaData)

      const diff = dataInicio.diff(dataBase, 'days')
      this.diasIniciarPagamento = diff
    },
  },  
  async created () {
    try {
      this.controles.montagemTelaConcluida = false
      try {
        this.$store.commit('controle/setAguardando', true)
        let id = this.$route.params.id
        
        this.parametros =  await this.carregarParametros()
        
        if (!this.parametros) {
          throw new Error(`Os parametros do Sistema não foram carregados!!`)
        }

        if (this.parametros.OP_VENDA_PRECO_POR_TABELA === 'T' ) {
          this.precoTabelado = true
        } else {
          this.precoTabelado = false
        }
        

        try {
          await this.carregarListaEstoque()
        } catch (err) {
          throw new Error(err.message || err)
        }

        
        this.gerarComboParcelas()
        this.gerarDias()

        await this.getTipoMovimentacoes()
        if (!this.tipoMovimentacoes.items || this.tipoMovimentacoes.items.length === 0) {
            throw new Error(`O tipo de movimentação não esta parametrizado no sistema!!`)
        }

        
        //VENDA EM ALTERACAO
        if ( id ) {
          try {
            // Faz o recalculo dos dados, o endpoint identifica se pode ou nao recalcular
            // Se ele der um erro é porque realmente foi uma excecao
            // Do contrario ele da um retorno normalmente
            const recalculo = await this.recalcular( id )

            if ((recalculo?.result === false) && recalculo?.msg) {
              Tools.exibirMensagem(this.$store, 'Aviso', 'warning', recalculo.msg)
            }
          } catch (err) {
            // Falha no recalculo 
            console.log('recalcular')
            console.log(err.message || err)
            throw (err)
          }

          let vendaResponse
          try {
            vendaResponse = await this.$http.get(`/api/protected/venda/getById/${id}`)
          } catch(err) {
            console.log(err)
            throw new Error('A Venda/Prefatura não foi localizada!')
          }
          this.venda = vendaResponse?.data?.[0]?? null
          if (!this.venda) {
            this.controles.falhaNaAbertura = true // pra deixar tudo fechado
            throw new Error('A Venda/Prefatura não foi localizada!')
          }


          this.ajustarCamposTabelaVendas(this.venda)
          await this.atualizarStatusAcoesVenda()
          
          // Atualizar a descrição do tipo de movimentação após carregar a venda
          if (this.venda.TIPO_MOVIMENTACAO_ID) {
            await this.buscarDescricaoTipoMovimentacao(this.venda.TIPO_MOVIMENTACAO_ID)
          }

          this.vlTotalAntes = this.venda.VL_TOTAL_NFE

          try {
            this.tabelaItens.items = await this.getItens()
          } catch (err) {
            console.log(err)
            throw new Error(`Os produtos da Venda/Prefatura, não foram encontrados!!`)
          }
          try {
            this.tabelaParcelamento.items = await this.getParcelamento()
            // Se for À Vista e o banco não retornou nada (comum em pedidos novos ou vindo da expedição), 
            // gera automaticamente para exibição e correta finalização
            if (this.venda.OP_FORMA_PAGTO === 'V' && (!this.tabelaParcelamento.items || this.tabelaParcelamento.items.length === 0)) {
              this.gerarParcelamento()
            }
          } catch (err) {
            throw new Error(`O parcelamento da Venda/Prefatura, não foi encontrado!!`)
          }
          /*Status do Pedido SITUACAO
          '0 = CANCELADO'
          '1 = FATURADO'
          '2 = EM CADASTRO'
          '3 = AGUARDANDO'
          '4 = ORDEM EXPEDIÇÃO'
          '5 = EMBARCANDO'
          '6 = EMBARCADO'
          */

          // * Regra do flag this.controles.fechada
          // Se OP_PEDIDO = '0' é uma venda feita na tela da prefatura e passa apenas pela SITUACAO 2, 1 e 0  
          // permite alterar apenas quando SITUACAO = 2
          // Se OP_PEDIDO = '1' é uma venda feita na tela do Pedido e passa pelos SITUACAO = 2, 3, 4, 5, 6 e por fim 1, o zero pode ser a qualquer momento
          // permite alterar apenas quando SITUACAO = 6, os demais valores permitem alterar apenas na tela do cadastro do Pedido de Vendas
          // Se OP_PEDIDO = '2' é um tipo de pedido chamado entrega do serviço de abate (Ainda nao implementado)
          // nao permite alterar em nenhum momento
          
          
          //preciso implemntar essa regra
          if (!this.venda.OP_PEDIDO  || this.venda.OP_PEDIDO === '0') {
            if (['2'].includes(this.venda.SITUACAO)) {
              this.controles.fechada = false
            } else {
              this.controles.fechada = true
            }
          } else if (this.venda.OP_PEDIDO === '1') {
            if (['6'].includes(this.venda.SITUACAO)) {
              this.controles.fechada = false
            } else {
              this.controles.fechada = true
            }
          } else if (this.venda.OP_PEDIDO === '2') {
            this.controles.fechada = true
          } else {
            this.controles.fechada = true
          }

          //Controla se o form iniciou em alteracao
          this.controles.vendaEmAlteracao = true

          //Controla se o usuario clicou no botao reabrir
          this.controles.vendaReaberta = false

          if (this.venda.DT_PREVISAO_ENTREGA && this.venda.DT_INICIAR_PAGAMENTO) {
            this.atualizarDiasPrazo(this.venda.DT_INICIAR_PAGAMENTO)
          }
          
          
          
        } 
        // NOVA VENDA
        else { 
          this.controles.vendaEmAlteracao = false
          this.controles.vendaReaberta = false
          this.controles.fechada = false
          
          this.limparVenda()

          this.venda.OBSERVACOES = this.parametros.LINHA1ROMA + '\n' + this.parametros.LINHA2ROMA + '\n' + this.parametros.LINHA3ROMA
          this.venda.TIPO_MOVIMENTACAO_ID = this.parametros.TIPO_MOVIMENTACAO_VENDA_ID
          
          // Atualizar a descrição do tipo de movimentação padrão
          if (this.venda.TIPO_MOVIMENTACAO_ID) {
            await this.buscarDescricaoTipoMovimentacao(this.venda.TIPO_MOVIMENTACAO_ID)
          }
          
          this.venda.SEQUENCIA                 = null
          this.venda.N_VENDA                   = null
          this.venda.DT_SAIDA                  = Tools.getDataAtual(),
          this.venda.DT_PREVISAO_ENTREGA       = this.venda.DT_SAIDA
          this.venda.SITUACAO                  = '2'
          this.venda.PAG2                      = '0'
          this.venda.OP_PEDIDO                 = null
          this.venda.TIPO_VEN                  = '0'
          this.venda.FORMA                     = 'VENDA'
          this.venda.USUARIO                   = window.localStorage.getItem('login')
          this.venda.USUARIO_LANCAMENTO_WEB    = window.localStorage.getItem('login')
          this.venda.NENTREGA                  = '0'
          this.venda.VL_TOTAL_RETORNO_BKP      = 0.00
          this.venda.VL_TOTAL_RETORNO          = 0.00
          this.venda.PESOLIQUIDO               = 0.00
          this.venda.PESOBRUTO                 = 0.00
          this.venda.VL_TOTAL_ANTES_ALTERACAO  = 0.00
          this.venda.VL_BASE_CALC_ICMS         = 0.00
          this.venda.VL_TOTAL_ICMS             = 0.00
          this.venda.VL_BASE_CALC_ST_ICMS      = 0.00
          this.venda.VL_TOTAL_ST_ICMS          = 0.00
          this.venda.VL_TOTAL_IPI              = 0.00
          this.venda.VL_TOTAL_PIS              = 0.00
          this.venda.VL_TOTAL_COFINS           = 0.00
          this.venda.VL_TOTAL_DESCONTO         = 0.00
          this.venda.VL_TOTAL_SEGURO           = 0.00
          this.venda.VL_TOTAL_OUTRAS_DESP      = 0.00
          this.venda.VL_TOTAL_FRETE            = 0.00
          this.venda.NR_PESO_BRUTO             = 0.00
          this.venda.VL_TOTAL_PRODUTOS         = 0.00
          this.venda.NR_PESO_LIQUIDO           = 0.00
          this.venda.VL_TOTAL_NFE              = 0.00

          
          
        }

      } catch (err) {
        console.log(err)
        this.$store.commit('controle/setAguardando', false)
        await Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        //this.$router.push(`/movimentos/vendas/listagem`)
        this.controles.falhaNaAbertura = true // pra deixar tudo fechado
        return
      }
    } finally {
      this.controles.montagemTelaConcluida = true
      
      // Pequeno delay para garantir que o Bootstrap-vue processe o encerramento do modal de carregamento
      setTimeout(() => {
        this.$store.commit('controle/setAguardando', false)
        
        // Failsafe: Remove classes de bloqueio de scroll que podem ter ficado residuais
        if (typeof document !== 'undefined' && document.body) {
          document.body.classList.remove('modal-open')
          document.body.style.overflow = ''
        }

      }, 500)

      
    }
  },
  async mounted (){
    // Failsafe adicional para garantir que o scroll esteja liberado ao montar o componente
    if (typeof document !== 'undefined' && document.body) {
      document.body.classList.remove('modal-open')
      document.body.style.overflow = ''
    }

    let id = this.$route.params.id
    if ( id == null  ) {
      this.focarCliente()
    }

    // Validar permissão para alterar data da venda
    await this.validarPermissaoAlterarDataVenda()
    
    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown)
    }, 200)

    
  },
  beforeDestroy() {
    // Remove o evento de keydown ao destruir o componente
    document.removeEventListener("keydown", this.handleKeydown)
  },

  watch: {
    'venda.TIPO_MOVIMENTACAO_ID'(newVal) {
      // Só atualiza se a montagem da tela já foi concluída
      // Para evitar execução prematura durante o created
      if (this.controles.montagemTelaConcluida && newVal) {
        this.buscarDescricaoTipoMovimentacao(newVal)
      } else if (!newVal) {
        this.tipoMovimentacaoDescricao = ''
      }
    },
    'item.COD_PRO': async function () {
      if (this.item.COD_PRO) {
        //ITEM EM ALTERACAO
        if (this.controles.itemAlteracao == true) {
          //so faz a regra da habilitação dos campos
          this.regraOP_ICMS_SITUACAO_TRIBUTARIA ()
          
        }  
        //CADASTRANDO NOVO ITEM
        else {
          const itemDuplicado = await this.verificarItemDuplicado(this.venda.SEQUENCIA, this.item.COD_PRO)
          if (itemDuplicado) {
            this.$root.$bvToast.toast('Esse produto já foi lançado no Pedido\n Informe outro!', {
              title: 'Aviso',
              autoHideDelay: 100,
              variant: 'danger',
              appendToast: true
            }) 
            this.item.COD_PRO = null
            return
          }
          // Se for novo - então procura a aliquota correta
          // Esse metodo ja habilita os campos corretamente
          //await this.atualizarAliquotas(true)
          //await this.atualizarDadosDoProduto(this.item.COD_PRO)
          try {
            await this.atualizarProduto(this.venda.COD_CLI, this.item.COD_PRO, this.venda.TIPO_MOVIMENTACAO_ID)
            //this.calculaICMSeIPIGeral()
          } catch (err) {
            this.item.COD_PRO = null
            this.$root.$bvToast.toast(err.message || err, {
              title: 'Aviso',
              autoHideDelay: 100,
              variant: 'danger',
              appendToast: true
            }) 
            return
          }
        }

        this.atualizarEstoqueProduto()
        if (this.precoTabelado === 'T' ) {
          this.carregarTabelaPreco()
        } else {
          this.atualizarPrecoVenda()
        }
        
      } else {
      }
    },
    'item.OP_ICMS_SITUACAO_TRIBUTARIA': function() {
      /*
      if (this.tabIndexItem == 2) {
        this.calculaICMSeIPIGeral()
        this.regraOP_ICMS_SITUACAO_TRIBUTARIA()
        this.limpaEditsSemValorICMSeIPI()
        
      }
        */

    },'item.COD_CENTRO': function() {
      this.atualizarEstoqueProduto()
    },
    'item.VL_ICMS_ALIQUOTA': function(){
      //if (!this.controles.montandoItem) {        this.calculaICMSeIPIGeral()      }
    },
    'item.VL_ICMS_BASE_CALC': function(){
      //if (!this.controles.montandoItem) { this.calculaICMSeIPIGeral()}
    },
    'item.QUANT': function(){
      this.somarTotalItem()
      //if (!this.controles.montandoItem) {this.calculaICMSeIPIGeral()}
    },
    'item.VL_UNT': function(){
      this.somarTotalItem()
      //if (!this.controles.montandoItem) {this.calculaICMSeIPIGeral()}
    },
    'item.VL_DESCONTO': function(){
      this.somarTotalItem()
      //if (!this.controles.montandoItem) {this.calculaICMSeIPIGeral()}
    },
    'venda.COD_CLI': async function (val, oldVal) {
      if (!val) {
        console.log('ressetnado cliente')
        this.resetarCliente()
        return
      }

      const sucesso = await this.atualizarCliente()
      if (sucesso === false) return

      if (!this.controles.montagemTelaConcluida) return

      if ((this.venda.SEQUENCIA) && (this.tabelaItens.items.length) && val !== oldVal) {
        try {
          this.$store.commit('controle/setAguardando', true)
          await this.sincronizarVendaComRecalculo({
            salvarVenda: true,
            atualizarItens: true,
            exibirToastTotalAlterado: true
          })
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
      }

    },
    'venda.TIPO_MOVIMENTACAO_ID': async function (val, oldVal) {
      if (!val) return
      if (val && !oldVal) return

      if (!this.controles.montagemTelaConcluida) return

      if ((this.venda.SEQUENCIA) && (this.tabelaItens.items.length) && val !== oldVal) {
        try {
          this.$store.commit('controle/setAguardando', true)
          await this.sincronizarVendaComRecalculo({
            salvarVenda: true,
            atualizarItens: true,
            exibirToastTotalAlterado: true
          })
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
      }

    },
    'venda.DT_PREVISAO_ENTREGA': async function(novaData, dataAnterior) {
      if (!this.controles.montagemTelaConcluida) return

      // Se a data foi limpa, limpar os campos de pagamento
      if (!novaData || novaData === '') {
        this.diasIniciarPagamento = null
        this.venda.NR_PARCELAS = null
        this.venda.PAG1 = null
        this.venda.DT_INICIAR_PAGAMENTO = null
        this.venda.OP_FORMA_PAGTO = null
        this.tabelaParcelamento.items = []
        return
      }

      // Se a data foi preenchida após ter sido limpa
      if (novaData && (!dataAnterior || dataAnterior === '')) {
        // Se tem cliente selecionado, carregar os parâmetros de pagamento do cliente
        if (this.venda.COD_CLI && this.cliente.CODIGO) {
          await this.$nextTick()
          
          // Resetar forma de pagamento
          this.venda.OP_FORMA_PAGTO = null
          await this.$nextTick()
          
          this.aplicarParametrosFormaPagamento(this.cliente.FORMA_PAGAMENTO, {
            dataBase: novaData,
            diasIniciarPagamento: this.cliente.DIAS_INICIAR_PAGAMENTO,
            numeroParcelas: this.cliente.PRAZO,
            diasEntreParcelas: this.cliente.DIAS_ENTRE_PARCELAS
          })
        } else {
          // Se não tem cliente, ajustar para À Vista
          await this.$nextTick()
          this.aplicarParametrosFormaPagamento('V', { dataBase: novaData })
        }
        this.gerarParcelamento()
        return
      }

      // Se a data foi apenas alterada (não limpa e não preenchida pela primeira vez)
      // Calcular primeira parcela se existe forma de pagamento
      if (novaData && dataAnterior && this.venda.OP_FORMA_PAGTO) {
        if (this.venda.OP_FORMA_PAGTO === 'V') {
          // À Vista: data de início = data da venda
          this.venda.DT_INICIAR_PAGAMENTO = novaData
        } else if (this.venda.OP_FORMA_PAGTO === 'P' && this.diasIniciarPagamento) {
          // A Prazo: calcular baseado nos dias informados
          this.venda.DT_INICIAR_PAGAMENTO = this.calcularDataPorDias(novaData, this.diasIniciarPagamento)
        }
        this.gerarParcelamento()
      }
    },
    diasIniciarPagamento(novosDias) {
      if (!this.controles.montagemTelaConcluida) return
      if (this.controles.atualizandoDias) return
      const dataBase = this.getDataBaseParcelamento()
      if (!dataBase) return
      if (novosDias === null || novosDias === undefined || novosDias === '') {
        this.venda.DT_INICIAR_PAGAMENTO = null
        return
      }

      this.controles.atualizandoData = true

      
      this.venda.DT_INICIAR_PAGAMENTO = this.calcularDataPorDias(dataBase, novosDias)
      

      this.$nextTick(() => {
        this.controles.atualizandoData = false
      })
    },
    'venda.DT_INICIAR_PAGAMENTO'(novaData) {
      if (!this.controles.montagemTelaConcluida) return
      if (this.controles.atualizandoData) return

      this.controles.atualizandoDias = true

      /*
      const dataPedido = moment(this.venda.DT_SAIDA)
      const dataInicio = moment(novaData)

      let diff = dataInicio.diff(dataPedido, 'days')
      console.log(diff)

      if (diff === 30) {
        this.diasIniciarPagamento = 30
      } else {
        this.diasIniciarPagamento = diff
      }
        */
      this.atualizarDiasPrazo(novaData)
      this.gerarParcelamento()

      this.$nextTick(() => {
        this.controles.atualizandoDias = false
      })
    },
    'tabelaPreco.selected': function() {
      if (this.item.COD_PRO && this.item.COD_PRO > 0 && this.tabelaPreco.selected && this.tabelaPreco.selected > 0) {
        this.$http.get(`/api/protected/tabelaPrecoProduto/getPreco/${this.item.COD_PRO}/${this.tabelaPreco.selected}`)
        .then((result) =>{
          this.item.VL_UNT = result.data[0].VL_PRECO
        })
      }
    },
    'venda.NR_PARCELAS': function(val) {
      // Se mudou para 1 parcela no A Prazo, zerar dias entre parcelas
      if (Number(val) === 1 && this.venda.OP_FORMA_PAGTO === 'P' && this.controles.montagemTelaConcluida) {
        this.$nextTick(() => {
          this.venda.PAG1 = 0
        })
      }
      this.gerarParcelamento()
    },
    'venda.OP_FORMA_PAGTO': function(val, oldVal) {
      // Só ajusta automaticamente após a montagem da tela estar concluída
      // para não interferir na carga inicial ou edição de vendas existentes
      if (this.controles.montagemTelaConcluida) {
        this.$nextTick(() => {
          if (val === 'V') {
            // À Vista: setar automaticamente os campos
            this.diasIniciarPagamento = 0
            this.venda.NR_PARCELAS = 1
            this.venda.PAG1 = 0
            // Ajustar a data de início para a data da venda
            this.venda.DT_INICIAR_PAGAMENTO = this.getDataBaseParcelamento()
          } else if (val === 'P' && (oldVal === 'V' || 
                     (Number(this.diasIniciarPagamento) == 0 && Number(this.venda.NR_PARCELAS) == 1))) {
            // A Prazo: se estava À Vista, limpar os valores para o usuário preencher
            this.diasIniciarPagamento = null
            this.venda.NR_PARCELAS = null
            this.venda.PAG1 = null
            this.venda.DT_INICIAR_PAGAMENTO = null
          }
        })
      }
      this.gerarParcelamento()
    },
    'venda.PAG1': function () {
      this.gerarParcelamento()
    },
    'venda.VL_TOTAL_NFE': function() {
      if (this.venda.OP_FORMA_PAGTO === 'V') {
        this.gerarParcelamento()
      }
    },
    'venda.VL_TOTAL_DESCONTO': function() {
      if (!this.controles.fechada) {
        this.recalcularTotalVenda()
      }
    },
    'venda.VL_TOTAL_FRETE': function() {
      if (!this.controles.fechada) {
        this.recalcularTotalVenda()
      }
    },
    'venda.VL_TOTAL_SEGURO': function() {
      if (!this.controles.fechada) {
        this.recalcularTotalVenda()
      }
    }
  }
  
}

</script>
<style scoped>

.header-icon-wrapper-modal {
  width: 45px;
  height: 45px;
  background: rgba(255, 255, 255, 0.15);  /* <- isso é o que “embrulha” o ícone */
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;

  /* se quiser manter sombra, ok, mas o Caixa não usa */
  box-shadow: none;
}

.bg-white-100 {
  background: rgba(255, 255, 255, 0.1);
}

.border-white-20 {
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.stat-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 15px rgba(0,0,0,0.1) !important;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.rounded-pill-left {
  border-top-left-radius: 50rem !important;
  border-bottom-left-radius: 50rem !important;
}

.rounded-pill-right {
  border-top-right-radius: 50rem !important;
  border-bottom-right-radius: 50rem !important;
}

.rounded-pill-20 {
  border-radius: 20px !important;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.letter-spacing-1 {
  letter-spacing: 1px;
}

.opacity-75 {
  opacity: 0.75;
}

/* Table Enhancements */
.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 12px 8px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 10px 8px !important;
  color: #4a5568;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

/* Button Variants */
.btn-soft-primary {
  background-color: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
  border: none;
}
.btn-soft-primary:hover {
  background-color: #20a8d8;
  color: white;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}
.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.border-white-20 {
  border: 1px solid rgba(255,255,255,0.2) !important;
}

/* Utility */
.transition-hover {
  transition: all 0.2s ease-in-out;
}

.bg-soft-warning { background-color: rgba(255, 193, 7, 0.12) !important; }
.bg-soft-success { background-color: rgba(40, 167, 69, 0.12) !important; }
.bg-soft-danger { background-color: rgba(220, 53, 69, 0.12) !important; }
.bg-soft-info { background-color: rgba(23, 162, 184, 0.12) !important; }
.bg-soft-primary { background-color: rgba(32, 76, 219, 0.12) !important; }

.badge-soft-success { background-color: rgba(40, 167, 69, 0.15); color: #28a745; }
.badge-soft-warning { background-color: rgba(255, 193, 7, 0.15); color: #856404; }
.badge-soft-danger { background-color: rgba(220, 53, 69, 0.15); color: #dc3545; }
.badge-soft-info { background-color: rgba(23, 162, 184, 0.15); color: #17a2b8; }
.badge-soft-primary { background-color: rgba(32, 76, 219, 0.15); color: #204cdb; }



.page-shell {
  background-color: #f4f7f6;
  min-height: 100vh;
}

.modal-xl-custom {
  max-width: 95% !important;
}
</style>





// WEBPACK FOOTER //
// src/views/movimentos/vendas/VendaCadastro.vue